import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {};
/** unique or primary key constraints on table "asset_amenities" */
export var AssetAmenitiesConstraint;
(function (AssetAmenitiesConstraint) {
    /** unique or primary key constraint on columns "asset_id", "global_amenity_id" */
    AssetAmenitiesConstraint["AssetAmenitiesPkey"] = "asset_amenities_pkey";
})(AssetAmenitiesConstraint || (AssetAmenitiesConstraint = {}));
/** select columns of table "asset_amenities" */
export var AssetAmenitiesSelectColumn;
(function (AssetAmenitiesSelectColumn) {
    /** column name */
    AssetAmenitiesSelectColumn["AssetId"] = "asset_id";
    /** column name */
    AssetAmenitiesSelectColumn["CreatedAt"] = "created_at";
    /** column name */
    AssetAmenitiesSelectColumn["GlobalAmenityId"] = "global_amenity_id";
    /** column name */
    AssetAmenitiesSelectColumn["UpdatedAt"] = "updated_at";
})(AssetAmenitiesSelectColumn || (AssetAmenitiesSelectColumn = {}));
/** update columns of table "asset_amenities" */
export var AssetAmenitiesUpdateColumn;
(function (AssetAmenitiesUpdateColumn) {
    /** column name */
    AssetAmenitiesUpdateColumn["AssetId"] = "asset_id";
    /** column name */
    AssetAmenitiesUpdateColumn["CreatedAt"] = "created_at";
    /** column name */
    AssetAmenitiesUpdateColumn["GlobalAmenityId"] = "global_amenity_id";
    /** column name */
    AssetAmenitiesUpdateColumn["UpdatedAt"] = "updated_at";
})(AssetAmenitiesUpdateColumn || (AssetAmenitiesUpdateColumn = {}));
/** unique or primary key constraints on table "asset_booking_events" */
export var AssetBookingEventsConstraint;
(function (AssetBookingEventsConstraint) {
    /** unique or primary key constraint on columns "event_time", "asset_booking_id" */
    AssetBookingEventsConstraint["AssetBookingEventsAssetBookingIdEventTimeKey"] = "asset_booking_events_asset_booking_id_event_time_key";
    /** unique or primary key constraint on columns "id" */
    AssetBookingEventsConstraint["AssetBookingEventsPkey"] = "asset_booking_events_pkey";
})(AssetBookingEventsConstraint || (AssetBookingEventsConstraint = {}));
/** select columns of table "asset_booking_events" */
export var AssetBookingEventsSelectColumn;
(function (AssetBookingEventsSelectColumn) {
    /** column name */
    AssetBookingEventsSelectColumn["AssetBookingId"] = "asset_booking_id";
    /** column name */
    AssetBookingEventsSelectColumn["CreatedAt"] = "created_at";
    /** column name */
    AssetBookingEventsSelectColumn["Diff"] = "diff";
    /** column name */
    AssetBookingEventsSelectColumn["EventTime"] = "event_time";
    /** column name */
    AssetBookingEventsSelectColumn["Id"] = "id";
    /** column name */
    AssetBookingEventsSelectColumn["Payload"] = "payload";
    /** column name */
    AssetBookingEventsSelectColumn["UpdatedAt"] = "updated_at";
})(AssetBookingEventsSelectColumn || (AssetBookingEventsSelectColumn = {}));
/** update columns of table "asset_booking_events" */
export var AssetBookingEventsUpdateColumn;
(function (AssetBookingEventsUpdateColumn) {
    /** column name */
    AssetBookingEventsUpdateColumn["AssetBookingId"] = "asset_booking_id";
    /** column name */
    AssetBookingEventsUpdateColumn["CreatedAt"] = "created_at";
    /** column name */
    AssetBookingEventsUpdateColumn["Diff"] = "diff";
    /** column name */
    AssetBookingEventsUpdateColumn["EventTime"] = "event_time";
    /** column name */
    AssetBookingEventsUpdateColumn["Id"] = "id";
    /** column name */
    AssetBookingEventsUpdateColumn["Payload"] = "payload";
    /** column name */
    AssetBookingEventsUpdateColumn["UpdatedAt"] = "updated_at";
})(AssetBookingEventsUpdateColumn || (AssetBookingEventsUpdateColumn = {}));
/** unique or primary key constraints on table "asset_bookings" */
export var AssetBookingsConstraint;
(function (AssetBookingsConstraint) {
    /** unique or primary key constraint on columns "id" */
    AssetBookingsConstraint["AssetBookingsPkey"] = "asset_bookings_pkey";
})(AssetBookingsConstraint || (AssetBookingsConstraint = {}));
/** select columns of table "asset_bookings" */
export var AssetBookingsSelectColumn;
(function (AssetBookingsSelectColumn) {
    /** column name */
    AssetBookingsSelectColumn["AccountType"] = "account_type";
    /** column name */
    AssetBookingsSelectColumn["Approver"] = "approver";
    /** column name */
    AssetBookingsSelectColumn["ApproverList"] = "approver_list";
    /** column name */
    AssetBookingsSelectColumn["AssetId"] = "asset_id";
    /** column name */
    AssetBookingsSelectColumn["BookingFor"] = "booking_for";
    /** column name */
    AssetBookingsSelectColumn["BookingTitle"] = "booking_title";
    /** column name */
    AssetBookingsSelectColumn["CancellationDate"] = "cancellation_date";
    /** column name */
    AssetBookingsSelectColumn["CreatedAt"] = "created_at";
    /** column name */
    AssetBookingsSelectColumn["Credit"] = "credit";
    /** column name */
    AssetBookingsSelectColumn["DateEnd"] = "date_end";
    /** column name */
    AssetBookingsSelectColumn["DateStart"] = "date_start";
    /** column name */
    AssetBookingsSelectColumn["DatetimeEnd"] = "datetime_end";
    /** column name */
    AssetBookingsSelectColumn["DatetimeStart"] = "datetime_start";
    /** column name */
    AssetBookingsSelectColumn["EventId"] = "event_id";
    /** column name */
    AssetBookingsSelectColumn["Id"] = "id";
    /** column name */
    AssetBookingsSelectColumn["ParticipantList"] = "participant_list";
    /** column name */
    AssetBookingsSelectColumn["Reason"] = "reason";
    /** column name */
    AssetBookingsSelectColumn["ReferenceId"] = "reference_id";
    /** column name */
    AssetBookingsSelectColumn["Reminder"] = "reminder";
    /** column name */
    AssetBookingsSelectColumn["Status"] = "status";
    /** column name */
    AssetBookingsSelectColumn["TimeEnd"] = "time_end";
    /** column name */
    AssetBookingsSelectColumn["TimeStart"] = "time_start";
    /** column name */
    AssetBookingsSelectColumn["UpdatedAt"] = "updated_at";
    /** column name */
    AssetBookingsSelectColumn["UpdatedById"] = "updated_by_id";
    /** column name */
    AssetBookingsSelectColumn["UserId"] = "user_id";
})(AssetBookingsSelectColumn || (AssetBookingsSelectColumn = {}));
/** select "asset_bookings_aggregate_bool_exp_bool_and_arguments_columns" columns of table "asset_bookings" */
export var AssetBookingsSelectColumnAssetBookingsAggregateBoolExpBoolAndArgumentsColumns;
(function (AssetBookingsSelectColumnAssetBookingsAggregateBoolExpBoolAndArgumentsColumns) {
    /** column name */
    AssetBookingsSelectColumnAssetBookingsAggregateBoolExpBoolAndArgumentsColumns["Reminder"] = "reminder";
})(AssetBookingsSelectColumnAssetBookingsAggregateBoolExpBoolAndArgumentsColumns || (AssetBookingsSelectColumnAssetBookingsAggregateBoolExpBoolAndArgumentsColumns = {}));
/** select "asset_bookings_aggregate_bool_exp_bool_or_arguments_columns" columns of table "asset_bookings" */
export var AssetBookingsSelectColumnAssetBookingsAggregateBoolExpBoolOrArgumentsColumns;
(function (AssetBookingsSelectColumnAssetBookingsAggregateBoolExpBoolOrArgumentsColumns) {
    /** column name */
    AssetBookingsSelectColumnAssetBookingsAggregateBoolExpBoolOrArgumentsColumns["Reminder"] = "reminder";
})(AssetBookingsSelectColumnAssetBookingsAggregateBoolExpBoolOrArgumentsColumns || (AssetBookingsSelectColumnAssetBookingsAggregateBoolExpBoolOrArgumentsColumns = {}));
/** update columns of table "asset_bookings" */
export var AssetBookingsUpdateColumn;
(function (AssetBookingsUpdateColumn) {
    /** column name */
    AssetBookingsUpdateColumn["AccountType"] = "account_type";
    /** column name */
    AssetBookingsUpdateColumn["Approver"] = "approver";
    /** column name */
    AssetBookingsUpdateColumn["ApproverList"] = "approver_list";
    /** column name */
    AssetBookingsUpdateColumn["AssetId"] = "asset_id";
    /** column name */
    AssetBookingsUpdateColumn["BookingFor"] = "booking_for";
    /** column name */
    AssetBookingsUpdateColumn["BookingTitle"] = "booking_title";
    /** column name */
    AssetBookingsUpdateColumn["CancellationDate"] = "cancellation_date";
    /** column name */
    AssetBookingsUpdateColumn["CreatedAt"] = "created_at";
    /** column name */
    AssetBookingsUpdateColumn["Credit"] = "credit";
    /** column name */
    AssetBookingsUpdateColumn["DateEnd"] = "date_end";
    /** column name */
    AssetBookingsUpdateColumn["DateStart"] = "date_start";
    /** column name */
    AssetBookingsUpdateColumn["EventId"] = "event_id";
    /** column name */
    AssetBookingsUpdateColumn["Id"] = "id";
    /** column name */
    AssetBookingsUpdateColumn["ParticipantList"] = "participant_list";
    /** column name */
    AssetBookingsUpdateColumn["Reason"] = "reason";
    /** column name */
    AssetBookingsUpdateColumn["Reminder"] = "reminder";
    /** column name */
    AssetBookingsUpdateColumn["Status"] = "status";
    /** column name */
    AssetBookingsUpdateColumn["TimeEnd"] = "time_end";
    /** column name */
    AssetBookingsUpdateColumn["TimeStart"] = "time_start";
    /** column name */
    AssetBookingsUpdateColumn["UpdatedAt"] = "updated_at";
    /** column name */
    AssetBookingsUpdateColumn["UpdatedById"] = "updated_by_id";
    /** column name */
    AssetBookingsUpdateColumn["UserId"] = "user_id";
})(AssetBookingsUpdateColumn || (AssetBookingsUpdateColumn = {}));
/** unique or primary key constraints on table "asset_classes" */
export var AssetClassesConstraint;
(function (AssetClassesConstraint) {
    /** unique or primary key constraint on columns "name", "user_group_id" */
    AssetClassesConstraint["AssetClassesNameUserGroupIdKey"] = "asset_classes_name_user_group_id_key";
    /** unique or primary key constraint on columns "id" */
    AssetClassesConstraint["AssetClassesPkey"] = "asset_classes_pkey";
})(AssetClassesConstraint || (AssetClassesConstraint = {}));
/** select columns of table "asset_classes" */
export var AssetClassesSelectColumn;
(function (AssetClassesSelectColumn) {
    /** column name */
    AssetClassesSelectColumn["CreatedAt"] = "created_at";
    /** column name */
    AssetClassesSelectColumn["Description"] = "description";
    /** column name */
    AssetClassesSelectColumn["Enable"] = "enable";
    /** column name */
    AssetClassesSelectColumn["Id"] = "id";
    /** column name */
    AssetClassesSelectColumn["IsGroup"] = "is_group";
    /** column name */
    AssetClassesSelectColumn["Name"] = "name";
    /** column name */
    AssetClassesSelectColumn["RequiresApproval"] = "requires_approval";
    /** column name */
    AssetClassesSelectColumn["UpdatedAt"] = "updated_at";
    /** column name */
    AssetClassesSelectColumn["UserGroupId"] = "user_group_id";
})(AssetClassesSelectColumn || (AssetClassesSelectColumn = {}));
/** select "asset_classes_aggregate_bool_exp_bool_and_arguments_columns" columns of table "asset_classes" */
export var AssetClassesSelectColumnAssetClassesAggregateBoolExpBoolAndArgumentsColumns;
(function (AssetClassesSelectColumnAssetClassesAggregateBoolExpBoolAndArgumentsColumns) {
    /** column name */
    AssetClassesSelectColumnAssetClassesAggregateBoolExpBoolAndArgumentsColumns["Enable"] = "enable";
    /** column name */
    AssetClassesSelectColumnAssetClassesAggregateBoolExpBoolAndArgumentsColumns["IsGroup"] = "is_group";
    /** column name */
    AssetClassesSelectColumnAssetClassesAggregateBoolExpBoolAndArgumentsColumns["RequiresApproval"] = "requires_approval";
})(AssetClassesSelectColumnAssetClassesAggregateBoolExpBoolAndArgumentsColumns || (AssetClassesSelectColumnAssetClassesAggregateBoolExpBoolAndArgumentsColumns = {}));
/** select "asset_classes_aggregate_bool_exp_bool_or_arguments_columns" columns of table "asset_classes" */
export var AssetClassesSelectColumnAssetClassesAggregateBoolExpBoolOrArgumentsColumns;
(function (AssetClassesSelectColumnAssetClassesAggregateBoolExpBoolOrArgumentsColumns) {
    /** column name */
    AssetClassesSelectColumnAssetClassesAggregateBoolExpBoolOrArgumentsColumns["Enable"] = "enable";
    /** column name */
    AssetClassesSelectColumnAssetClassesAggregateBoolExpBoolOrArgumentsColumns["IsGroup"] = "is_group";
    /** column name */
    AssetClassesSelectColumnAssetClassesAggregateBoolExpBoolOrArgumentsColumns["RequiresApproval"] = "requires_approval";
})(AssetClassesSelectColumnAssetClassesAggregateBoolExpBoolOrArgumentsColumns || (AssetClassesSelectColumnAssetClassesAggregateBoolExpBoolOrArgumentsColumns = {}));
/** update columns of table "asset_classes" */
export var AssetClassesUpdateColumn;
(function (AssetClassesUpdateColumn) {
    /** column name */
    AssetClassesUpdateColumn["CreatedAt"] = "created_at";
    /** column name */
    AssetClassesUpdateColumn["Description"] = "description";
    /** column name */
    AssetClassesUpdateColumn["Enable"] = "enable";
    /** column name */
    AssetClassesUpdateColumn["Id"] = "id";
    /** column name */
    AssetClassesUpdateColumn["IsGroup"] = "is_group";
    /** column name */
    AssetClassesUpdateColumn["Name"] = "name";
    /** column name */
    AssetClassesUpdateColumn["RequiresApproval"] = "requires_approval";
    /** column name */
    AssetClassesUpdateColumn["UpdatedAt"] = "updated_at";
    /** column name */
    AssetClassesUpdateColumn["UserGroupId"] = "user_group_id";
})(AssetClassesUpdateColumn || (AssetClassesUpdateColumn = {}));
/** unique or primary key constraints on table "asset_group_media" */
export var AssetGroupMediaConstraint;
(function (AssetGroupMediaConstraint) {
    /** unique or primary key constraint on columns "asset_group_id", "media_id" */
    AssetGroupMediaConstraint["AssetGroupMediaPkey"] = "asset_group_media_pkey";
})(AssetGroupMediaConstraint || (AssetGroupMediaConstraint = {}));
/** select columns of table "asset_group_media" */
export var AssetGroupMediaSelectColumn;
(function (AssetGroupMediaSelectColumn) {
    /** column name */
    AssetGroupMediaSelectColumn["AssetGroupId"] = "asset_group_id";
    /** column name */
    AssetGroupMediaSelectColumn["CreatedAt"] = "created_at";
    /** column name */
    AssetGroupMediaSelectColumn["MediaId"] = "media_id";
    /** column name */
    AssetGroupMediaSelectColumn["UpdatedAt"] = "updated_at";
})(AssetGroupMediaSelectColumn || (AssetGroupMediaSelectColumn = {}));
/** update columns of table "asset_group_media" */
export var AssetGroupMediaUpdateColumn;
(function (AssetGroupMediaUpdateColumn) {
    /** column name */
    AssetGroupMediaUpdateColumn["AssetGroupId"] = "asset_group_id";
    /** column name */
    AssetGroupMediaUpdateColumn["CreatedAt"] = "created_at";
    /** column name */
    AssetGroupMediaUpdateColumn["MediaId"] = "media_id";
    /** column name */
    AssetGroupMediaUpdateColumn["UpdatedAt"] = "updated_at";
})(AssetGroupMediaUpdateColumn || (AssetGroupMediaUpdateColumn = {}));
/** unique or primary key constraints on table "asset_group_operating_hours" */
export var AssetGroupOperatingHoursConstraint;
(function (AssetGroupOperatingHoursConstraint) {
    /** unique or primary key constraint on columns "asset_group_id", "day_of_week" */
    AssetGroupOperatingHoursConstraint["AssetGroupOperatingHoursDayOfWeekAssetGroupIdKey"] = "asset_group_operating_hours_day_of_week_asset_group_id_key";
    /** unique or primary key constraint on columns "id" */
    AssetGroupOperatingHoursConstraint["AssetGroupOperatingHoursPkey"] = "asset_group_operating_hours_pkey";
})(AssetGroupOperatingHoursConstraint || (AssetGroupOperatingHoursConstraint = {}));
/** select columns of table "asset_group_operating_hours" */
export var AssetGroupOperatingHoursSelectColumn;
(function (AssetGroupOperatingHoursSelectColumn) {
    /** column name */
    AssetGroupOperatingHoursSelectColumn["AssetGroupId"] = "asset_group_id";
    /** column name */
    AssetGroupOperatingHoursSelectColumn["CreatedAt"] = "created_at";
    /** column name */
    AssetGroupOperatingHoursSelectColumn["DayOfWeek"] = "day_of_week";
    /** column name */
    AssetGroupOperatingHoursSelectColumn["HourEnd"] = "hour_end";
    /** column name */
    AssetGroupOperatingHoursSelectColumn["HourStart"] = "hour_start";
    /** column name */
    AssetGroupOperatingHoursSelectColumn["Id"] = "id";
    /** column name */
    AssetGroupOperatingHoursSelectColumn["OperatingGroupId"] = "operating_group_id";
    /** column name */
    AssetGroupOperatingHoursSelectColumn["UpdatedAt"] = "updated_at";
})(AssetGroupOperatingHoursSelectColumn || (AssetGroupOperatingHoursSelectColumn = {}));
/** update columns of table "asset_group_operating_hours" */
export var AssetGroupOperatingHoursUpdateColumn;
(function (AssetGroupOperatingHoursUpdateColumn) {
    /** column name */
    AssetGroupOperatingHoursUpdateColumn["AssetGroupId"] = "asset_group_id";
    /** column name */
    AssetGroupOperatingHoursUpdateColumn["CreatedAt"] = "created_at";
    /** column name */
    AssetGroupOperatingHoursUpdateColumn["DayOfWeek"] = "day_of_week";
    /** column name */
    AssetGroupOperatingHoursUpdateColumn["HourEnd"] = "hour_end";
    /** column name */
    AssetGroupOperatingHoursUpdateColumn["HourStart"] = "hour_start";
    /** column name */
    AssetGroupOperatingHoursUpdateColumn["Id"] = "id";
    /** column name */
    AssetGroupOperatingHoursUpdateColumn["OperatingGroupId"] = "operating_group_id";
    /** column name */
    AssetGroupOperatingHoursUpdateColumn["UpdatedAt"] = "updated_at";
})(AssetGroupOperatingHoursUpdateColumn || (AssetGroupOperatingHoursUpdateColumn = {}));
/** unique or primary key constraints on table "asset_groups" */
export var AssetGroupsConstraint;
(function (AssetGroupsConstraint) {
    /** unique or primary key constraint on columns "id" */
    AssetGroupsConstraint["AssetGroupsPkey"] = "asset_groups_pkey";
})(AssetGroupsConstraint || (AssetGroupsConstraint = {}));
/** select columns of table "asset_groups" */
export var AssetGroupsSelectColumn;
(function (AssetGroupsSelectColumn) {
    /** column name */
    AssetGroupsSelectColumn["Active"] = "active";
    /** column name */
    AssetGroupsSelectColumn["AssetClassId"] = "asset_class_id";
    /** column name */
    AssetGroupsSelectColumn["CreatedAt"] = "created_at";
    /** column name */
    AssetGroupsSelectColumn["Description"] = "description";
    /** column name */
    AssetGroupsSelectColumn["DisplayName"] = "display_name";
    /** column name */
    AssetGroupsSelectColumn["FloorplanImageUrl"] = "floorplan_image_url";
    /** column name */
    AssetGroupsSelectColumn["Id"] = "id";
    /** column name */
    AssetGroupsSelectColumn["Note"] = "note";
    /** column name */
    AssetGroupsSelectColumn["OptionalName"] = "optional_name";
    /** column name */
    AssetGroupsSelectColumn["ParentId"] = "parent_id";
    /** column name */
    AssetGroupsSelectColumn["ThumbnailImageUrl"] = "thumbnail_image_url";
    /** column name */
    AssetGroupsSelectColumn["UpdatedAt"] = "updated_at";
})(AssetGroupsSelectColumn || (AssetGroupsSelectColumn = {}));
/** select "asset_groups_aggregate_bool_exp_bool_and_arguments_columns" columns of table "asset_groups" */
export var AssetGroupsSelectColumnAssetGroupsAggregateBoolExpBoolAndArgumentsColumns;
(function (AssetGroupsSelectColumnAssetGroupsAggregateBoolExpBoolAndArgumentsColumns) {
    /** column name */
    AssetGroupsSelectColumnAssetGroupsAggregateBoolExpBoolAndArgumentsColumns["Active"] = "active";
})(AssetGroupsSelectColumnAssetGroupsAggregateBoolExpBoolAndArgumentsColumns || (AssetGroupsSelectColumnAssetGroupsAggregateBoolExpBoolAndArgumentsColumns = {}));
/** select "asset_groups_aggregate_bool_exp_bool_or_arguments_columns" columns of table "asset_groups" */
export var AssetGroupsSelectColumnAssetGroupsAggregateBoolExpBoolOrArgumentsColumns;
(function (AssetGroupsSelectColumnAssetGroupsAggregateBoolExpBoolOrArgumentsColumns) {
    /** column name */
    AssetGroupsSelectColumnAssetGroupsAggregateBoolExpBoolOrArgumentsColumns["Active"] = "active";
})(AssetGroupsSelectColumnAssetGroupsAggregateBoolExpBoolOrArgumentsColumns || (AssetGroupsSelectColumnAssetGroupsAggregateBoolExpBoolOrArgumentsColumns = {}));
/** update columns of table "asset_groups" */
export var AssetGroupsUpdateColumn;
(function (AssetGroupsUpdateColumn) {
    /** column name */
    AssetGroupsUpdateColumn["Active"] = "active";
    /** column name */
    AssetGroupsUpdateColumn["AssetClassId"] = "asset_class_id";
    /** column name */
    AssetGroupsUpdateColumn["CreatedAt"] = "created_at";
    /** column name */
    AssetGroupsUpdateColumn["Description"] = "description";
    /** column name */
    AssetGroupsUpdateColumn["DisplayName"] = "display_name";
    /** column name */
    AssetGroupsUpdateColumn["FloorplanImageUrl"] = "floorplan_image_url";
    /** column name */
    AssetGroupsUpdateColumn["Id"] = "id";
    /** column name */
    AssetGroupsUpdateColumn["Note"] = "note";
    /** column name */
    AssetGroupsUpdateColumn["OptionalName"] = "optional_name";
    /** column name */
    AssetGroupsUpdateColumn["ParentId"] = "parent_id";
    /** column name */
    AssetGroupsUpdateColumn["ThumbnailImageUrl"] = "thumbnail_image_url";
    /** column name */
    AssetGroupsUpdateColumn["UpdatedAt"] = "updated_at";
})(AssetGroupsUpdateColumn || (AssetGroupsUpdateColumn = {}));
/** unique or primary key constraints on table "asset_media" */
export var AssetMediaConstraint;
(function (AssetMediaConstraint) {
    /** unique or primary key constraint on columns "asset_id", "media_id" */
    AssetMediaConstraint["AssetMediaPkey"] = "asset_media_pkey";
})(AssetMediaConstraint || (AssetMediaConstraint = {}));
/** select columns of table "asset_media" */
export var AssetMediaSelectColumn;
(function (AssetMediaSelectColumn) {
    /** column name */
    AssetMediaSelectColumn["AssetId"] = "asset_id";
    /** column name */
    AssetMediaSelectColumn["CreatedAt"] = "created_at";
    /** column name */
    AssetMediaSelectColumn["MediaId"] = "media_id";
    /** column name */
    AssetMediaSelectColumn["UpdatedAt"] = "updated_at";
})(AssetMediaSelectColumn || (AssetMediaSelectColumn = {}));
/** update columns of table "asset_media" */
export var AssetMediaUpdateColumn;
(function (AssetMediaUpdateColumn) {
    /** column name */
    AssetMediaUpdateColumn["AssetId"] = "asset_id";
    /** column name */
    AssetMediaUpdateColumn["CreatedAt"] = "created_at";
    /** column name */
    AssetMediaUpdateColumn["MediaId"] = "media_id";
    /** column name */
    AssetMediaUpdateColumn["UpdatedAt"] = "updated_at";
})(AssetMediaUpdateColumn || (AssetMediaUpdateColumn = {}));
/** unique or primary key constraints on table "asset_operating_hours" */
export var AssetOperatingHoursConstraint;
(function (AssetOperatingHoursConstraint) {
    /** unique or primary key constraint on columns "asset_id", "day_of_week" */
    AssetOperatingHoursConstraint["AssetOperatingHoursDayOfWeekAssetIdKey"] = "asset_operating_hours_day_of_week_asset_id_key";
    /** unique or primary key constraint on columns "id" */
    AssetOperatingHoursConstraint["AssetOperatingHoursPkey"] = "asset_operating_hours_pkey";
})(AssetOperatingHoursConstraint || (AssetOperatingHoursConstraint = {}));
/** select columns of table "asset_operating_hours" */
export var AssetOperatingHoursSelectColumn;
(function (AssetOperatingHoursSelectColumn) {
    /** column name */
    AssetOperatingHoursSelectColumn["AssetId"] = "asset_id";
    /** column name */
    AssetOperatingHoursSelectColumn["CreatedAt"] = "created_at";
    /** column name */
    AssetOperatingHoursSelectColumn["DayOfWeek"] = "day_of_week";
    /** column name */
    AssetOperatingHoursSelectColumn["HourEnd"] = "hour_end";
    /** column name */
    AssetOperatingHoursSelectColumn["HourStart"] = "hour_start";
    /** column name */
    AssetOperatingHoursSelectColumn["Id"] = "id";
    /** column name */
    AssetOperatingHoursSelectColumn["OperatingGroupId"] = "operating_group_id";
    /** column name */
    AssetOperatingHoursSelectColumn["UpdatedAt"] = "updated_at";
})(AssetOperatingHoursSelectColumn || (AssetOperatingHoursSelectColumn = {}));
/** update columns of table "asset_operating_hours" */
export var AssetOperatingHoursUpdateColumn;
(function (AssetOperatingHoursUpdateColumn) {
    /** column name */
    AssetOperatingHoursUpdateColumn["AssetId"] = "asset_id";
    /** column name */
    AssetOperatingHoursUpdateColumn["CreatedAt"] = "created_at";
    /** column name */
    AssetOperatingHoursUpdateColumn["DayOfWeek"] = "day_of_week";
    /** column name */
    AssetOperatingHoursUpdateColumn["HourEnd"] = "hour_end";
    /** column name */
    AssetOperatingHoursUpdateColumn["HourStart"] = "hour_start";
    /** column name */
    AssetOperatingHoursUpdateColumn["Id"] = "id";
    /** column name */
    AssetOperatingHoursUpdateColumn["OperatingGroupId"] = "operating_group_id";
    /** column name */
    AssetOperatingHoursUpdateColumn["UpdatedAt"] = "updated_at";
})(AssetOperatingHoursUpdateColumn || (AssetOperatingHoursUpdateColumn = {}));
/** unique or primary key constraints on table "asset_unavailabilities" */
export var AssetUnavailabilitiesConstraint;
(function (AssetUnavailabilitiesConstraint) {
    /** unique or primary key constraint on columns "id" */
    AssetUnavailabilitiesConstraint["AssetUnavailabilitiesPkey"] = "asset_unavailabilities_pkey";
})(AssetUnavailabilitiesConstraint || (AssetUnavailabilitiesConstraint = {}));
/** select columns of table "asset_unavailabilities" */
export var AssetUnavailabilitiesSelectColumn;
(function (AssetUnavailabilitiesSelectColumn) {
    /** column name */
    AssetUnavailabilitiesSelectColumn["AssetId"] = "asset_id";
    /** column name */
    AssetUnavailabilitiesSelectColumn["CreatedAt"] = "created_at";
    /** column name */
    AssetUnavailabilitiesSelectColumn["DateEnd"] = "date_end";
    /** column name */
    AssetUnavailabilitiesSelectColumn["DateStart"] = "date_start";
    /** column name */
    AssetUnavailabilitiesSelectColumn["DeletedAt"] = "deleted_at";
    /** column name */
    AssetUnavailabilitiesSelectColumn["Id"] = "id";
    /** column name */
    AssetUnavailabilitiesSelectColumn["Reason"] = "reason";
    /** column name */
    AssetUnavailabilitiesSelectColumn["Status"] = "status";
    /** column name */
    AssetUnavailabilitiesSelectColumn["UpdatedAt"] = "updated_at";
})(AssetUnavailabilitiesSelectColumn || (AssetUnavailabilitiesSelectColumn = {}));
/** update columns of table "asset_unavailabilities" */
export var AssetUnavailabilitiesUpdateColumn;
(function (AssetUnavailabilitiesUpdateColumn) {
    /** column name */
    AssetUnavailabilitiesUpdateColumn["AssetId"] = "asset_id";
    /** column name */
    AssetUnavailabilitiesUpdateColumn["CreatedAt"] = "created_at";
    /** column name */
    AssetUnavailabilitiesUpdateColumn["DateEnd"] = "date_end";
    /** column name */
    AssetUnavailabilitiesUpdateColumn["DateStart"] = "date_start";
    /** column name */
    AssetUnavailabilitiesUpdateColumn["DeletedAt"] = "deleted_at";
    /** column name */
    AssetUnavailabilitiesUpdateColumn["Id"] = "id";
    /** column name */
    AssetUnavailabilitiesUpdateColumn["Reason"] = "reason";
    /** column name */
    AssetUnavailabilitiesUpdateColumn["Status"] = "status";
    /** column name */
    AssetUnavailabilitiesUpdateColumn["UpdatedAt"] = "updated_at";
})(AssetUnavailabilitiesUpdateColumn || (AssetUnavailabilitiesUpdateColumn = {}));
/** unique or primary key constraints on table "assets" */
export var AssetsConstraint;
(function (AssetsConstraint) {
    /** unique or primary key constraint on columns "id" */
    AssetsConstraint["AssetsPkey"] = "assets_pkey";
})(AssetsConstraint || (AssetsConstraint = {}));
/** select columns of table "assets" */
export var AssetsSelectColumn;
(function (AssetsSelectColumn) {
    /** column name */
    AssetsSelectColumn["Active"] = "active";
    /** column name */
    AssetsSelectColumn["AllowChildAccess"] = "allow_child_access";
    /** column name */
    AssetsSelectColumn["AssetClassId"] = "asset_class_id";
    /** column name */
    AssetsSelectColumn["AssetGroupId"] = "asset_group_id";
    /** column name */
    AssetsSelectColumn["ComputedAvailableAt"] = "computed_available_at";
    /** column name */
    AssetsSelectColumn["CreatedAt"] = "created_at";
    /** column name */
    AssetsSelectColumn["CreditCost"] = "credit_cost";
    /** column name */
    AssetsSelectColumn["Description"] = "description";
    /** column name */
    AssetsSelectColumn["DisplayName"] = "display_name";
    /** column name */
    AssetsSelectColumn["Id"] = "id";
    /** column name */
    AssetsSelectColumn["MaximumCapacity"] = "maximum_capacity";
    /** column name */
    AssetsSelectColumn["Note"] = "note";
    /** column name */
    AssetsSelectColumn["OptionalName"] = "optional_name";
    /** column name */
    AssetsSelectColumn["SmallestBookingTime"] = "smallest_booking_time";
    /** column name */
    AssetsSelectColumn["Status"] = "status";
    /** column name */
    AssetsSelectColumn["ThumbnailImageUrl"] = "thumbnail_image_url";
    /** column name */
    AssetsSelectColumn["UpdatedAt"] = "updated_at";
})(AssetsSelectColumn || (AssetsSelectColumn = {}));
/** select "assets_aggregate_bool_exp_bool_and_arguments_columns" columns of table "assets" */
export var AssetsSelectColumnAssetsAggregateBoolExpBoolAndArgumentsColumns;
(function (AssetsSelectColumnAssetsAggregateBoolExpBoolAndArgumentsColumns) {
    /** column name */
    AssetsSelectColumnAssetsAggregateBoolExpBoolAndArgumentsColumns["Active"] = "active";
    /** column name */
    AssetsSelectColumnAssetsAggregateBoolExpBoolAndArgumentsColumns["AllowChildAccess"] = "allow_child_access";
})(AssetsSelectColumnAssetsAggregateBoolExpBoolAndArgumentsColumns || (AssetsSelectColumnAssetsAggregateBoolExpBoolAndArgumentsColumns = {}));
/** select "assets_aggregate_bool_exp_bool_or_arguments_columns" columns of table "assets" */
export var AssetsSelectColumnAssetsAggregateBoolExpBoolOrArgumentsColumns;
(function (AssetsSelectColumnAssetsAggregateBoolExpBoolOrArgumentsColumns) {
    /** column name */
    AssetsSelectColumnAssetsAggregateBoolExpBoolOrArgumentsColumns["Active"] = "active";
    /** column name */
    AssetsSelectColumnAssetsAggregateBoolExpBoolOrArgumentsColumns["AllowChildAccess"] = "allow_child_access";
})(AssetsSelectColumnAssetsAggregateBoolExpBoolOrArgumentsColumns || (AssetsSelectColumnAssetsAggregateBoolExpBoolOrArgumentsColumns = {}));
/** update columns of table "assets" */
export var AssetsUpdateColumn;
(function (AssetsUpdateColumn) {
    /** column name */
    AssetsUpdateColumn["Active"] = "active";
    /** column name */
    AssetsUpdateColumn["AllowChildAccess"] = "allow_child_access";
    /** column name */
    AssetsUpdateColumn["AssetClassId"] = "asset_class_id";
    /** column name */
    AssetsUpdateColumn["AssetGroupId"] = "asset_group_id";
    /** column name */
    AssetsUpdateColumn["ComputedAvailableAt"] = "computed_available_at";
    /** column name */
    AssetsUpdateColumn["CreatedAt"] = "created_at";
    /** column name */
    AssetsUpdateColumn["CreditCost"] = "credit_cost";
    /** column name */
    AssetsUpdateColumn["Description"] = "description";
    /** column name */
    AssetsUpdateColumn["DisplayName"] = "display_name";
    /** column name */
    AssetsUpdateColumn["Id"] = "id";
    /** column name */
    AssetsUpdateColumn["MaximumCapacity"] = "maximum_capacity";
    /** column name */
    AssetsUpdateColumn["Note"] = "note";
    /** column name */
    AssetsUpdateColumn["OptionalName"] = "optional_name";
    /** column name */
    AssetsUpdateColumn["SmallestBookingTime"] = "smallest_booking_time";
    /** column name */
    AssetsUpdateColumn["Status"] = "status";
    /** column name */
    AssetsUpdateColumn["ThumbnailImageUrl"] = "thumbnail_image_url";
    /** column name */
    AssetsUpdateColumn["UpdatedAt"] = "updated_at";
})(AssetsUpdateColumn || (AssetsUpdateColumn = {}));
/** select columns of table "bookers" */
export var BookersSelectColumn;
(function (BookersSelectColumn) {
    /** column name */
    BookersSelectColumn["AssetBookingId"] = "asset_booking_id";
    /** column name */
    BookersSelectColumn["AvatarUrl"] = "avatar_url";
    /** column name */
    BookersSelectColumn["Email"] = "email";
    /** column name */
    BookersSelectColumn["FirstName"] = "first_name";
    /** column name */
    BookersSelectColumn["Id"] = "id";
    /** column name */
    BookersSelectColumn["LastName"] = "last_name";
    /** column name */
    BookersSelectColumn["Salutation"] = "salutation";
})(BookersSelectColumn || (BookersSelectColumn = {}));
/** unique or primary key constraints on table "consents" */
export var ConsentsConstraint;
(function (ConsentsConstraint) {
    /** unique or primary key constraint on columns "name", "organization_id" */
    ConsentsConstraint["ConsentsNameOrganizationIdKey"] = "consents_name_organization_id_key";
    /** unique or primary key constraint on columns "id" */
    ConsentsConstraint["ConsentsPkey"] = "consents_pkey";
})(ConsentsConstraint || (ConsentsConstraint = {}));
/** select columns of table "consents" */
export var ConsentsSelectColumn;
(function (ConsentsSelectColumn) {
    /** column name */
    ConsentsSelectColumn["CreatedAt"] = "created_at";
    /** column name */
    ConsentsSelectColumn["Id"] = "id";
    /** column name */
    ConsentsSelectColumn["Name"] = "name";
    /** column name */
    ConsentsSelectColumn["OrganizationId"] = "organization_id";
    /** column name */
    ConsentsSelectColumn["UpdatedAt"] = "updated_at";
})(ConsentsSelectColumn || (ConsentsSelectColumn = {}));
/** update columns of table "consents" */
export var ConsentsUpdateColumn;
(function (ConsentsUpdateColumn) {
    /** column name */
    ConsentsUpdateColumn["CreatedAt"] = "created_at";
    /** column name */
    ConsentsUpdateColumn["Id"] = "id";
    /** column name */
    ConsentsUpdateColumn["Name"] = "name";
    /** column name */
    ConsentsUpdateColumn["OrganizationId"] = "organization_id";
    /** column name */
    ConsentsUpdateColumn["UpdatedAt"] = "updated_at";
})(ConsentsUpdateColumn || (ConsentsUpdateColumn = {}));
/** ordering argument of a cursor */
export var CursorOrdering;
(function (CursorOrdering) {
    /** ascending ordering of the cursor */
    CursorOrdering["Asc"] = "ASC";
    /** descending ordering of the cursor */
    CursorOrdering["Desc"] = "DESC";
})(CursorOrdering || (CursorOrdering = {}));
/** unique or primary key constraints on table "enum_asset_booking_statuses" */
export var EnumAssetBookingStatusesConstraint;
(function (EnumAssetBookingStatusesConstraint) {
    /** unique or primary key constraint on columns "value" */
    EnumAssetBookingStatusesConstraint["EnumAssetBookingStatusesPkey"] = "enum_asset_booking_statuses_pkey";
})(EnumAssetBookingStatusesConstraint || (EnumAssetBookingStatusesConstraint = {}));
export var EnumAssetBookingStatusesEnum;
(function (EnumAssetBookingStatusesEnum) {
    /** cancelled */
    EnumAssetBookingStatusesEnum["Cancelled"] = "cancelled";
    /** confirmed */
    EnumAssetBookingStatusesEnum["Confirmed"] = "confirmed";
    /** pending */
    EnumAssetBookingStatusesEnum["Pending"] = "pending";
})(EnumAssetBookingStatusesEnum || (EnumAssetBookingStatusesEnum = {}));
/** select columns of table "enum_asset_booking_statuses" */
export var EnumAssetBookingStatusesSelectColumn;
(function (EnumAssetBookingStatusesSelectColumn) {
    /** column name */
    EnumAssetBookingStatusesSelectColumn["Comment"] = "comment";
    /** column name */
    EnumAssetBookingStatusesSelectColumn["Value"] = "value";
})(EnumAssetBookingStatusesSelectColumn || (EnumAssetBookingStatusesSelectColumn = {}));
/** update columns of table "enum_asset_booking_statuses" */
export var EnumAssetBookingStatusesUpdateColumn;
(function (EnumAssetBookingStatusesUpdateColumn) {
    /** column name */
    EnumAssetBookingStatusesUpdateColumn["Comment"] = "comment";
    /** column name */
    EnumAssetBookingStatusesUpdateColumn["Value"] = "value";
})(EnumAssetBookingStatusesUpdateColumn || (EnumAssetBookingStatusesUpdateColumn = {}));
/** unique or primary key constraints on table "enum_asset_statuses" */
export var EnumAssetStatusesConstraint;
(function (EnumAssetStatusesConstraint) {
    /** unique or primary key constraint on columns "value" */
    EnumAssetStatusesConstraint["EnumAssetStatusesPkey"] = "enum_asset_statuses_pkey";
})(EnumAssetStatusesConstraint || (EnumAssetStatusesConstraint = {}));
export var EnumAssetStatusesEnum;
(function (EnumAssetStatusesEnum) {
    EnumAssetStatusesEnum["Available"] = "available";
    EnumAssetStatusesEnum["OutOfService"] = "out_of_service";
    EnumAssetStatusesEnum["Unavailable"] = "unavailable";
})(EnumAssetStatusesEnum || (EnumAssetStatusesEnum = {}));
/** select columns of table "enum_asset_statuses" */
export var EnumAssetStatusesSelectColumn;
(function (EnumAssetStatusesSelectColumn) {
    /** column name */
    EnumAssetStatusesSelectColumn["Comment"] = "comment";
    /** column name */
    EnumAssetStatusesSelectColumn["Value"] = "value";
})(EnumAssetStatusesSelectColumn || (EnumAssetStatusesSelectColumn = {}));
/** update columns of table "enum_asset_statuses" */
export var EnumAssetStatusesUpdateColumn;
(function (EnumAssetStatusesUpdateColumn) {
    /** column name */
    EnumAssetStatusesUpdateColumn["Comment"] = "comment";
    /** column name */
    EnumAssetStatusesUpdateColumn["Value"] = "value";
})(EnumAssetStatusesUpdateColumn || (EnumAssetStatusesUpdateColumn = {}));
/** unique or primary key constraints on table "enum_invite_statuses" */
export var EnumInviteStatusesConstraint;
(function (EnumInviteStatusesConstraint) {
    /** unique or primary key constraint on columns "value" */
    EnumInviteStatusesConstraint["EnumInviteStatusesPkey"] = "enum_invite_statuses_pkey";
})(EnumInviteStatusesConstraint || (EnumInviteStatusesConstraint = {}));
export var EnumInviteStatusesEnum;
(function (EnumInviteStatusesEnum) {
    EnumInviteStatusesEnum["Accepted"] = "accepted";
    EnumInviteStatusesEnum["Cancelled"] = "cancelled";
    EnumInviteStatusesEnum["Completed"] = "completed";
    EnumInviteStatusesEnum["Failed"] = "failed";
    EnumInviteStatusesEnum["Pending"] = "pending";
})(EnumInviteStatusesEnum || (EnumInviteStatusesEnum = {}));
/** select columns of table "enum_invite_statuses" */
export var EnumInviteStatusesSelectColumn;
(function (EnumInviteStatusesSelectColumn) {
    /** column name */
    EnumInviteStatusesSelectColumn["Value"] = "value";
})(EnumInviteStatusesSelectColumn || (EnumInviteStatusesSelectColumn = {}));
/** update columns of table "enum_invite_statuses" */
export var EnumInviteStatusesUpdateColumn;
(function (EnumInviteStatusesUpdateColumn) {
    /** column name */
    EnumInviteStatusesUpdateColumn["Value"] = "value";
})(EnumInviteStatusesUpdateColumn || (EnumInviteStatusesUpdateColumn = {}));
/** unique or primary key constraints on table "enum_process_types" */
export var EnumProcessTypesConstraint;
(function (EnumProcessTypesConstraint) {
    /** unique or primary key constraint on columns "value" */
    EnumProcessTypesConstraint["EnumProcessTypesPkey"] = "enum_process_types_pkey";
})(EnumProcessTypesConstraint || (EnumProcessTypesConstraint = {}));
export var EnumProcessTypesEnum;
(function (EnumProcessTypesEnum) {
    EnumProcessTypesEnum["External"] = "external";
    EnumProcessTypesEnum["User"] = "user";
    EnumProcessTypesEnum["UserGroup"] = "user_group";
})(EnumProcessTypesEnum || (EnumProcessTypesEnum = {}));
/** select columns of table "enum_process_types" */
export var EnumProcessTypesSelectColumn;
(function (EnumProcessTypesSelectColumn) {
    /** column name */
    EnumProcessTypesSelectColumn["Value"] = "value";
})(EnumProcessTypesSelectColumn || (EnumProcessTypesSelectColumn = {}));
/** update columns of table "enum_process_types" */
export var EnumProcessTypesUpdateColumn;
(function (EnumProcessTypesUpdateColumn) {
    /** column name */
    EnumProcessTypesUpdateColumn["Value"] = "value";
})(EnumProcessTypesUpdateColumn || (EnumProcessTypesUpdateColumn = {}));
/** unique or primary key constraints on table "enum_user_groups_tier" */
export var EnumUserGroupsTierConstraint;
(function (EnumUserGroupsTierConstraint) {
    /** unique or primary key constraint on columns "value" */
    EnumUserGroupsTierConstraint["EnumUserGroupsTierPkey"] = "enum_user_groups_tier_pkey";
})(EnumUserGroupsTierConstraint || (EnumUserGroupsTierConstraint = {}));
export var EnumUserGroupsTierEnum;
(function (EnumUserGroupsTierEnum) {
    EnumUserGroupsTierEnum["ActiveService"] = "active_service";
    EnumUserGroupsTierEnum["SelfService"] = "self_service";
    EnumUserGroupsTierEnum["Standard"] = "standard";
})(EnumUserGroupsTierEnum || (EnumUserGroupsTierEnum = {}));
/** select columns of table "enum_user_groups_tier" */
export var EnumUserGroupsTierSelectColumn;
(function (EnumUserGroupsTierSelectColumn) {
    /** column name */
    EnumUserGroupsTierSelectColumn["Value"] = "value";
})(EnumUserGroupsTierSelectColumn || (EnumUserGroupsTierSelectColumn = {}));
/** update columns of table "enum_user_groups_tier" */
export var EnumUserGroupsTierUpdateColumn;
(function (EnumUserGroupsTierUpdateColumn) {
    /** column name */
    EnumUserGroupsTierUpdateColumn["Value"] = "value";
})(EnumUserGroupsTierUpdateColumn || (EnumUserGroupsTierUpdateColumn = {}));
/** unique or primary key constraints on table "external_process_values" */
export var ExternalProcessValuesConstraint;
(function (ExternalProcessValuesConstraint) {
    /** unique or primary key constraint on columns "user_id", "process_id" */
    ExternalProcessValuesConstraint["ExternalProcessValuesPkey"] = "external_process_values_pkey";
    /** unique or primary key constraint on columns "user_id", "process_id" */
    ExternalProcessValuesConstraint["ExternalProcessValuesProcessIdUserIdKey"] = "external_process_values_process_id_user_id_key";
})(ExternalProcessValuesConstraint || (ExternalProcessValuesConstraint = {}));
/** select columns of table "external_process_values" */
export var ExternalProcessValuesSelectColumn;
(function (ExternalProcessValuesSelectColumn) {
    /** column name */
    ExternalProcessValuesSelectColumn["CreatedAt"] = "created_at";
    /** column name */
    ExternalProcessValuesSelectColumn["ProcessId"] = "process_id";
    /** column name */
    ExternalProcessValuesSelectColumn["ProcessValues"] = "process_values";
    /** column name */
    ExternalProcessValuesSelectColumn["UpdatedAt"] = "updated_at";
    /** column name */
    ExternalProcessValuesSelectColumn["UserId"] = "user_id";
})(ExternalProcessValuesSelectColumn || (ExternalProcessValuesSelectColumn = {}));
/** update columns of table "external_process_values" */
export var ExternalProcessValuesUpdateColumn;
(function (ExternalProcessValuesUpdateColumn) {
    /** column name */
    ExternalProcessValuesUpdateColumn["CreatedAt"] = "created_at";
    /** column name */
    ExternalProcessValuesUpdateColumn["ProcessId"] = "process_id";
    /** column name */
    ExternalProcessValuesUpdateColumn["ProcessValues"] = "process_values";
    /** column name */
    ExternalProcessValuesUpdateColumn["UpdatedAt"] = "updated_at";
    /** column name */
    ExternalProcessValuesUpdateColumn["UserId"] = "user_id";
})(ExternalProcessValuesUpdateColumn || (ExternalProcessValuesUpdateColumn = {}));
/** unique or primary key constraints on table "flattened_asset_groups" */
export var FlattenedAssetGroupsConstraint;
(function (FlattenedAssetGroupsConstraint) {
    /** unique or primary key constraint on columns "child_id", "parent_id" */
    FlattenedAssetGroupsConstraint["FlattenedAssetGroupsPkey"] = "flattened_asset_groups_pkey";
})(FlattenedAssetGroupsConstraint || (FlattenedAssetGroupsConstraint = {}));
/** select columns of table "flattened_asset_groups" */
export var FlattenedAssetGroupsSelectColumn;
(function (FlattenedAssetGroupsSelectColumn) {
    /** column name */
    FlattenedAssetGroupsSelectColumn["ChildId"] = "child_id";
    /** column name */
    FlattenedAssetGroupsSelectColumn["CreatedAt"] = "created_at";
    /** column name */
    FlattenedAssetGroupsSelectColumn["ParentId"] = "parent_id";
    /** column name */
    FlattenedAssetGroupsSelectColumn["UpdatedAt"] = "updated_at";
})(FlattenedAssetGroupsSelectColumn || (FlattenedAssetGroupsSelectColumn = {}));
/** update columns of table "flattened_asset_groups" */
export var FlattenedAssetGroupsUpdateColumn;
(function (FlattenedAssetGroupsUpdateColumn) {
    /** column name */
    FlattenedAssetGroupsUpdateColumn["ChildId"] = "child_id";
    /** column name */
    FlattenedAssetGroupsUpdateColumn["CreatedAt"] = "created_at";
    /** column name */
    FlattenedAssetGroupsUpdateColumn["ParentId"] = "parent_id";
    /** column name */
    FlattenedAssetGroupsUpdateColumn["UpdatedAt"] = "updated_at";
})(FlattenedAssetGroupsUpdateColumn || (FlattenedAssetGroupsUpdateColumn = {}));
/** unique or primary key constraints on table "flattened_user_group_user_permissions" */
export var FlattenedUserGroupUserPermissionsConstraint;
(function (FlattenedUserGroupUserPermissionsConstraint) {
    /** unique or primary key constraint on columns "user_group_id", "user_id", "permission_id" */
    FlattenedUserGroupUserPermissionsConstraint["FlattenedUserGroupPermissionsPkey"] = "flattened_user_group_permissions_pkey";
})(FlattenedUserGroupUserPermissionsConstraint || (FlattenedUserGroupUserPermissionsConstraint = {}));
/** select columns of table "flattened_user_group_user_permissions" */
export var FlattenedUserGroupUserPermissionsSelectColumn;
(function (FlattenedUserGroupUserPermissionsSelectColumn) {
    /** column name */
    FlattenedUserGroupUserPermissionsSelectColumn["CreatedAt"] = "created_at";
    /** column name */
    FlattenedUserGroupUserPermissionsSelectColumn["PermissionId"] = "permission_id";
    /** column name */
    FlattenedUserGroupUserPermissionsSelectColumn["UpdatedAt"] = "updated_at";
    /** column name */
    FlattenedUserGroupUserPermissionsSelectColumn["UserGroupId"] = "user_group_id";
    /** column name */
    FlattenedUserGroupUserPermissionsSelectColumn["UserId"] = "user_id";
})(FlattenedUserGroupUserPermissionsSelectColumn || (FlattenedUserGroupUserPermissionsSelectColumn = {}));
/** update columns of table "flattened_user_group_user_permissions" */
export var FlattenedUserGroupUserPermissionsUpdateColumn;
(function (FlattenedUserGroupUserPermissionsUpdateColumn) {
    /** column name */
    FlattenedUserGroupUserPermissionsUpdateColumn["CreatedAt"] = "created_at";
    /** column name */
    FlattenedUserGroupUserPermissionsUpdateColumn["PermissionId"] = "permission_id";
    /** column name */
    FlattenedUserGroupUserPermissionsUpdateColumn["UpdatedAt"] = "updated_at";
    /** column name */
    FlattenedUserGroupUserPermissionsUpdateColumn["UserGroupId"] = "user_group_id";
    /** column name */
    FlattenedUserGroupUserPermissionsUpdateColumn["UserId"] = "user_id";
})(FlattenedUserGroupUserPermissionsUpdateColumn || (FlattenedUserGroupUserPermissionsUpdateColumn = {}));
/** unique or primary key constraints on table "flattened_user_group_users" */
export var FlattenedUserGroupUsersConstraint;
(function (FlattenedUserGroupUsersConstraint) {
    /** unique or primary key constraint on columns "user_group_id", "user_id", "organization_id" */
    FlattenedUserGroupUsersConstraint["FlattenedUserGroupUsersPkey"] = "flattened_user_group_users_pkey";
})(FlattenedUserGroupUsersConstraint || (FlattenedUserGroupUsersConstraint = {}));
/** select columns of table "flattened_user_group_users" */
export var FlattenedUserGroupUsersSelectColumn;
(function (FlattenedUserGroupUsersSelectColumn) {
    /** column name */
    FlattenedUserGroupUsersSelectColumn["CreatedAt"] = "created_at";
    /** column name */
    FlattenedUserGroupUsersSelectColumn["OrganizationId"] = "organization_id";
    /** column name */
    FlattenedUserGroupUsersSelectColumn["UpdatedAt"] = "updated_at";
    /** column name */
    FlattenedUserGroupUsersSelectColumn["UserGroupId"] = "user_group_id";
    /** column name */
    FlattenedUserGroupUsersSelectColumn["UserId"] = "user_id";
})(FlattenedUserGroupUsersSelectColumn || (FlattenedUserGroupUsersSelectColumn = {}));
/** update columns of table "flattened_user_group_users" */
export var FlattenedUserGroupUsersUpdateColumn;
(function (FlattenedUserGroupUsersUpdateColumn) {
    /** column name */
    FlattenedUserGroupUsersUpdateColumn["CreatedAt"] = "created_at";
    /** column name */
    FlattenedUserGroupUsersUpdateColumn["OrganizationId"] = "organization_id";
    /** column name */
    FlattenedUserGroupUsersUpdateColumn["UpdatedAt"] = "updated_at";
    /** column name */
    FlattenedUserGroupUsersUpdateColumn["UserGroupId"] = "user_group_id";
    /** column name */
    FlattenedUserGroupUsersUpdateColumn["UserId"] = "user_id";
})(FlattenedUserGroupUsersUpdateColumn || (FlattenedUserGroupUsersUpdateColumn = {}));
/** unique or primary key constraints on table "flattened_user_groups" */
export var FlattenedUserGroupsConstraint;
(function (FlattenedUserGroupsConstraint) {
    /** unique or primary key constraint on columns "child_id", "parent_id" */
    FlattenedUserGroupsConstraint["FlattenedUserGroupsPkey"] = "flattened_user_groups_pkey";
})(FlattenedUserGroupsConstraint || (FlattenedUserGroupsConstraint = {}));
/** select columns of table "flattened_user_groups" */
export var FlattenedUserGroupsSelectColumn;
(function (FlattenedUserGroupsSelectColumn) {
    /** column name */
    FlattenedUserGroupsSelectColumn["ChildId"] = "child_id";
    /** column name */
    FlattenedUserGroupsSelectColumn["CreatedAt"] = "created_at";
    /** column name */
    FlattenedUserGroupsSelectColumn["ParentId"] = "parent_id";
    /** column name */
    FlattenedUserGroupsSelectColumn["UpdatedAt"] = "updated_at";
})(FlattenedUserGroupsSelectColumn || (FlattenedUserGroupsSelectColumn = {}));
/** update columns of table "flattened_user_groups" */
export var FlattenedUserGroupsUpdateColumn;
(function (FlattenedUserGroupsUpdateColumn) {
    /** column name */
    FlattenedUserGroupsUpdateColumn["ChildId"] = "child_id";
    /** column name */
    FlattenedUserGroupsUpdateColumn["CreatedAt"] = "created_at";
    /** column name */
    FlattenedUserGroupsUpdateColumn["ParentId"] = "parent_id";
    /** column name */
    FlattenedUserGroupsUpdateColumn["UpdatedAt"] = "updated_at";
})(FlattenedUserGroupsUpdateColumn || (FlattenedUserGroupsUpdateColumn = {}));
/** select columns of table "friday_operating_hours" */
export var FridayOperatingHoursSelectColumn;
(function (FridayOperatingHoursSelectColumn) {
    /** column name */
    FridayOperatingHoursSelectColumn["DayOfWeek"] = "day_of_week";
    /** column name */
    FridayOperatingHoursSelectColumn["HourEnd"] = "hour_end";
    /** column name */
    FridayOperatingHoursSelectColumn["HourStart"] = "hour_start";
    /** column name */
    FridayOperatingHoursSelectColumn["ModelId"] = "model_id";
})(FridayOperatingHoursSelectColumn || (FridayOperatingHoursSelectColumn = {}));
/** unique or primary key constraints on table "invites" */
export var InvitesConstraint;
(function (InvitesConstraint) {
    /** unique or primary key constraint on columns "id" */
    InvitesConstraint["InvitesPkey"] = "invites_pkey";
})(InvitesConstraint || (InvitesConstraint = {}));
/** select columns of table "invites" */
export var InvitesSelectColumn;
(function (InvitesSelectColumn) {
    /** column name */
    InvitesSelectColumn["Code"] = "code";
    /** column name */
    InvitesSelectColumn["CreatedAt"] = "created_at";
    /** column name */
    InvitesSelectColumn["Error"] = "error";
    /** column name */
    InvitesSelectColumn["ExpiresAt"] = "expires_at";
    /** column name */
    InvitesSelectColumn["GlobalRoleId"] = "global_role_id";
    /** column name */
    InvitesSelectColumn["Id"] = "id";
    /** column name */
    InvitesSelectColumn["ReceiverEmail"] = "receiver_email";
    /** column name */
    InvitesSelectColumn["SenderId"] = "sender_id";
    /** column name */
    InvitesSelectColumn["Status"] = "status";
    /** column name */
    InvitesSelectColumn["UpdatedAt"] = "updated_at";
    /** column name */
    InvitesSelectColumn["UserGroupId"] = "user_group_id";
    /** column name */
    InvitesSelectColumn["UserGroupRoleId"] = "user_group_role_id";
})(InvitesSelectColumn || (InvitesSelectColumn = {}));
/** update columns of table "invites" */
export var InvitesUpdateColumn;
(function (InvitesUpdateColumn) {
    /** column name */
    InvitesUpdateColumn["Code"] = "code";
    /** column name */
    InvitesUpdateColumn["CreatedAt"] = "created_at";
    /** column name */
    InvitesUpdateColumn["Error"] = "error";
    /** column name */
    InvitesUpdateColumn["ExpiresAt"] = "expires_at";
    /** column name */
    InvitesUpdateColumn["GlobalRoleId"] = "global_role_id";
    /** column name */
    InvitesUpdateColumn["Id"] = "id";
    /** column name */
    InvitesUpdateColumn["ReceiverEmail"] = "receiver_email";
    /** column name */
    InvitesUpdateColumn["SenderId"] = "sender_id";
    /** column name */
    InvitesUpdateColumn["Status"] = "status";
    /** column name */
    InvitesUpdateColumn["UpdatedAt"] = "updated_at";
    /** column name */
    InvitesUpdateColumn["UserGroupId"] = "user_group_id";
    /** column name */
    InvitesUpdateColumn["UserGroupRoleId"] = "user_group_role_id";
})(InvitesUpdateColumn || (InvitesUpdateColumn = {}));
/** unique or primary key constraints on table "media" */
export var MediaConstraint;
(function (MediaConstraint) {
    /** unique or primary key constraint on columns "id" */
    MediaConstraint["MediaPkey"] = "media_pkey";
    /** unique or primary key constraint on columns "resource_key" */
    MediaConstraint["MediaResourceKeyKey"] = "media_resource_key_key";
})(MediaConstraint || (MediaConstraint = {}));
/** select columns of table "media" */
export var MediaSelectColumn;
(function (MediaSelectColumn) {
    /** column name */
    MediaSelectColumn["CreatedAt"] = "created_at";
    /** column name */
    MediaSelectColumn["DeletedAt"] = "deleted_at";
    /** column name */
    MediaSelectColumn["FileFormat"] = "file_format";
    /** column name */
    MediaSelectColumn["Id"] = "id";
    /** column name */
    MediaSelectColumn["ResourceKey"] = "resource_key";
    /** column name */
    MediaSelectColumn["UpdatedAt"] = "updated_at";
    /** column name */
    MediaSelectColumn["Url"] = "url";
})(MediaSelectColumn || (MediaSelectColumn = {}));
/** update columns of table "media" */
export var MediaUpdateColumn;
(function (MediaUpdateColumn) {
    /** column name */
    MediaUpdateColumn["CreatedAt"] = "created_at";
    /** column name */
    MediaUpdateColumn["DeletedAt"] = "deleted_at";
    /** column name */
    MediaUpdateColumn["FileFormat"] = "file_format";
    /** column name */
    MediaUpdateColumn["Id"] = "id";
    /** column name */
    MediaUpdateColumn["ResourceKey"] = "resource_key";
    /** column name */
    MediaUpdateColumn["UpdatedAt"] = "updated_at";
    /** column name */
    MediaUpdateColumn["Url"] = "url";
})(MediaUpdateColumn || (MediaUpdateColumn = {}));
/** select columns of table "monday_operating_hours" */
export var MondayOperatingHoursSelectColumn;
(function (MondayOperatingHoursSelectColumn) {
    /** column name */
    MondayOperatingHoursSelectColumn["DayOfWeek"] = "day_of_week";
    /** column name */
    MondayOperatingHoursSelectColumn["HourEnd"] = "hour_end";
    /** column name */
    MondayOperatingHoursSelectColumn["HourStart"] = "hour_start";
    /** column name */
    MondayOperatingHoursSelectColumn["ModelId"] = "model_id";
})(MondayOperatingHoursSelectColumn || (MondayOperatingHoursSelectColumn = {}));
/** unique or primary key constraints on table "onboarding_phone_number_verifications" */
export var OnboardingPhoneNumberVerificationsConstraint;
(function (OnboardingPhoneNumberVerificationsConstraint) {
    /** unique or primary key constraint on columns "id" */
    OnboardingPhoneNumberVerificationsConstraint["OnboardingPhoneNumberVerificationsPkey"] = "onboarding_phone_number_verifications_pkey";
})(OnboardingPhoneNumberVerificationsConstraint || (OnboardingPhoneNumberVerificationsConstraint = {}));
/** select columns of table "onboarding_phone_number_verifications" */
export var OnboardingPhoneNumberVerificationsSelectColumn;
(function (OnboardingPhoneNumberVerificationsSelectColumn) {
    /** column name */
    OnboardingPhoneNumberVerificationsSelectColumn["CreatedAt"] = "created_at";
    /** column name */
    OnboardingPhoneNumberVerificationsSelectColumn["Email"] = "email";
    /** column name */
    OnboardingPhoneNumberVerificationsSelectColumn["Id"] = "id";
    /** column name */
    OnboardingPhoneNumberVerificationsSelectColumn["PhoneNumber"] = "phone_number";
    /** column name */
    OnboardingPhoneNumberVerificationsSelectColumn["Refno"] = "refno";
    /** column name */
    OnboardingPhoneNumberVerificationsSelectColumn["Token"] = "token";
    /** column name */
    OnboardingPhoneNumberVerificationsSelectColumn["UpdateaAt"] = "updatea_at";
    /** column name */
    OnboardingPhoneNumberVerificationsSelectColumn["VerifiedAt"] = "verified_at";
})(OnboardingPhoneNumberVerificationsSelectColumn || (OnboardingPhoneNumberVerificationsSelectColumn = {}));
/** update columns of table "onboarding_phone_number_verifications" */
export var OnboardingPhoneNumberVerificationsUpdateColumn;
(function (OnboardingPhoneNumberVerificationsUpdateColumn) {
    /** column name */
    OnboardingPhoneNumberVerificationsUpdateColumn["CreatedAt"] = "created_at";
    /** column name */
    OnboardingPhoneNumberVerificationsUpdateColumn["Email"] = "email";
    /** column name */
    OnboardingPhoneNumberVerificationsUpdateColumn["Id"] = "id";
    /** column name */
    OnboardingPhoneNumberVerificationsUpdateColumn["PhoneNumber"] = "phone_number";
    /** column name */
    OnboardingPhoneNumberVerificationsUpdateColumn["Refno"] = "refno";
    /** column name */
    OnboardingPhoneNumberVerificationsUpdateColumn["Token"] = "token";
    /** column name */
    OnboardingPhoneNumberVerificationsUpdateColumn["UpdateaAt"] = "updatea_at";
    /** column name */
    OnboardingPhoneNumberVerificationsUpdateColumn["VerifiedAt"] = "verified_at";
})(OnboardingPhoneNumberVerificationsUpdateColumn || (OnboardingPhoneNumberVerificationsUpdateColumn = {}));
/** unique or primary key constraints on table "booking_images" */
export var OrBookingImagesConstraint;
(function (OrBookingImagesConstraint) {
    /** unique or primary key constraint on columns "id" */
    OrBookingImagesConstraint["Pk_0a23a7b72845a77057a4b78eeef"] = "PK_0a23a7b72845a77057a4b78eeef";
})(OrBookingImagesConstraint || (OrBookingImagesConstraint = {}));
/** select columns of table "booking_images" */
export var OrBookingImagesSelectColumn;
(function (OrBookingImagesSelectColumn) {
    /** column name */
    OrBookingImagesSelectColumn["BookingId"] = "booking_id";
    /** column name */
    OrBookingImagesSelectColumn["CreatedAt"] = "created_at";
    /** column name */
    OrBookingImagesSelectColumn["Id"] = "id";
    /** column name */
    OrBookingImagesSelectColumn["IsActive"] = "is_active";
    /** column name */
    OrBookingImagesSelectColumn["ObjectKey"] = "object_key";
    /** column name */
    OrBookingImagesSelectColumn["UpdatedAt"] = "updated_at";
})(OrBookingImagesSelectColumn || (OrBookingImagesSelectColumn = {}));
/** select "or_booking_images_aggregate_bool_exp_bool_and_arguments_columns" columns of table "booking_images" */
export var OrBookingImagesSelectColumnOrBookingImagesAggregateBoolExpBoolAndArgumentsColumns;
(function (OrBookingImagesSelectColumnOrBookingImagesAggregateBoolExpBoolAndArgumentsColumns) {
    /** column name */
    OrBookingImagesSelectColumnOrBookingImagesAggregateBoolExpBoolAndArgumentsColumns["IsActive"] = "is_active";
})(OrBookingImagesSelectColumnOrBookingImagesAggregateBoolExpBoolAndArgumentsColumns || (OrBookingImagesSelectColumnOrBookingImagesAggregateBoolExpBoolAndArgumentsColumns = {}));
/** select "or_booking_images_aggregate_bool_exp_bool_or_arguments_columns" columns of table "booking_images" */
export var OrBookingImagesSelectColumnOrBookingImagesAggregateBoolExpBoolOrArgumentsColumns;
(function (OrBookingImagesSelectColumnOrBookingImagesAggregateBoolExpBoolOrArgumentsColumns) {
    /** column name */
    OrBookingImagesSelectColumnOrBookingImagesAggregateBoolExpBoolOrArgumentsColumns["IsActive"] = "is_active";
})(OrBookingImagesSelectColumnOrBookingImagesAggregateBoolExpBoolOrArgumentsColumns || (OrBookingImagesSelectColumnOrBookingImagesAggregateBoolExpBoolOrArgumentsColumns = {}));
/** update columns of table "booking_images" */
export var OrBookingImagesUpdateColumn;
(function (OrBookingImagesUpdateColumn) {
    /** column name */
    OrBookingImagesUpdateColumn["BookingId"] = "booking_id";
    /** column name */
    OrBookingImagesUpdateColumn["CreatedAt"] = "created_at";
    /** column name */
    OrBookingImagesUpdateColumn["Id"] = "id";
    /** column name */
    OrBookingImagesUpdateColumn["IsActive"] = "is_active";
    /** column name */
    OrBookingImagesUpdateColumn["ObjectKey"] = "object_key";
    /** column name */
    OrBookingImagesUpdateColumn["UpdatedAt"] = "updated_at";
})(OrBookingImagesUpdateColumn || (OrBookingImagesUpdateColumn = {}));
/** unique or primary key constraints on table "bookings" */
export var OrBookingsConstraint;
(function (OrBookingsConstraint) {
    /** unique or primary key constraint on columns "id" */
    OrBookingsConstraint["PkBee6805982cc1e248e94ce94957"] = "PK_bee6805982cc1e248e94ce94957";
})(OrBookingsConstraint || (OrBookingsConstraint = {}));
/** select columns of table "bookings" */
export var OrBookingsSelectColumn;
(function (OrBookingsSelectColumn) {
    /** column name */
    OrBookingsSelectColumn["BusinessProfileKey"] = "business_profile_key";
    /** column name */
    OrBookingsSelectColumn["CommonFeeCharge"] = "common_fee_charge";
    /** column name */
    OrBookingsSelectColumn["CreatedAt"] = "created_at";
    /** column name */
    OrBookingsSelectColumn["ElectricityCharge"] = "electricity_charge";
    /** column name */
    OrBookingsSelectColumn["ExampleItems"] = "example_items";
    /** column name */
    OrBookingsSelectColumn["FixedElectricityCharge"] = "fixed_electricity_charge";
    /** column name */
    OrBookingsSelectColumn["FixedWaterCharge"] = "fixed_water_charge";
    /** column name */
    OrBookingsSelectColumn["Id"] = "id";
    /** column name */
    OrBookingsSelectColumn["InsuranceRental"] = "insurance_rental";
    /** column name */
    OrBookingsSelectColumn["IsActive"] = "is_active";
    /** column name */
    OrBookingsSelectColumn["MessageToBooker"] = "message_to_booker";
    /** column name */
    OrBookingsSelectColumn["MoreInfo"] = "more_info";
    /** column name */
    OrBookingsSelectColumn["RejectInternalComment"] = "reject_internal_comment";
    /** column name */
    OrBookingsSelectColumn["RejectReason"] = "reject_reason";
    /** column name */
    OrBookingsSelectColumn["RentalBusinessGroup"] = "rental_business_group";
    /** column name */
    OrBookingsSelectColumn["RentalCost"] = "rental_cost";
    /** column name */
    OrBookingsSelectColumn["RentalCostPercent"] = "rental_cost_percent";
    /** column name */
    OrBookingsSelectColumn["RentalHouseholdFileKey"] = "rental_household_file_key";
    /** column name */
    OrBookingsSelectColumn["RentalIdCardFileKey"] = "rental_id_card_file_key";
    /** column name */
    OrBookingsSelectColumn["RentalWorkCertFileKey"] = "rental_work_cert_file_key";
    /** column name */
    OrBookingsSelectColumn["SaleSupport"] = "sale_support";
    /** column name */
    OrBookingsSelectColumn["ShipTo"] = "ship_to";
    /** column name */
    OrBookingsSelectColumn["ShipToName"] = "ship_to_name";
    /** column name */
    OrBookingsSelectColumn["ShopName"] = "shop_name";
    /** column name */
    OrBookingsSelectColumn["ShopType"] = "shop_type";
    /** column name */
    OrBookingsSelectColumn["SoldTo"] = "sold_to";
    /** column name */
    OrBookingsSelectColumn["SoldToName"] = "sold_to_name";
    /** column name */
    OrBookingsSelectColumn["SpaceId"] = "space_id";
    /** column name */
    OrBookingsSelectColumn["Tel"] = "tel";
    /** column name */
    OrBookingsSelectColumn["UpdatedAt"] = "updated_at";
    /** column name */
    OrBookingsSelectColumn["Uuid"] = "uuid";
    /** column name */
    OrBookingsSelectColumn["VatFileKey"] = "vat_file_key";
    /** column name */
    OrBookingsSelectColumn["WastedWaterTreatmentCharge"] = "wasted_water_treatment_charge";
    /** column name */
    OrBookingsSelectColumn["WaterCharge"] = "water_charge";
})(OrBookingsSelectColumn || (OrBookingsSelectColumn = {}));
/** select "or_bookings_aggregate_bool_exp_avg_arguments_columns" columns of table "bookings" */
export var OrBookingsSelectColumnOrBookingsAggregateBoolExpAvgArgumentsColumns;
(function (OrBookingsSelectColumnOrBookingsAggregateBoolExpAvgArgumentsColumns) {
    /** column name */
    OrBookingsSelectColumnOrBookingsAggregateBoolExpAvgArgumentsColumns["CommonFeeCharge"] = "common_fee_charge";
    /** column name */
    OrBookingsSelectColumnOrBookingsAggregateBoolExpAvgArgumentsColumns["ElectricityCharge"] = "electricity_charge";
    /** column name */
    OrBookingsSelectColumnOrBookingsAggregateBoolExpAvgArgumentsColumns["FixedElectricityCharge"] = "fixed_electricity_charge";
    /** column name */
    OrBookingsSelectColumnOrBookingsAggregateBoolExpAvgArgumentsColumns["FixedWaterCharge"] = "fixed_water_charge";
    /** column name */
    OrBookingsSelectColumnOrBookingsAggregateBoolExpAvgArgumentsColumns["InsuranceRental"] = "insurance_rental";
    /** column name */
    OrBookingsSelectColumnOrBookingsAggregateBoolExpAvgArgumentsColumns["RentalCost"] = "rental_cost";
    /** column name */
    OrBookingsSelectColumnOrBookingsAggregateBoolExpAvgArgumentsColumns["RentalCostPercent"] = "rental_cost_percent";
    /** column name */
    OrBookingsSelectColumnOrBookingsAggregateBoolExpAvgArgumentsColumns["WastedWaterTreatmentCharge"] = "wasted_water_treatment_charge";
    /** column name */
    OrBookingsSelectColumnOrBookingsAggregateBoolExpAvgArgumentsColumns["WaterCharge"] = "water_charge";
})(OrBookingsSelectColumnOrBookingsAggregateBoolExpAvgArgumentsColumns || (OrBookingsSelectColumnOrBookingsAggregateBoolExpAvgArgumentsColumns = {}));
/** select "or_bookings_aggregate_bool_exp_bool_and_arguments_columns" columns of table "bookings" */
export var OrBookingsSelectColumnOrBookingsAggregateBoolExpBoolAndArgumentsColumns;
(function (OrBookingsSelectColumnOrBookingsAggregateBoolExpBoolAndArgumentsColumns) {
    /** column name */
    OrBookingsSelectColumnOrBookingsAggregateBoolExpBoolAndArgumentsColumns["IsActive"] = "is_active";
})(OrBookingsSelectColumnOrBookingsAggregateBoolExpBoolAndArgumentsColumns || (OrBookingsSelectColumnOrBookingsAggregateBoolExpBoolAndArgumentsColumns = {}));
/** select "or_bookings_aggregate_bool_exp_bool_or_arguments_columns" columns of table "bookings" */
export var OrBookingsSelectColumnOrBookingsAggregateBoolExpBoolOrArgumentsColumns;
(function (OrBookingsSelectColumnOrBookingsAggregateBoolExpBoolOrArgumentsColumns) {
    /** column name */
    OrBookingsSelectColumnOrBookingsAggregateBoolExpBoolOrArgumentsColumns["IsActive"] = "is_active";
})(OrBookingsSelectColumnOrBookingsAggregateBoolExpBoolOrArgumentsColumns || (OrBookingsSelectColumnOrBookingsAggregateBoolExpBoolOrArgumentsColumns = {}));
/** select "or_bookings_aggregate_bool_exp_corr_arguments_columns" columns of table "bookings" */
export var OrBookingsSelectColumnOrBookingsAggregateBoolExpCorrArgumentsColumns;
(function (OrBookingsSelectColumnOrBookingsAggregateBoolExpCorrArgumentsColumns) {
    /** column name */
    OrBookingsSelectColumnOrBookingsAggregateBoolExpCorrArgumentsColumns["CommonFeeCharge"] = "common_fee_charge";
    /** column name */
    OrBookingsSelectColumnOrBookingsAggregateBoolExpCorrArgumentsColumns["ElectricityCharge"] = "electricity_charge";
    /** column name */
    OrBookingsSelectColumnOrBookingsAggregateBoolExpCorrArgumentsColumns["FixedElectricityCharge"] = "fixed_electricity_charge";
    /** column name */
    OrBookingsSelectColumnOrBookingsAggregateBoolExpCorrArgumentsColumns["FixedWaterCharge"] = "fixed_water_charge";
    /** column name */
    OrBookingsSelectColumnOrBookingsAggregateBoolExpCorrArgumentsColumns["InsuranceRental"] = "insurance_rental";
    /** column name */
    OrBookingsSelectColumnOrBookingsAggregateBoolExpCorrArgumentsColumns["RentalCost"] = "rental_cost";
    /** column name */
    OrBookingsSelectColumnOrBookingsAggregateBoolExpCorrArgumentsColumns["RentalCostPercent"] = "rental_cost_percent";
    /** column name */
    OrBookingsSelectColumnOrBookingsAggregateBoolExpCorrArgumentsColumns["WastedWaterTreatmentCharge"] = "wasted_water_treatment_charge";
    /** column name */
    OrBookingsSelectColumnOrBookingsAggregateBoolExpCorrArgumentsColumns["WaterCharge"] = "water_charge";
})(OrBookingsSelectColumnOrBookingsAggregateBoolExpCorrArgumentsColumns || (OrBookingsSelectColumnOrBookingsAggregateBoolExpCorrArgumentsColumns = {}));
/** select "or_bookings_aggregate_bool_exp_covar_samp_arguments_columns" columns of table "bookings" */
export var OrBookingsSelectColumnOrBookingsAggregateBoolExpCovarSampArgumentsColumns;
(function (OrBookingsSelectColumnOrBookingsAggregateBoolExpCovarSampArgumentsColumns) {
    /** column name */
    OrBookingsSelectColumnOrBookingsAggregateBoolExpCovarSampArgumentsColumns["CommonFeeCharge"] = "common_fee_charge";
    /** column name */
    OrBookingsSelectColumnOrBookingsAggregateBoolExpCovarSampArgumentsColumns["ElectricityCharge"] = "electricity_charge";
    /** column name */
    OrBookingsSelectColumnOrBookingsAggregateBoolExpCovarSampArgumentsColumns["FixedElectricityCharge"] = "fixed_electricity_charge";
    /** column name */
    OrBookingsSelectColumnOrBookingsAggregateBoolExpCovarSampArgumentsColumns["FixedWaterCharge"] = "fixed_water_charge";
    /** column name */
    OrBookingsSelectColumnOrBookingsAggregateBoolExpCovarSampArgumentsColumns["InsuranceRental"] = "insurance_rental";
    /** column name */
    OrBookingsSelectColumnOrBookingsAggregateBoolExpCovarSampArgumentsColumns["RentalCost"] = "rental_cost";
    /** column name */
    OrBookingsSelectColumnOrBookingsAggregateBoolExpCovarSampArgumentsColumns["RentalCostPercent"] = "rental_cost_percent";
    /** column name */
    OrBookingsSelectColumnOrBookingsAggregateBoolExpCovarSampArgumentsColumns["WastedWaterTreatmentCharge"] = "wasted_water_treatment_charge";
    /** column name */
    OrBookingsSelectColumnOrBookingsAggregateBoolExpCovarSampArgumentsColumns["WaterCharge"] = "water_charge";
})(OrBookingsSelectColumnOrBookingsAggregateBoolExpCovarSampArgumentsColumns || (OrBookingsSelectColumnOrBookingsAggregateBoolExpCovarSampArgumentsColumns = {}));
/** select "or_bookings_aggregate_bool_exp_max_arguments_columns" columns of table "bookings" */
export var OrBookingsSelectColumnOrBookingsAggregateBoolExpMaxArgumentsColumns;
(function (OrBookingsSelectColumnOrBookingsAggregateBoolExpMaxArgumentsColumns) {
    /** column name */
    OrBookingsSelectColumnOrBookingsAggregateBoolExpMaxArgumentsColumns["CommonFeeCharge"] = "common_fee_charge";
    /** column name */
    OrBookingsSelectColumnOrBookingsAggregateBoolExpMaxArgumentsColumns["ElectricityCharge"] = "electricity_charge";
    /** column name */
    OrBookingsSelectColumnOrBookingsAggregateBoolExpMaxArgumentsColumns["FixedElectricityCharge"] = "fixed_electricity_charge";
    /** column name */
    OrBookingsSelectColumnOrBookingsAggregateBoolExpMaxArgumentsColumns["FixedWaterCharge"] = "fixed_water_charge";
    /** column name */
    OrBookingsSelectColumnOrBookingsAggregateBoolExpMaxArgumentsColumns["InsuranceRental"] = "insurance_rental";
    /** column name */
    OrBookingsSelectColumnOrBookingsAggregateBoolExpMaxArgumentsColumns["RentalCost"] = "rental_cost";
    /** column name */
    OrBookingsSelectColumnOrBookingsAggregateBoolExpMaxArgumentsColumns["RentalCostPercent"] = "rental_cost_percent";
    /** column name */
    OrBookingsSelectColumnOrBookingsAggregateBoolExpMaxArgumentsColumns["WastedWaterTreatmentCharge"] = "wasted_water_treatment_charge";
    /** column name */
    OrBookingsSelectColumnOrBookingsAggregateBoolExpMaxArgumentsColumns["WaterCharge"] = "water_charge";
})(OrBookingsSelectColumnOrBookingsAggregateBoolExpMaxArgumentsColumns || (OrBookingsSelectColumnOrBookingsAggregateBoolExpMaxArgumentsColumns = {}));
/** select "or_bookings_aggregate_bool_exp_min_arguments_columns" columns of table "bookings" */
export var OrBookingsSelectColumnOrBookingsAggregateBoolExpMinArgumentsColumns;
(function (OrBookingsSelectColumnOrBookingsAggregateBoolExpMinArgumentsColumns) {
    /** column name */
    OrBookingsSelectColumnOrBookingsAggregateBoolExpMinArgumentsColumns["CommonFeeCharge"] = "common_fee_charge";
    /** column name */
    OrBookingsSelectColumnOrBookingsAggregateBoolExpMinArgumentsColumns["ElectricityCharge"] = "electricity_charge";
    /** column name */
    OrBookingsSelectColumnOrBookingsAggregateBoolExpMinArgumentsColumns["FixedElectricityCharge"] = "fixed_electricity_charge";
    /** column name */
    OrBookingsSelectColumnOrBookingsAggregateBoolExpMinArgumentsColumns["FixedWaterCharge"] = "fixed_water_charge";
    /** column name */
    OrBookingsSelectColumnOrBookingsAggregateBoolExpMinArgumentsColumns["InsuranceRental"] = "insurance_rental";
    /** column name */
    OrBookingsSelectColumnOrBookingsAggregateBoolExpMinArgumentsColumns["RentalCost"] = "rental_cost";
    /** column name */
    OrBookingsSelectColumnOrBookingsAggregateBoolExpMinArgumentsColumns["RentalCostPercent"] = "rental_cost_percent";
    /** column name */
    OrBookingsSelectColumnOrBookingsAggregateBoolExpMinArgumentsColumns["WastedWaterTreatmentCharge"] = "wasted_water_treatment_charge";
    /** column name */
    OrBookingsSelectColumnOrBookingsAggregateBoolExpMinArgumentsColumns["WaterCharge"] = "water_charge";
})(OrBookingsSelectColumnOrBookingsAggregateBoolExpMinArgumentsColumns || (OrBookingsSelectColumnOrBookingsAggregateBoolExpMinArgumentsColumns = {}));
/** select "or_bookings_aggregate_bool_exp_stddev_samp_arguments_columns" columns of table "bookings" */
export var OrBookingsSelectColumnOrBookingsAggregateBoolExpStddevSampArgumentsColumns;
(function (OrBookingsSelectColumnOrBookingsAggregateBoolExpStddevSampArgumentsColumns) {
    /** column name */
    OrBookingsSelectColumnOrBookingsAggregateBoolExpStddevSampArgumentsColumns["CommonFeeCharge"] = "common_fee_charge";
    /** column name */
    OrBookingsSelectColumnOrBookingsAggregateBoolExpStddevSampArgumentsColumns["ElectricityCharge"] = "electricity_charge";
    /** column name */
    OrBookingsSelectColumnOrBookingsAggregateBoolExpStddevSampArgumentsColumns["FixedElectricityCharge"] = "fixed_electricity_charge";
    /** column name */
    OrBookingsSelectColumnOrBookingsAggregateBoolExpStddevSampArgumentsColumns["FixedWaterCharge"] = "fixed_water_charge";
    /** column name */
    OrBookingsSelectColumnOrBookingsAggregateBoolExpStddevSampArgumentsColumns["InsuranceRental"] = "insurance_rental";
    /** column name */
    OrBookingsSelectColumnOrBookingsAggregateBoolExpStddevSampArgumentsColumns["RentalCost"] = "rental_cost";
    /** column name */
    OrBookingsSelectColumnOrBookingsAggregateBoolExpStddevSampArgumentsColumns["RentalCostPercent"] = "rental_cost_percent";
    /** column name */
    OrBookingsSelectColumnOrBookingsAggregateBoolExpStddevSampArgumentsColumns["WastedWaterTreatmentCharge"] = "wasted_water_treatment_charge";
    /** column name */
    OrBookingsSelectColumnOrBookingsAggregateBoolExpStddevSampArgumentsColumns["WaterCharge"] = "water_charge";
})(OrBookingsSelectColumnOrBookingsAggregateBoolExpStddevSampArgumentsColumns || (OrBookingsSelectColumnOrBookingsAggregateBoolExpStddevSampArgumentsColumns = {}));
/** select "or_bookings_aggregate_bool_exp_sum_arguments_columns" columns of table "bookings" */
export var OrBookingsSelectColumnOrBookingsAggregateBoolExpSumArgumentsColumns;
(function (OrBookingsSelectColumnOrBookingsAggregateBoolExpSumArgumentsColumns) {
    /** column name */
    OrBookingsSelectColumnOrBookingsAggregateBoolExpSumArgumentsColumns["CommonFeeCharge"] = "common_fee_charge";
    /** column name */
    OrBookingsSelectColumnOrBookingsAggregateBoolExpSumArgumentsColumns["ElectricityCharge"] = "electricity_charge";
    /** column name */
    OrBookingsSelectColumnOrBookingsAggregateBoolExpSumArgumentsColumns["FixedElectricityCharge"] = "fixed_electricity_charge";
    /** column name */
    OrBookingsSelectColumnOrBookingsAggregateBoolExpSumArgumentsColumns["FixedWaterCharge"] = "fixed_water_charge";
    /** column name */
    OrBookingsSelectColumnOrBookingsAggregateBoolExpSumArgumentsColumns["InsuranceRental"] = "insurance_rental";
    /** column name */
    OrBookingsSelectColumnOrBookingsAggregateBoolExpSumArgumentsColumns["RentalCost"] = "rental_cost";
    /** column name */
    OrBookingsSelectColumnOrBookingsAggregateBoolExpSumArgumentsColumns["RentalCostPercent"] = "rental_cost_percent";
    /** column name */
    OrBookingsSelectColumnOrBookingsAggregateBoolExpSumArgumentsColumns["WastedWaterTreatmentCharge"] = "wasted_water_treatment_charge";
    /** column name */
    OrBookingsSelectColumnOrBookingsAggregateBoolExpSumArgumentsColumns["WaterCharge"] = "water_charge";
})(OrBookingsSelectColumnOrBookingsAggregateBoolExpSumArgumentsColumns || (OrBookingsSelectColumnOrBookingsAggregateBoolExpSumArgumentsColumns = {}));
/** select "or_bookings_aggregate_bool_exp_var_samp_arguments_columns" columns of table "bookings" */
export var OrBookingsSelectColumnOrBookingsAggregateBoolExpVarSampArgumentsColumns;
(function (OrBookingsSelectColumnOrBookingsAggregateBoolExpVarSampArgumentsColumns) {
    /** column name */
    OrBookingsSelectColumnOrBookingsAggregateBoolExpVarSampArgumentsColumns["CommonFeeCharge"] = "common_fee_charge";
    /** column name */
    OrBookingsSelectColumnOrBookingsAggregateBoolExpVarSampArgumentsColumns["ElectricityCharge"] = "electricity_charge";
    /** column name */
    OrBookingsSelectColumnOrBookingsAggregateBoolExpVarSampArgumentsColumns["FixedElectricityCharge"] = "fixed_electricity_charge";
    /** column name */
    OrBookingsSelectColumnOrBookingsAggregateBoolExpVarSampArgumentsColumns["FixedWaterCharge"] = "fixed_water_charge";
    /** column name */
    OrBookingsSelectColumnOrBookingsAggregateBoolExpVarSampArgumentsColumns["InsuranceRental"] = "insurance_rental";
    /** column name */
    OrBookingsSelectColumnOrBookingsAggregateBoolExpVarSampArgumentsColumns["RentalCost"] = "rental_cost";
    /** column name */
    OrBookingsSelectColumnOrBookingsAggregateBoolExpVarSampArgumentsColumns["RentalCostPercent"] = "rental_cost_percent";
    /** column name */
    OrBookingsSelectColumnOrBookingsAggregateBoolExpVarSampArgumentsColumns["WastedWaterTreatmentCharge"] = "wasted_water_treatment_charge";
    /** column name */
    OrBookingsSelectColumnOrBookingsAggregateBoolExpVarSampArgumentsColumns["WaterCharge"] = "water_charge";
})(OrBookingsSelectColumnOrBookingsAggregateBoolExpVarSampArgumentsColumns || (OrBookingsSelectColumnOrBookingsAggregateBoolExpVarSampArgumentsColumns = {}));
/** update columns of table "bookings" */
export var OrBookingsUpdateColumn;
(function (OrBookingsUpdateColumn) {
    /** column name */
    OrBookingsUpdateColumn["BusinessProfileKey"] = "business_profile_key";
    /** column name */
    OrBookingsUpdateColumn["CommonFeeCharge"] = "common_fee_charge";
    /** column name */
    OrBookingsUpdateColumn["CreatedAt"] = "created_at";
    /** column name */
    OrBookingsUpdateColumn["ElectricityCharge"] = "electricity_charge";
    /** column name */
    OrBookingsUpdateColumn["ExampleItems"] = "example_items";
    /** column name */
    OrBookingsUpdateColumn["FixedElectricityCharge"] = "fixed_electricity_charge";
    /** column name */
    OrBookingsUpdateColumn["FixedWaterCharge"] = "fixed_water_charge";
    /** column name */
    OrBookingsUpdateColumn["Id"] = "id";
    /** column name */
    OrBookingsUpdateColumn["InsuranceRental"] = "insurance_rental";
    /** column name */
    OrBookingsUpdateColumn["IsActive"] = "is_active";
    /** column name */
    OrBookingsUpdateColumn["MessageToBooker"] = "message_to_booker";
    /** column name */
    OrBookingsUpdateColumn["MoreInfo"] = "more_info";
    /** column name */
    OrBookingsUpdateColumn["RejectInternalComment"] = "reject_internal_comment";
    /** column name */
    OrBookingsUpdateColumn["RejectReason"] = "reject_reason";
    /** column name */
    OrBookingsUpdateColumn["RentalBusinessGroup"] = "rental_business_group";
    /** column name */
    OrBookingsUpdateColumn["RentalCost"] = "rental_cost";
    /** column name */
    OrBookingsUpdateColumn["RentalCostPercent"] = "rental_cost_percent";
    /** column name */
    OrBookingsUpdateColumn["RentalHouseholdFileKey"] = "rental_household_file_key";
    /** column name */
    OrBookingsUpdateColumn["RentalIdCardFileKey"] = "rental_id_card_file_key";
    /** column name */
    OrBookingsUpdateColumn["RentalWorkCertFileKey"] = "rental_work_cert_file_key";
    /** column name */
    OrBookingsUpdateColumn["SaleSupport"] = "sale_support";
    /** column name */
    OrBookingsUpdateColumn["ShipTo"] = "ship_to";
    /** column name */
    OrBookingsUpdateColumn["ShipToName"] = "ship_to_name";
    /** column name */
    OrBookingsUpdateColumn["ShopName"] = "shop_name";
    /** column name */
    OrBookingsUpdateColumn["ShopType"] = "shop_type";
    /** column name */
    OrBookingsUpdateColumn["SoldTo"] = "sold_to";
    /** column name */
    OrBookingsUpdateColumn["SoldToName"] = "sold_to_name";
    /** column name */
    OrBookingsUpdateColumn["SpaceId"] = "space_id";
    /** column name */
    OrBookingsUpdateColumn["Tel"] = "tel";
    /** column name */
    OrBookingsUpdateColumn["UpdatedAt"] = "updated_at";
    /** column name */
    OrBookingsUpdateColumn["Uuid"] = "uuid";
    /** column name */
    OrBookingsUpdateColumn["VatFileKey"] = "vat_file_key";
    /** column name */
    OrBookingsUpdateColumn["WastedWaterTreatmentCharge"] = "wasted_water_treatment_charge";
    /** column name */
    OrBookingsUpdateColumn["WaterCharge"] = "water_charge";
})(OrBookingsUpdateColumn || (OrBookingsUpdateColumn = {}));
/** unique or primary key constraints on table "campaign_emails" */
export var OrCampaignEmailsConstraint;
(function (OrCampaignEmailsConstraint) {
    /** unique or primary key constraint on columns "id" */
    OrCampaignEmailsConstraint["Pk_801485bdaf0c253be03b2f291e7"] = "PK_801485bdaf0c253be03b2f291e7";
})(OrCampaignEmailsConstraint || (OrCampaignEmailsConstraint = {}));
/** select columns of table "campaign_emails" */
export var OrCampaignEmailsSelectColumn;
(function (OrCampaignEmailsSelectColumn) {
    /** column name */
    OrCampaignEmailsSelectColumn["CampaignId"] = "campaign_id";
    /** column name */
    OrCampaignEmailsSelectColumn["CreatedAt"] = "created_at";
    /** column name */
    OrCampaignEmailsSelectColumn["Email"] = "email";
    /** column name */
    OrCampaignEmailsSelectColumn["Id"] = "id";
    /** column name */
    OrCampaignEmailsSelectColumn["ReadStatus"] = "read_status";
    /** column name */
    OrCampaignEmailsSelectColumn["UpdatedAt"] = "updated_at";
})(OrCampaignEmailsSelectColumn || (OrCampaignEmailsSelectColumn = {}));
/** select "or_campaign_emails_aggregate_bool_exp_bool_and_arguments_columns" columns of table "campaign_emails" */
export var OrCampaignEmailsSelectColumnOrCampaignEmailsAggregateBoolExpBoolAndArgumentsColumns;
(function (OrCampaignEmailsSelectColumnOrCampaignEmailsAggregateBoolExpBoolAndArgumentsColumns) {
    /** column name */
    OrCampaignEmailsSelectColumnOrCampaignEmailsAggregateBoolExpBoolAndArgumentsColumns["ReadStatus"] = "read_status";
})(OrCampaignEmailsSelectColumnOrCampaignEmailsAggregateBoolExpBoolAndArgumentsColumns || (OrCampaignEmailsSelectColumnOrCampaignEmailsAggregateBoolExpBoolAndArgumentsColumns = {}));
/** select "or_campaign_emails_aggregate_bool_exp_bool_or_arguments_columns" columns of table "campaign_emails" */
export var OrCampaignEmailsSelectColumnOrCampaignEmailsAggregateBoolExpBoolOrArgumentsColumns;
(function (OrCampaignEmailsSelectColumnOrCampaignEmailsAggregateBoolExpBoolOrArgumentsColumns) {
    /** column name */
    OrCampaignEmailsSelectColumnOrCampaignEmailsAggregateBoolExpBoolOrArgumentsColumns["ReadStatus"] = "read_status";
})(OrCampaignEmailsSelectColumnOrCampaignEmailsAggregateBoolExpBoolOrArgumentsColumns || (OrCampaignEmailsSelectColumnOrCampaignEmailsAggregateBoolExpBoolOrArgumentsColumns = {}));
/** update columns of table "campaign_emails" */
export var OrCampaignEmailsUpdateColumn;
(function (OrCampaignEmailsUpdateColumn) {
    /** column name */
    OrCampaignEmailsUpdateColumn["CampaignId"] = "campaign_id";
    /** column name */
    OrCampaignEmailsUpdateColumn["CreatedAt"] = "created_at";
    /** column name */
    OrCampaignEmailsUpdateColumn["Email"] = "email";
    /** column name */
    OrCampaignEmailsUpdateColumn["Id"] = "id";
    /** column name */
    OrCampaignEmailsUpdateColumn["ReadStatus"] = "read_status";
    /** column name */
    OrCampaignEmailsUpdateColumn["UpdatedAt"] = "updated_at";
})(OrCampaignEmailsUpdateColumn || (OrCampaignEmailsUpdateColumn = {}));
/** unique or primary key constraints on table "campaing_spaces" */
export var OrCampaignSpacesConstraint;
(function (OrCampaignSpacesConstraint) {
    /** unique or primary key constraint on columns "id" */
    OrCampaignSpacesConstraint["Pk_151121226c25db452e6a52f9a83"] = "PK_151121226c25db452e6a52f9a83";
})(OrCampaignSpacesConstraint || (OrCampaignSpacesConstraint = {}));
/** select columns of table "campaing_spaces" */
export var OrCampaignSpacesSelectColumn;
(function (OrCampaignSpacesSelectColumn) {
    /** column name */
    OrCampaignSpacesSelectColumn["CampaignId"] = "campaign_id";
    /** column name */
    OrCampaignSpacesSelectColumn["CreatedAt"] = "created_at";
    /** column name */
    OrCampaignSpacesSelectColumn["Id"] = "id";
    /** column name */
    OrCampaignSpacesSelectColumn["SpaceId"] = "space_id";
    /** column name */
    OrCampaignSpacesSelectColumn["UpdatedAt"] = "updated_at";
})(OrCampaignSpacesSelectColumn || (OrCampaignSpacesSelectColumn = {}));
/** update columns of table "campaing_spaces" */
export var OrCampaignSpacesUpdateColumn;
(function (OrCampaignSpacesUpdateColumn) {
    /** column name */
    OrCampaignSpacesUpdateColumn["CampaignId"] = "campaign_id";
    /** column name */
    OrCampaignSpacesUpdateColumn["CreatedAt"] = "created_at";
    /** column name */
    OrCampaignSpacesUpdateColumn["Id"] = "id";
    /** column name */
    OrCampaignSpacesUpdateColumn["SpaceId"] = "space_id";
    /** column name */
    OrCampaignSpacesUpdateColumn["UpdatedAt"] = "updated_at";
})(OrCampaignSpacesUpdateColumn || (OrCampaignSpacesUpdateColumn = {}));
/** unique or primary key constraints on table "campaing_users" */
export var OrCampaignUsersConstraint;
(function (OrCampaignUsersConstraint) {
    /** unique or primary key constraint on columns "id" */
    OrCampaignUsersConstraint["PkD54d0bbe7fef176ee87dc72640f"] = "PK_d54d0bbe7fef176ee87dc72640f";
})(OrCampaignUsersConstraint || (OrCampaignUsersConstraint = {}));
/** select columns of table "campaing_users" */
export var OrCampaignUsersSelectColumn;
(function (OrCampaignUsersSelectColumn) {
    /** column name */
    OrCampaignUsersSelectColumn["CampaignId"] = "campaign_id";
    /** column name */
    OrCampaignUsersSelectColumn["CreatedAt"] = "created_at";
    /** column name */
    OrCampaignUsersSelectColumn["Id"] = "id";
    /** column name */
    OrCampaignUsersSelectColumn["UpdatedAt"] = "updated_at";
    /** column name */
    OrCampaignUsersSelectColumn["UserUuid"] = "user_uuid";
})(OrCampaignUsersSelectColumn || (OrCampaignUsersSelectColumn = {}));
/** update columns of table "campaing_users" */
export var OrCampaignUsersUpdateColumn;
(function (OrCampaignUsersUpdateColumn) {
    /** column name */
    OrCampaignUsersUpdateColumn["CampaignId"] = "campaign_id";
    /** column name */
    OrCampaignUsersUpdateColumn["CreatedAt"] = "created_at";
    /** column name */
    OrCampaignUsersUpdateColumn["Id"] = "id";
    /** column name */
    OrCampaignUsersUpdateColumn["UpdatedAt"] = "updated_at";
    /** column name */
    OrCampaignUsersUpdateColumn["UserUuid"] = "user_uuid";
})(OrCampaignUsersUpdateColumn || (OrCampaignUsersUpdateColumn = {}));
/** unique or primary key constraints on table "campaigns" */
export var OrCampaignsConstraint;
(function (OrCampaignsConstraint) {
    /** unique or primary key constraint on columns "id" */
    OrCampaignsConstraint["Pk_831e3fcd4fc45b4e4c3f57a9ee4"] = "PK_831e3fcd4fc45b4e4c3f57a9ee4";
})(OrCampaignsConstraint || (OrCampaignsConstraint = {}));
/** select columns of table "campaigns" */
export var OrCampaignsSelectColumn;
(function (OrCampaignsSelectColumn) {
    /** column name */
    OrCampaignsSelectColumn["CreatedAt"] = "created_at";
    /** column name */
    OrCampaignsSelectColumn["CreatedBy"] = "created_by";
    /** column name */
    OrCampaignsSelectColumn["Duration"] = "duration";
    /** column name */
    OrCampaignsSelectColumn["Id"] = "id";
    /** column name */
    OrCampaignsSelectColumn["IsActive"] = "is_active";
    /** column name */
    OrCampaignsSelectColumn["Name"] = "name";
    /** column name */
    OrCampaignsSelectColumn["SentTime"] = "sent_time";
    /** column name */
    OrCampaignsSelectColumn["StartDate"] = "start_date";
    /** column name */
    OrCampaignsSelectColumn["Status"] = "status";
    /** column name */
    OrCampaignsSelectColumn["UpdatedAt"] = "updated_at";
})(OrCampaignsSelectColumn || (OrCampaignsSelectColumn = {}));
/** update columns of table "campaigns" */
export var OrCampaignsUpdateColumn;
(function (OrCampaignsUpdateColumn) {
    /** column name */
    OrCampaignsUpdateColumn["CreatedAt"] = "created_at";
    /** column name */
    OrCampaignsUpdateColumn["CreatedBy"] = "created_by";
    /** column name */
    OrCampaignsUpdateColumn["Duration"] = "duration";
    /** column name */
    OrCampaignsUpdateColumn["Id"] = "id";
    /** column name */
    OrCampaignsUpdateColumn["IsActive"] = "is_active";
    /** column name */
    OrCampaignsUpdateColumn["Name"] = "name";
    /** column name */
    OrCampaignsUpdateColumn["SentTime"] = "sent_time";
    /** column name */
    OrCampaignsUpdateColumn["StartDate"] = "start_date";
    /** column name */
    OrCampaignsUpdateColumn["Status"] = "status";
    /** column name */
    OrCampaignsUpdateColumn["UpdatedAt"] = "updated_at";
})(OrCampaignsUpdateColumn || (OrCampaignsUpdateColumn = {}));
/** unique or primary key constraints on table "space_images" */
export var OrSpaceImagesConstraint;
(function (OrSpaceImagesConstraint) {
    /** unique or primary key constraint on columns "id" */
    OrSpaceImagesConstraint["PkDe373fe7e75645d9f194b4be810"] = "PK_de373fe7e75645d9f194b4be810";
})(OrSpaceImagesConstraint || (OrSpaceImagesConstraint = {}));
/** select columns of table "space_images" */
export var OrSpaceImagesSelectColumn;
(function (OrSpaceImagesSelectColumn) {
    /** column name */
    OrSpaceImagesSelectColumn["CreatedAt"] = "created_at";
    /** column name */
    OrSpaceImagesSelectColumn["Id"] = "id";
    /** column name */
    OrSpaceImagesSelectColumn["IsActive"] = "is_active";
    /** column name */
    OrSpaceImagesSelectColumn["ObjectKey"] = "object_key";
    /** column name */
    OrSpaceImagesSelectColumn["SpaceId"] = "space_id";
    /** column name */
    OrSpaceImagesSelectColumn["UpdatedAt"] = "updated_at";
})(OrSpaceImagesSelectColumn || (OrSpaceImagesSelectColumn = {}));
/** select "or_space_images_aggregate_bool_exp_bool_and_arguments_columns" columns of table "space_images" */
export var OrSpaceImagesSelectColumnOrSpaceImagesAggregateBoolExpBoolAndArgumentsColumns;
(function (OrSpaceImagesSelectColumnOrSpaceImagesAggregateBoolExpBoolAndArgumentsColumns) {
    /** column name */
    OrSpaceImagesSelectColumnOrSpaceImagesAggregateBoolExpBoolAndArgumentsColumns["IsActive"] = "is_active";
})(OrSpaceImagesSelectColumnOrSpaceImagesAggregateBoolExpBoolAndArgumentsColumns || (OrSpaceImagesSelectColumnOrSpaceImagesAggregateBoolExpBoolAndArgumentsColumns = {}));
/** select "or_space_images_aggregate_bool_exp_bool_or_arguments_columns" columns of table "space_images" */
export var OrSpaceImagesSelectColumnOrSpaceImagesAggregateBoolExpBoolOrArgumentsColumns;
(function (OrSpaceImagesSelectColumnOrSpaceImagesAggregateBoolExpBoolOrArgumentsColumns) {
    /** column name */
    OrSpaceImagesSelectColumnOrSpaceImagesAggregateBoolExpBoolOrArgumentsColumns["IsActive"] = "is_active";
})(OrSpaceImagesSelectColumnOrSpaceImagesAggregateBoolExpBoolOrArgumentsColumns || (OrSpaceImagesSelectColumnOrSpaceImagesAggregateBoolExpBoolOrArgumentsColumns = {}));
/** update columns of table "space_images" */
export var OrSpaceImagesUpdateColumn;
(function (OrSpaceImagesUpdateColumn) {
    /** column name */
    OrSpaceImagesUpdateColumn["CreatedAt"] = "created_at";
    /** column name */
    OrSpaceImagesUpdateColumn["Id"] = "id";
    /** column name */
    OrSpaceImagesUpdateColumn["IsActive"] = "is_active";
    /** column name */
    OrSpaceImagesUpdateColumn["ObjectKey"] = "object_key";
    /** column name */
    OrSpaceImagesUpdateColumn["SpaceId"] = "space_id";
    /** column name */
    OrSpaceImagesUpdateColumn["UpdatedAt"] = "updated_at";
})(OrSpaceImagesUpdateColumn || (OrSpaceImagesUpdateColumn = {}));
/** unique or primary key constraints on table "spaces" */
export var OrSpacesConstraint;
(function (OrSpacesConstraint) {
    /** unique or primary key constraint on columns "id" */
    OrSpacesConstraint["PkDbe542974aca57afcb60709d4c8"] = "PK_dbe542974aca57afcb60709d4c8";
})(OrSpacesConstraint || (OrSpacesConstraint = {}));
/** select columns of table "spaces" */
export var OrSpacesSelectColumn;
(function (OrSpacesSelectColumn) {
    /** column name */
    OrSpacesSelectColumn["Approver_1"] = "approver_1";
    /** column name */
    OrSpacesSelectColumn["Approver_2"] = "approver_2";
    /** column name */
    OrSpacesSelectColumn["Approver_3"] = "approver_3";
    /** column name */
    OrSpacesSelectColumn["Approver_4"] = "approver_4";
    /** column name */
    OrSpacesSelectColumn["Approver_5"] = "approver_5";
    /** column name */
    OrSpacesSelectColumn["CommonFeeCharge"] = "common_fee_charge";
    /** column name */
    OrSpacesSelectColumn["CreatedAt"] = "created_at";
    /** column name */
    OrSpacesSelectColumn["DimensionsArea"] = "dimensions_area";
    /** column name */
    OrSpacesSelectColumn["DimensionsLength"] = "dimensions_length";
    /** column name */
    OrSpacesSelectColumn["DimensionsWidth"] = "dimensions_width";
    /** column name */
    OrSpacesSelectColumn["ElectricityCharge"] = "electricity_charge";
    /** column name */
    OrSpacesSelectColumn["FixedElectricityCharge"] = "fixed_electricity_charge";
    /** column name */
    OrSpacesSelectColumn["FixedWaterCharge"] = "fixed_water_charge";
    /** column name */
    OrSpacesSelectColumn["Id"] = "id";
    /** column name */
    OrSpacesSelectColumn["InsuranceRental"] = "insurance_rental";
    /** column name */
    OrSpacesSelectColumn["LayoutPositions"] = "layout_positions";
    /** column name */
    OrSpacesSelectColumn["ManagementFee"] = "management_fee";
    /** column name */
    OrSpacesSelectColumn["RentalFixedAmount"] = "rental_fixed_amount";
    /** column name */
    OrSpacesSelectColumn["RentalPercentAmount"] = "rental_percent_amount";
    /** column name */
    OrSpacesSelectColumn["RentalType"] = "rental_type";
    /** column name */
    OrSpacesSelectColumn["SaleSupport"] = "sale_support";
    /** column name */
    OrSpacesSelectColumn["SpaceAlias"] = "space_alias";
    /** column name */
    OrSpacesSelectColumn["SpaceType"] = "space_type";
    /** column name */
    OrSpacesSelectColumn["StationId"] = "station_id";
    /** column name */
    OrSpacesSelectColumn["UpdatedAt"] = "updated_at";
    /** column name */
    OrSpacesSelectColumn["Uuid"] = "uuid";
    /** column name */
    OrSpacesSelectColumn["WastedWaterTreatmentCharge"] = "wasted_water_treatment_charge";
    /** column name */
    OrSpacesSelectColumn["WaterCharge"] = "water_charge";
})(OrSpacesSelectColumn || (OrSpacesSelectColumn = {}));
/** select "or_spaces_aggregate_bool_exp_avg_arguments_columns" columns of table "spaces" */
export var OrSpacesSelectColumnOrSpacesAggregateBoolExpAvgArgumentsColumns;
(function (OrSpacesSelectColumnOrSpacesAggregateBoolExpAvgArgumentsColumns) {
    /** column name */
    OrSpacesSelectColumnOrSpacesAggregateBoolExpAvgArgumentsColumns["CommonFeeCharge"] = "common_fee_charge";
    /** column name */
    OrSpacesSelectColumnOrSpacesAggregateBoolExpAvgArgumentsColumns["DimensionsArea"] = "dimensions_area";
    /** column name */
    OrSpacesSelectColumnOrSpacesAggregateBoolExpAvgArgumentsColumns["DimensionsLength"] = "dimensions_length";
    /** column name */
    OrSpacesSelectColumnOrSpacesAggregateBoolExpAvgArgumentsColumns["DimensionsWidth"] = "dimensions_width";
    /** column name */
    OrSpacesSelectColumnOrSpacesAggregateBoolExpAvgArgumentsColumns["ElectricityCharge"] = "electricity_charge";
    /** column name */
    OrSpacesSelectColumnOrSpacesAggregateBoolExpAvgArgumentsColumns["FixedElectricityCharge"] = "fixed_electricity_charge";
    /** column name */
    OrSpacesSelectColumnOrSpacesAggregateBoolExpAvgArgumentsColumns["FixedWaterCharge"] = "fixed_water_charge";
    /** column name */
    OrSpacesSelectColumnOrSpacesAggregateBoolExpAvgArgumentsColumns["InsuranceRental"] = "insurance_rental";
    /** column name */
    OrSpacesSelectColumnOrSpacesAggregateBoolExpAvgArgumentsColumns["ManagementFee"] = "management_fee";
    /** column name */
    OrSpacesSelectColumnOrSpacesAggregateBoolExpAvgArgumentsColumns["RentalFixedAmount"] = "rental_fixed_amount";
    /** column name */
    OrSpacesSelectColumnOrSpacesAggregateBoolExpAvgArgumentsColumns["RentalPercentAmount"] = "rental_percent_amount";
    /** column name */
    OrSpacesSelectColumnOrSpacesAggregateBoolExpAvgArgumentsColumns["WastedWaterTreatmentCharge"] = "wasted_water_treatment_charge";
    /** column name */
    OrSpacesSelectColumnOrSpacesAggregateBoolExpAvgArgumentsColumns["WaterCharge"] = "water_charge";
})(OrSpacesSelectColumnOrSpacesAggregateBoolExpAvgArgumentsColumns || (OrSpacesSelectColumnOrSpacesAggregateBoolExpAvgArgumentsColumns = {}));
/** select "or_spaces_aggregate_bool_exp_corr_arguments_columns" columns of table "spaces" */
export var OrSpacesSelectColumnOrSpacesAggregateBoolExpCorrArgumentsColumns;
(function (OrSpacesSelectColumnOrSpacesAggregateBoolExpCorrArgumentsColumns) {
    /** column name */
    OrSpacesSelectColumnOrSpacesAggregateBoolExpCorrArgumentsColumns["CommonFeeCharge"] = "common_fee_charge";
    /** column name */
    OrSpacesSelectColumnOrSpacesAggregateBoolExpCorrArgumentsColumns["DimensionsArea"] = "dimensions_area";
    /** column name */
    OrSpacesSelectColumnOrSpacesAggregateBoolExpCorrArgumentsColumns["DimensionsLength"] = "dimensions_length";
    /** column name */
    OrSpacesSelectColumnOrSpacesAggregateBoolExpCorrArgumentsColumns["DimensionsWidth"] = "dimensions_width";
    /** column name */
    OrSpacesSelectColumnOrSpacesAggregateBoolExpCorrArgumentsColumns["ElectricityCharge"] = "electricity_charge";
    /** column name */
    OrSpacesSelectColumnOrSpacesAggregateBoolExpCorrArgumentsColumns["FixedElectricityCharge"] = "fixed_electricity_charge";
    /** column name */
    OrSpacesSelectColumnOrSpacesAggregateBoolExpCorrArgumentsColumns["FixedWaterCharge"] = "fixed_water_charge";
    /** column name */
    OrSpacesSelectColumnOrSpacesAggregateBoolExpCorrArgumentsColumns["InsuranceRental"] = "insurance_rental";
    /** column name */
    OrSpacesSelectColumnOrSpacesAggregateBoolExpCorrArgumentsColumns["ManagementFee"] = "management_fee";
    /** column name */
    OrSpacesSelectColumnOrSpacesAggregateBoolExpCorrArgumentsColumns["RentalFixedAmount"] = "rental_fixed_amount";
    /** column name */
    OrSpacesSelectColumnOrSpacesAggregateBoolExpCorrArgumentsColumns["RentalPercentAmount"] = "rental_percent_amount";
    /** column name */
    OrSpacesSelectColumnOrSpacesAggregateBoolExpCorrArgumentsColumns["WastedWaterTreatmentCharge"] = "wasted_water_treatment_charge";
    /** column name */
    OrSpacesSelectColumnOrSpacesAggregateBoolExpCorrArgumentsColumns["WaterCharge"] = "water_charge";
})(OrSpacesSelectColumnOrSpacesAggregateBoolExpCorrArgumentsColumns || (OrSpacesSelectColumnOrSpacesAggregateBoolExpCorrArgumentsColumns = {}));
/** select "or_spaces_aggregate_bool_exp_covar_samp_arguments_columns" columns of table "spaces" */
export var OrSpacesSelectColumnOrSpacesAggregateBoolExpCovarSampArgumentsColumns;
(function (OrSpacesSelectColumnOrSpacesAggregateBoolExpCovarSampArgumentsColumns) {
    /** column name */
    OrSpacesSelectColumnOrSpacesAggregateBoolExpCovarSampArgumentsColumns["CommonFeeCharge"] = "common_fee_charge";
    /** column name */
    OrSpacesSelectColumnOrSpacesAggregateBoolExpCovarSampArgumentsColumns["DimensionsArea"] = "dimensions_area";
    /** column name */
    OrSpacesSelectColumnOrSpacesAggregateBoolExpCovarSampArgumentsColumns["DimensionsLength"] = "dimensions_length";
    /** column name */
    OrSpacesSelectColumnOrSpacesAggregateBoolExpCovarSampArgumentsColumns["DimensionsWidth"] = "dimensions_width";
    /** column name */
    OrSpacesSelectColumnOrSpacesAggregateBoolExpCovarSampArgumentsColumns["ElectricityCharge"] = "electricity_charge";
    /** column name */
    OrSpacesSelectColumnOrSpacesAggregateBoolExpCovarSampArgumentsColumns["FixedElectricityCharge"] = "fixed_electricity_charge";
    /** column name */
    OrSpacesSelectColumnOrSpacesAggregateBoolExpCovarSampArgumentsColumns["FixedWaterCharge"] = "fixed_water_charge";
    /** column name */
    OrSpacesSelectColumnOrSpacesAggregateBoolExpCovarSampArgumentsColumns["InsuranceRental"] = "insurance_rental";
    /** column name */
    OrSpacesSelectColumnOrSpacesAggregateBoolExpCovarSampArgumentsColumns["ManagementFee"] = "management_fee";
    /** column name */
    OrSpacesSelectColumnOrSpacesAggregateBoolExpCovarSampArgumentsColumns["RentalFixedAmount"] = "rental_fixed_amount";
    /** column name */
    OrSpacesSelectColumnOrSpacesAggregateBoolExpCovarSampArgumentsColumns["RentalPercentAmount"] = "rental_percent_amount";
    /** column name */
    OrSpacesSelectColumnOrSpacesAggregateBoolExpCovarSampArgumentsColumns["WastedWaterTreatmentCharge"] = "wasted_water_treatment_charge";
    /** column name */
    OrSpacesSelectColumnOrSpacesAggregateBoolExpCovarSampArgumentsColumns["WaterCharge"] = "water_charge";
})(OrSpacesSelectColumnOrSpacesAggregateBoolExpCovarSampArgumentsColumns || (OrSpacesSelectColumnOrSpacesAggregateBoolExpCovarSampArgumentsColumns = {}));
/** select "or_spaces_aggregate_bool_exp_max_arguments_columns" columns of table "spaces" */
export var OrSpacesSelectColumnOrSpacesAggregateBoolExpMaxArgumentsColumns;
(function (OrSpacesSelectColumnOrSpacesAggregateBoolExpMaxArgumentsColumns) {
    /** column name */
    OrSpacesSelectColumnOrSpacesAggregateBoolExpMaxArgumentsColumns["CommonFeeCharge"] = "common_fee_charge";
    /** column name */
    OrSpacesSelectColumnOrSpacesAggregateBoolExpMaxArgumentsColumns["DimensionsArea"] = "dimensions_area";
    /** column name */
    OrSpacesSelectColumnOrSpacesAggregateBoolExpMaxArgumentsColumns["DimensionsLength"] = "dimensions_length";
    /** column name */
    OrSpacesSelectColumnOrSpacesAggregateBoolExpMaxArgumentsColumns["DimensionsWidth"] = "dimensions_width";
    /** column name */
    OrSpacesSelectColumnOrSpacesAggregateBoolExpMaxArgumentsColumns["ElectricityCharge"] = "electricity_charge";
    /** column name */
    OrSpacesSelectColumnOrSpacesAggregateBoolExpMaxArgumentsColumns["FixedElectricityCharge"] = "fixed_electricity_charge";
    /** column name */
    OrSpacesSelectColumnOrSpacesAggregateBoolExpMaxArgumentsColumns["FixedWaterCharge"] = "fixed_water_charge";
    /** column name */
    OrSpacesSelectColumnOrSpacesAggregateBoolExpMaxArgumentsColumns["InsuranceRental"] = "insurance_rental";
    /** column name */
    OrSpacesSelectColumnOrSpacesAggregateBoolExpMaxArgumentsColumns["ManagementFee"] = "management_fee";
    /** column name */
    OrSpacesSelectColumnOrSpacesAggregateBoolExpMaxArgumentsColumns["RentalFixedAmount"] = "rental_fixed_amount";
    /** column name */
    OrSpacesSelectColumnOrSpacesAggregateBoolExpMaxArgumentsColumns["RentalPercentAmount"] = "rental_percent_amount";
    /** column name */
    OrSpacesSelectColumnOrSpacesAggregateBoolExpMaxArgumentsColumns["WastedWaterTreatmentCharge"] = "wasted_water_treatment_charge";
    /** column name */
    OrSpacesSelectColumnOrSpacesAggregateBoolExpMaxArgumentsColumns["WaterCharge"] = "water_charge";
})(OrSpacesSelectColumnOrSpacesAggregateBoolExpMaxArgumentsColumns || (OrSpacesSelectColumnOrSpacesAggregateBoolExpMaxArgumentsColumns = {}));
/** select "or_spaces_aggregate_bool_exp_min_arguments_columns" columns of table "spaces" */
export var OrSpacesSelectColumnOrSpacesAggregateBoolExpMinArgumentsColumns;
(function (OrSpacesSelectColumnOrSpacesAggregateBoolExpMinArgumentsColumns) {
    /** column name */
    OrSpacesSelectColumnOrSpacesAggregateBoolExpMinArgumentsColumns["CommonFeeCharge"] = "common_fee_charge";
    /** column name */
    OrSpacesSelectColumnOrSpacesAggregateBoolExpMinArgumentsColumns["DimensionsArea"] = "dimensions_area";
    /** column name */
    OrSpacesSelectColumnOrSpacesAggregateBoolExpMinArgumentsColumns["DimensionsLength"] = "dimensions_length";
    /** column name */
    OrSpacesSelectColumnOrSpacesAggregateBoolExpMinArgumentsColumns["DimensionsWidth"] = "dimensions_width";
    /** column name */
    OrSpacesSelectColumnOrSpacesAggregateBoolExpMinArgumentsColumns["ElectricityCharge"] = "electricity_charge";
    /** column name */
    OrSpacesSelectColumnOrSpacesAggregateBoolExpMinArgumentsColumns["FixedElectricityCharge"] = "fixed_electricity_charge";
    /** column name */
    OrSpacesSelectColumnOrSpacesAggregateBoolExpMinArgumentsColumns["FixedWaterCharge"] = "fixed_water_charge";
    /** column name */
    OrSpacesSelectColumnOrSpacesAggregateBoolExpMinArgumentsColumns["InsuranceRental"] = "insurance_rental";
    /** column name */
    OrSpacesSelectColumnOrSpacesAggregateBoolExpMinArgumentsColumns["ManagementFee"] = "management_fee";
    /** column name */
    OrSpacesSelectColumnOrSpacesAggregateBoolExpMinArgumentsColumns["RentalFixedAmount"] = "rental_fixed_amount";
    /** column name */
    OrSpacesSelectColumnOrSpacesAggregateBoolExpMinArgumentsColumns["RentalPercentAmount"] = "rental_percent_amount";
    /** column name */
    OrSpacesSelectColumnOrSpacesAggregateBoolExpMinArgumentsColumns["WastedWaterTreatmentCharge"] = "wasted_water_treatment_charge";
    /** column name */
    OrSpacesSelectColumnOrSpacesAggregateBoolExpMinArgumentsColumns["WaterCharge"] = "water_charge";
})(OrSpacesSelectColumnOrSpacesAggregateBoolExpMinArgumentsColumns || (OrSpacesSelectColumnOrSpacesAggregateBoolExpMinArgumentsColumns = {}));
/** select "or_spaces_aggregate_bool_exp_stddev_samp_arguments_columns" columns of table "spaces" */
export var OrSpacesSelectColumnOrSpacesAggregateBoolExpStddevSampArgumentsColumns;
(function (OrSpacesSelectColumnOrSpacesAggregateBoolExpStddevSampArgumentsColumns) {
    /** column name */
    OrSpacesSelectColumnOrSpacesAggregateBoolExpStddevSampArgumentsColumns["CommonFeeCharge"] = "common_fee_charge";
    /** column name */
    OrSpacesSelectColumnOrSpacesAggregateBoolExpStddevSampArgumentsColumns["DimensionsArea"] = "dimensions_area";
    /** column name */
    OrSpacesSelectColumnOrSpacesAggregateBoolExpStddevSampArgumentsColumns["DimensionsLength"] = "dimensions_length";
    /** column name */
    OrSpacesSelectColumnOrSpacesAggregateBoolExpStddevSampArgumentsColumns["DimensionsWidth"] = "dimensions_width";
    /** column name */
    OrSpacesSelectColumnOrSpacesAggregateBoolExpStddevSampArgumentsColumns["ElectricityCharge"] = "electricity_charge";
    /** column name */
    OrSpacesSelectColumnOrSpacesAggregateBoolExpStddevSampArgumentsColumns["FixedElectricityCharge"] = "fixed_electricity_charge";
    /** column name */
    OrSpacesSelectColumnOrSpacesAggregateBoolExpStddevSampArgumentsColumns["FixedWaterCharge"] = "fixed_water_charge";
    /** column name */
    OrSpacesSelectColumnOrSpacesAggregateBoolExpStddevSampArgumentsColumns["InsuranceRental"] = "insurance_rental";
    /** column name */
    OrSpacesSelectColumnOrSpacesAggregateBoolExpStddevSampArgumentsColumns["ManagementFee"] = "management_fee";
    /** column name */
    OrSpacesSelectColumnOrSpacesAggregateBoolExpStddevSampArgumentsColumns["RentalFixedAmount"] = "rental_fixed_amount";
    /** column name */
    OrSpacesSelectColumnOrSpacesAggregateBoolExpStddevSampArgumentsColumns["RentalPercentAmount"] = "rental_percent_amount";
    /** column name */
    OrSpacesSelectColumnOrSpacesAggregateBoolExpStddevSampArgumentsColumns["WastedWaterTreatmentCharge"] = "wasted_water_treatment_charge";
    /** column name */
    OrSpacesSelectColumnOrSpacesAggregateBoolExpStddevSampArgumentsColumns["WaterCharge"] = "water_charge";
})(OrSpacesSelectColumnOrSpacesAggregateBoolExpStddevSampArgumentsColumns || (OrSpacesSelectColumnOrSpacesAggregateBoolExpStddevSampArgumentsColumns = {}));
/** select "or_spaces_aggregate_bool_exp_sum_arguments_columns" columns of table "spaces" */
export var OrSpacesSelectColumnOrSpacesAggregateBoolExpSumArgumentsColumns;
(function (OrSpacesSelectColumnOrSpacesAggregateBoolExpSumArgumentsColumns) {
    /** column name */
    OrSpacesSelectColumnOrSpacesAggregateBoolExpSumArgumentsColumns["CommonFeeCharge"] = "common_fee_charge";
    /** column name */
    OrSpacesSelectColumnOrSpacesAggregateBoolExpSumArgumentsColumns["DimensionsArea"] = "dimensions_area";
    /** column name */
    OrSpacesSelectColumnOrSpacesAggregateBoolExpSumArgumentsColumns["DimensionsLength"] = "dimensions_length";
    /** column name */
    OrSpacesSelectColumnOrSpacesAggregateBoolExpSumArgumentsColumns["DimensionsWidth"] = "dimensions_width";
    /** column name */
    OrSpacesSelectColumnOrSpacesAggregateBoolExpSumArgumentsColumns["ElectricityCharge"] = "electricity_charge";
    /** column name */
    OrSpacesSelectColumnOrSpacesAggregateBoolExpSumArgumentsColumns["FixedElectricityCharge"] = "fixed_electricity_charge";
    /** column name */
    OrSpacesSelectColumnOrSpacesAggregateBoolExpSumArgumentsColumns["FixedWaterCharge"] = "fixed_water_charge";
    /** column name */
    OrSpacesSelectColumnOrSpacesAggregateBoolExpSumArgumentsColumns["InsuranceRental"] = "insurance_rental";
    /** column name */
    OrSpacesSelectColumnOrSpacesAggregateBoolExpSumArgumentsColumns["ManagementFee"] = "management_fee";
    /** column name */
    OrSpacesSelectColumnOrSpacesAggregateBoolExpSumArgumentsColumns["RentalFixedAmount"] = "rental_fixed_amount";
    /** column name */
    OrSpacesSelectColumnOrSpacesAggregateBoolExpSumArgumentsColumns["RentalPercentAmount"] = "rental_percent_amount";
    /** column name */
    OrSpacesSelectColumnOrSpacesAggregateBoolExpSumArgumentsColumns["WastedWaterTreatmentCharge"] = "wasted_water_treatment_charge";
    /** column name */
    OrSpacesSelectColumnOrSpacesAggregateBoolExpSumArgumentsColumns["WaterCharge"] = "water_charge";
})(OrSpacesSelectColumnOrSpacesAggregateBoolExpSumArgumentsColumns || (OrSpacesSelectColumnOrSpacesAggregateBoolExpSumArgumentsColumns = {}));
/** select "or_spaces_aggregate_bool_exp_var_samp_arguments_columns" columns of table "spaces" */
export var OrSpacesSelectColumnOrSpacesAggregateBoolExpVarSampArgumentsColumns;
(function (OrSpacesSelectColumnOrSpacesAggregateBoolExpVarSampArgumentsColumns) {
    /** column name */
    OrSpacesSelectColumnOrSpacesAggregateBoolExpVarSampArgumentsColumns["CommonFeeCharge"] = "common_fee_charge";
    /** column name */
    OrSpacesSelectColumnOrSpacesAggregateBoolExpVarSampArgumentsColumns["DimensionsArea"] = "dimensions_area";
    /** column name */
    OrSpacesSelectColumnOrSpacesAggregateBoolExpVarSampArgumentsColumns["DimensionsLength"] = "dimensions_length";
    /** column name */
    OrSpacesSelectColumnOrSpacesAggregateBoolExpVarSampArgumentsColumns["DimensionsWidth"] = "dimensions_width";
    /** column name */
    OrSpacesSelectColumnOrSpacesAggregateBoolExpVarSampArgumentsColumns["ElectricityCharge"] = "electricity_charge";
    /** column name */
    OrSpacesSelectColumnOrSpacesAggregateBoolExpVarSampArgumentsColumns["FixedElectricityCharge"] = "fixed_electricity_charge";
    /** column name */
    OrSpacesSelectColumnOrSpacesAggregateBoolExpVarSampArgumentsColumns["FixedWaterCharge"] = "fixed_water_charge";
    /** column name */
    OrSpacesSelectColumnOrSpacesAggregateBoolExpVarSampArgumentsColumns["InsuranceRental"] = "insurance_rental";
    /** column name */
    OrSpacesSelectColumnOrSpacesAggregateBoolExpVarSampArgumentsColumns["ManagementFee"] = "management_fee";
    /** column name */
    OrSpacesSelectColumnOrSpacesAggregateBoolExpVarSampArgumentsColumns["RentalFixedAmount"] = "rental_fixed_amount";
    /** column name */
    OrSpacesSelectColumnOrSpacesAggregateBoolExpVarSampArgumentsColumns["RentalPercentAmount"] = "rental_percent_amount";
    /** column name */
    OrSpacesSelectColumnOrSpacesAggregateBoolExpVarSampArgumentsColumns["WastedWaterTreatmentCharge"] = "wasted_water_treatment_charge";
    /** column name */
    OrSpacesSelectColumnOrSpacesAggregateBoolExpVarSampArgumentsColumns["WaterCharge"] = "water_charge";
})(OrSpacesSelectColumnOrSpacesAggregateBoolExpVarSampArgumentsColumns || (OrSpacesSelectColumnOrSpacesAggregateBoolExpVarSampArgumentsColumns = {}));
/** update columns of table "spaces" */
export var OrSpacesUpdateColumn;
(function (OrSpacesUpdateColumn) {
    /** column name */
    OrSpacesUpdateColumn["Approver_1"] = "approver_1";
    /** column name */
    OrSpacesUpdateColumn["Approver_2"] = "approver_2";
    /** column name */
    OrSpacesUpdateColumn["Approver_3"] = "approver_3";
    /** column name */
    OrSpacesUpdateColumn["Approver_4"] = "approver_4";
    /** column name */
    OrSpacesUpdateColumn["Approver_5"] = "approver_5";
    /** column name */
    OrSpacesUpdateColumn["CommonFeeCharge"] = "common_fee_charge";
    /** column name */
    OrSpacesUpdateColumn["CreatedAt"] = "created_at";
    /** column name */
    OrSpacesUpdateColumn["DimensionsArea"] = "dimensions_area";
    /** column name */
    OrSpacesUpdateColumn["DimensionsLength"] = "dimensions_length";
    /** column name */
    OrSpacesUpdateColumn["DimensionsWidth"] = "dimensions_width";
    /** column name */
    OrSpacesUpdateColumn["ElectricityCharge"] = "electricity_charge";
    /** column name */
    OrSpacesUpdateColumn["FixedElectricityCharge"] = "fixed_electricity_charge";
    /** column name */
    OrSpacesUpdateColumn["FixedWaterCharge"] = "fixed_water_charge";
    /** column name */
    OrSpacesUpdateColumn["Id"] = "id";
    /** column name */
    OrSpacesUpdateColumn["InsuranceRental"] = "insurance_rental";
    /** column name */
    OrSpacesUpdateColumn["LayoutPositions"] = "layout_positions";
    /** column name */
    OrSpacesUpdateColumn["ManagementFee"] = "management_fee";
    /** column name */
    OrSpacesUpdateColumn["RentalFixedAmount"] = "rental_fixed_amount";
    /** column name */
    OrSpacesUpdateColumn["RentalPercentAmount"] = "rental_percent_amount";
    /** column name */
    OrSpacesUpdateColumn["RentalType"] = "rental_type";
    /** column name */
    OrSpacesUpdateColumn["SaleSupport"] = "sale_support";
    /** column name */
    OrSpacesUpdateColumn["SpaceAlias"] = "space_alias";
    /** column name */
    OrSpacesUpdateColumn["SpaceType"] = "space_type";
    /** column name */
    OrSpacesUpdateColumn["StationId"] = "station_id";
    /** column name */
    OrSpacesUpdateColumn["UpdatedAt"] = "updated_at";
    /** column name */
    OrSpacesUpdateColumn["Uuid"] = "uuid";
    /** column name */
    OrSpacesUpdateColumn["WastedWaterTreatmentCharge"] = "wasted_water_treatment_charge";
    /** column name */
    OrSpacesUpdateColumn["WaterCharge"] = "water_charge";
})(OrSpacesUpdateColumn || (OrSpacesUpdateColumn = {}));
/** unique or primary key constraints on table "station_images" */
export var OrStationImagesConstraint;
(function (OrStationImagesConstraint) {
    /** unique or primary key constraint on columns "id" */
    OrStationImagesConstraint["Pk_30ff94018592eb92a91110ed147"] = "PK_30ff94018592eb92a91110ed147";
})(OrStationImagesConstraint || (OrStationImagesConstraint = {}));
/** select columns of table "station_images" */
export var OrStationImagesSelectColumn;
(function (OrStationImagesSelectColumn) {
    /** column name */
    OrStationImagesSelectColumn["CreatedAt"] = "created_at";
    /** column name */
    OrStationImagesSelectColumn["Id"] = "id";
    /** column name */
    OrStationImagesSelectColumn["IsActive"] = "is_active";
    /** column name */
    OrStationImagesSelectColumn["ObjectKey"] = "object_key";
    /** column name */
    OrStationImagesSelectColumn["StationId"] = "station_id";
    /** column name */
    OrStationImagesSelectColumn["UpdatedAt"] = "updated_at";
})(OrStationImagesSelectColumn || (OrStationImagesSelectColumn = {}));
/** select "or_station_images_aggregate_bool_exp_bool_and_arguments_columns" columns of table "station_images" */
export var OrStationImagesSelectColumnOrStationImagesAggregateBoolExpBoolAndArgumentsColumns;
(function (OrStationImagesSelectColumnOrStationImagesAggregateBoolExpBoolAndArgumentsColumns) {
    /** column name */
    OrStationImagesSelectColumnOrStationImagesAggregateBoolExpBoolAndArgumentsColumns["IsActive"] = "is_active";
})(OrStationImagesSelectColumnOrStationImagesAggregateBoolExpBoolAndArgumentsColumns || (OrStationImagesSelectColumnOrStationImagesAggregateBoolExpBoolAndArgumentsColumns = {}));
/** select "or_station_images_aggregate_bool_exp_bool_or_arguments_columns" columns of table "station_images" */
export var OrStationImagesSelectColumnOrStationImagesAggregateBoolExpBoolOrArgumentsColumns;
(function (OrStationImagesSelectColumnOrStationImagesAggregateBoolExpBoolOrArgumentsColumns) {
    /** column name */
    OrStationImagesSelectColumnOrStationImagesAggregateBoolExpBoolOrArgumentsColumns["IsActive"] = "is_active";
})(OrStationImagesSelectColumnOrStationImagesAggregateBoolExpBoolOrArgumentsColumns || (OrStationImagesSelectColumnOrStationImagesAggregateBoolExpBoolOrArgumentsColumns = {}));
/** update columns of table "station_images" */
export var OrStationImagesUpdateColumn;
(function (OrStationImagesUpdateColumn) {
    /** column name */
    OrStationImagesUpdateColumn["CreatedAt"] = "created_at";
    /** column name */
    OrStationImagesUpdateColumn["Id"] = "id";
    /** column name */
    OrStationImagesUpdateColumn["IsActive"] = "is_active";
    /** column name */
    OrStationImagesUpdateColumn["ObjectKey"] = "object_key";
    /** column name */
    OrStationImagesUpdateColumn["StationId"] = "station_id";
    /** column name */
    OrStationImagesUpdateColumn["UpdatedAt"] = "updated_at";
})(OrStationImagesUpdateColumn || (OrStationImagesUpdateColumn = {}));
/** unique or primary key constraints on table "stations" */
export var OrStationsConstraint;
(function (OrStationsConstraint) {
    /** unique or primary key constraint on columns "id" */
    OrStationsConstraint["PkF047974bd453c85b08bab349367"] = "PK_f047974bd453c85b08bab349367";
})(OrStationsConstraint || (OrStationsConstraint = {}));
/** select columns of table "stations" */
export var OrStationsSelectColumn;
(function (OrStationsSelectColumn) {
    /** column name */
    OrStationsSelectColumn["Address"] = "address";
    /** column name */
    OrStationsSelectColumn["AmphoeCode"] = "amphoe_code";
    /** column name */
    OrStationsSelectColumn["CadFileKey"] = "cad_file_key";
    /** column name */
    OrStationsSelectColumn["CreatedAt"] = "created_at";
    /** column name */
    OrStationsSelectColumn["GenericTenantAndDealerPublishType"] = "generic_tenant_and_dealer_publish_type";
    /** column name */
    OrStationsSelectColumn["Id"] = "id";
    /** column name */
    OrStationsSelectColumn["IsActive"] = "is_active";
    /** column name */
    OrStationsSelectColumn["Latitude"] = "latitude";
    /** column name */
    OrStationsSelectColumn["LayoutFileKey"] = "layout_file_key";
    /** column name */
    OrStationsSelectColumn["Longitude"] = "longitude";
    /** column name */
    OrStationsSelectColumn["OpenDate"] = "open_date";
    /** column name */
    OrStationsSelectColumn["OrBrandAndOrPartnerPublishType"] = "or_brand_and_or_partner_publish_type";
    /** column name */
    OrStationsSelectColumn["ParkingLot"] = "parking_lot";
    /** column name */
    OrStationsSelectColumn["PassedCarsPerDay"] = "passed_cars_per_day";
    /** column name */
    OrStationsSelectColumn["Pbl"] = "pbl";
    /** column name */
    OrStationsSelectColumn["ProvinceCode"] = "province_code";
    /** column name */
    OrStationsSelectColumn["RegionCode"] = "region_code";
    /** column name */
    OrStationsSelectColumn["Status"] = "status";
    /** column name */
    OrStationsSelectColumn["TicketsPerDay"] = "tickets_per_day";
    /** column name */
    OrStationsSelectColumn["Tier"] = "tier";
    /** column name */
    OrStationsSelectColumn["Type"] = "type";
    /** column name */
    OrStationsSelectColumn["UpdatedAt"] = "updated_at";
    /** column name */
    OrStationsSelectColumn["Uuid"] = "uuid";
})(OrStationsSelectColumn || (OrStationsSelectColumn = {}));
/** update columns of table "stations" */
export var OrStationsUpdateColumn;
(function (OrStationsUpdateColumn) {
    /** column name */
    OrStationsUpdateColumn["Address"] = "address";
    /** column name */
    OrStationsUpdateColumn["AmphoeCode"] = "amphoe_code";
    /** column name */
    OrStationsUpdateColumn["CadFileKey"] = "cad_file_key";
    /** column name */
    OrStationsUpdateColumn["CreatedAt"] = "created_at";
    /** column name */
    OrStationsUpdateColumn["GenericTenantAndDealerPublishType"] = "generic_tenant_and_dealer_publish_type";
    /** column name */
    OrStationsUpdateColumn["Id"] = "id";
    /** column name */
    OrStationsUpdateColumn["IsActive"] = "is_active";
    /** column name */
    OrStationsUpdateColumn["Latitude"] = "latitude";
    /** column name */
    OrStationsUpdateColumn["LayoutFileKey"] = "layout_file_key";
    /** column name */
    OrStationsUpdateColumn["Longitude"] = "longitude";
    /** column name */
    OrStationsUpdateColumn["OpenDate"] = "open_date";
    /** column name */
    OrStationsUpdateColumn["OrBrandAndOrPartnerPublishType"] = "or_brand_and_or_partner_publish_type";
    /** column name */
    OrStationsUpdateColumn["ParkingLot"] = "parking_lot";
    /** column name */
    OrStationsUpdateColumn["PassedCarsPerDay"] = "passed_cars_per_day";
    /** column name */
    OrStationsUpdateColumn["Pbl"] = "pbl";
    /** column name */
    OrStationsUpdateColumn["ProvinceCode"] = "province_code";
    /** column name */
    OrStationsUpdateColumn["RegionCode"] = "region_code";
    /** column name */
    OrStationsUpdateColumn["Status"] = "status";
    /** column name */
    OrStationsUpdateColumn["TicketsPerDay"] = "tickets_per_day";
    /** column name */
    OrStationsUpdateColumn["Tier"] = "tier";
    /** column name */
    OrStationsUpdateColumn["Type"] = "type";
    /** column name */
    OrStationsUpdateColumn["UpdatedAt"] = "updated_at";
    /** column name */
    OrStationsUpdateColumn["Uuid"] = "uuid";
})(OrStationsUpdateColumn || (OrStationsUpdateColumn = {}));
/** column ordering options */
export var OrderBy;
(function (OrderBy) {
    /** in ascending order, nulls last */
    OrderBy["Asc"] = "asc";
    /** in ascending order, nulls first */
    OrderBy["AscNullsFirst"] = "asc_nulls_first";
    /** in ascending order, nulls last */
    OrderBy["AscNullsLast"] = "asc_nulls_last";
    /** in descending order, nulls first */
    OrderBy["Desc"] = "desc";
    /** in descending order, nulls first */
    OrderBy["DescNullsFirst"] = "desc_nulls_first";
    /** in descending order, nulls last */
    OrderBy["DescNullsLast"] = "desc_nulls_last";
})(OrderBy || (OrderBy = {}));
/** unique or primary key constraints on table "permissions" */
export var PermissionsConstraint;
(function (PermissionsConstraint) {
    /** unique or primary key constraint on columns "id" */
    PermissionsConstraint["PermissionsPkey"] = "permissions_pkey";
})(PermissionsConstraint || (PermissionsConstraint = {}));
/** select columns of table "permissions" */
export var PermissionsSelectColumn;
(function (PermissionsSelectColumn) {
    /** column name */
    PermissionsSelectColumn["CreatedAt"] = "created_at";
    /** column name */
    PermissionsSelectColumn["Description"] = "description";
    /** column name */
    PermissionsSelectColumn["Id"] = "id";
    /** column name */
    PermissionsSelectColumn["Name"] = "name";
    /** column name */
    PermissionsSelectColumn["UpdatedAt"] = "updated_at";
})(PermissionsSelectColumn || (PermissionsSelectColumn = {}));
/** update columns of table "permissions" */
export var PermissionsUpdateColumn;
(function (PermissionsUpdateColumn) {
    /** column name */
    PermissionsUpdateColumn["CreatedAt"] = "created_at";
    /** column name */
    PermissionsUpdateColumn["Description"] = "description";
    /** column name */
    PermissionsUpdateColumn["Id"] = "id";
    /** column name */
    PermissionsUpdateColumn["Name"] = "name";
    /** column name */
    PermissionsUpdateColumn["UpdatedAt"] = "updated_at";
})(PermissionsUpdateColumn || (PermissionsUpdateColumn = {}));
/** unique or primary key constraints on table "phone_number_verifications" */
export var PhoneNumberVerificationsConstraint;
(function (PhoneNumberVerificationsConstraint) {
    /** unique or primary key constraint on columns "user_id", "phone_number", "organization_id" */
    PhoneNumberVerificationsConstraint["PhoneNumberVerificationsUserIdPhoneNumberOrganizationId"] = "phone_number_verifications_user_id_phone_number_organization_id";
    /** unique or primary key constraint on columns "id" */
    PhoneNumberVerificationsConstraint["TelephoneNumberVerificationsPkey"] = "telephone_number_verifications_pkey";
})(PhoneNumberVerificationsConstraint || (PhoneNumberVerificationsConstraint = {}));
/** select columns of table "phone_number_verifications" */
export var PhoneNumberVerificationsSelectColumn;
(function (PhoneNumberVerificationsSelectColumn) {
    /** column name */
    PhoneNumberVerificationsSelectColumn["CreatedAt"] = "created_at";
    /** column name */
    PhoneNumberVerificationsSelectColumn["Id"] = "id";
    /** column name */
    PhoneNumberVerificationsSelectColumn["OrganizationId"] = "organization_id";
    /** column name */
    PhoneNumberVerificationsSelectColumn["PhoneNumber"] = "phone_number";
    /** column name */
    PhoneNumberVerificationsSelectColumn["Refno"] = "refno";
    /** column name */
    PhoneNumberVerificationsSelectColumn["Token"] = "token";
    /** column name */
    PhoneNumberVerificationsSelectColumn["UpdatedAt"] = "updated_at";
    /** column name */
    PhoneNumberVerificationsSelectColumn["UserId"] = "user_id";
    /** column name */
    PhoneNumberVerificationsSelectColumn["VerifiedAt"] = "verified_at";
})(PhoneNumberVerificationsSelectColumn || (PhoneNumberVerificationsSelectColumn = {}));
/** update columns of table "phone_number_verifications" */
export var PhoneNumberVerificationsUpdateColumn;
(function (PhoneNumberVerificationsUpdateColumn) {
    /** column name */
    PhoneNumberVerificationsUpdateColumn["CreatedAt"] = "created_at";
    /** column name */
    PhoneNumberVerificationsUpdateColumn["Id"] = "id";
    /** column name */
    PhoneNumberVerificationsUpdateColumn["OrganizationId"] = "organization_id";
    /** column name */
    PhoneNumberVerificationsUpdateColumn["PhoneNumber"] = "phone_number";
    /** column name */
    PhoneNumberVerificationsUpdateColumn["Refno"] = "refno";
    /** column name */
    PhoneNumberVerificationsUpdateColumn["Token"] = "token";
    /** column name */
    PhoneNumberVerificationsUpdateColumn["UpdatedAt"] = "updated_at";
    /** column name */
    PhoneNumberVerificationsUpdateColumn["UserId"] = "user_id";
    /** column name */
    PhoneNumberVerificationsUpdateColumn["VerifiedAt"] = "verified_at";
})(PhoneNumberVerificationsUpdateColumn || (PhoneNumberVerificationsUpdateColumn = {}));
/** unique or primary key constraints on table "processes" */
export var ProcessesConstraint;
(function (ProcessesConstraint) {
    /** unique or primary key constraint on columns "name" */
    ProcessesConstraint["ProcessesNameKey"] = "processes_name_key";
    /** unique or primary key constraint on columns "id" */
    ProcessesConstraint["ProcessesPkey"] = "processes_pkey";
    /** unique or primary key constraint on columns "type", "user_group_id" */
    ProcessesConstraint["ProcessesUserGroupIdTypeKey"] = "processes_user_group_id_type_key";
})(ProcessesConstraint || (ProcessesConstraint = {}));
/** select columns of table "processes" */
export var ProcessesSelectColumn;
(function (ProcessesSelectColumn) {
    /** column name */
    ProcessesSelectColumn["CreatedAt"] = "created_at";
    /** column name */
    ProcessesSelectColumn["CreatedBy"] = "created_by";
    /** column name */
    ProcessesSelectColumn["ExternalUrl"] = "external_url";
    /** column name */
    ProcessesSelectColumn["Id"] = "id";
    /** column name */
    ProcessesSelectColumn["Name"] = "name";
    /** column name */
    ProcessesSelectColumn["Schema"] = "schema";
    /** column name */
    ProcessesSelectColumn["Type"] = "type";
    /** column name */
    ProcessesSelectColumn["Uischema"] = "uischema";
    /** column name */
    ProcessesSelectColumn["UpdatedAt"] = "updated_at";
    /** column name */
    ProcessesSelectColumn["UserGroupId"] = "user_group_id";
})(ProcessesSelectColumn || (ProcessesSelectColumn = {}));
/** update columns of table "processes" */
export var ProcessesUpdateColumn;
(function (ProcessesUpdateColumn) {
    /** column name */
    ProcessesUpdateColumn["CreatedAt"] = "created_at";
    /** column name */
    ProcessesUpdateColumn["CreatedBy"] = "created_by";
    /** column name */
    ProcessesUpdateColumn["ExternalUrl"] = "external_url";
    /** column name */
    ProcessesUpdateColumn["Id"] = "id";
    /** column name */
    ProcessesUpdateColumn["Name"] = "name";
    /** column name */
    ProcessesUpdateColumn["Schema"] = "schema";
    /** column name */
    ProcessesUpdateColumn["Type"] = "type";
    /** column name */
    ProcessesUpdateColumn["Uischema"] = "uischema";
    /** column name */
    ProcessesUpdateColumn["UpdatedAt"] = "updated_at";
    /** column name */
    ProcessesUpdateColumn["UserGroupId"] = "user_group_id";
})(ProcessesUpdateColumn || (ProcessesUpdateColumn = {}));
/** unique or primary key constraints on table "profiles" */
export var ProfilesConstraint;
(function (ProfilesConstraint) {
    /** unique or primary key constraint on columns "auth0_id", "auth0_tenant_name" */
    ProfilesConstraint["ProfilesAuth0IdAuth0TenantNameKey"] = "profiles_auth0_id_auth0_tenant_name_key";
    /** unique or primary key constraint on columns "id" */
    ProfilesConstraint["ProfilesPkey"] = "profiles_pkey";
})(ProfilesConstraint || (ProfilesConstraint = {}));
/** select columns of table "profiles" */
export var ProfilesSelectColumn;
(function (ProfilesSelectColumn) {
    /** column name */
    ProfilesSelectColumn["Auth0Id"] = "auth0_id";
    /** column name */
    ProfilesSelectColumn["Auth0TenantName"] = "auth0_tenant_name";
    /** column name */
    ProfilesSelectColumn["ConnectionStrategy"] = "connection_strategy";
    /** column name */
    ProfilesSelectColumn["CreatedAt"] = "created_at";
    /** column name */
    ProfilesSelectColumn["Data"] = "data";
    /** column name */
    ProfilesSelectColumn["Email"] = "email";
    /** column name */
    ProfilesSelectColumn["Id"] = "id";
    /** column name */
    ProfilesSelectColumn["UpdatedAt"] = "updated_at";
    /** column name */
    ProfilesSelectColumn["UserId"] = "user_id";
})(ProfilesSelectColumn || (ProfilesSelectColumn = {}));
/** update columns of table "profiles" */
export var ProfilesUpdateColumn;
(function (ProfilesUpdateColumn) {
    /** column name */
    ProfilesUpdateColumn["Auth0Id"] = "auth0_id";
    /** column name */
    ProfilesUpdateColumn["Auth0TenantName"] = "auth0_tenant_name";
    /** column name */
    ProfilesUpdateColumn["ConnectionStrategy"] = "connection_strategy";
    /** column name */
    ProfilesUpdateColumn["CreatedAt"] = "created_at";
    /** column name */
    ProfilesUpdateColumn["Data"] = "data";
    /** column name */
    ProfilesUpdateColumn["Email"] = "email";
    /** column name */
    ProfilesUpdateColumn["Id"] = "id";
    /** column name */
    ProfilesUpdateColumn["UpdatedAt"] = "updated_at";
    /** column name */
    ProfilesUpdateColumn["UserId"] = "user_id";
})(ProfilesUpdateColumn || (ProfilesUpdateColumn = {}));
/** unique or primary key constraints on table "raw_invites" */
export var RawInvitesConstraint;
(function (RawInvitesConstraint) {
    /** unique or primary key constraint on columns "id" */
    RawInvitesConstraint["RawInvitesPkey"] = "raw_invites_pkey";
})(RawInvitesConstraint || (RawInvitesConstraint = {}));
/** select columns of table "raw_invites" */
export var RawInvitesSelectColumn;
(function (RawInvitesSelectColumn) {
    /** column name */
    RawInvitesSelectColumn["CreatedAt"] = "created_at";
    /** column name */
    RawInvitesSelectColumn["EndDate"] = "end_date";
    /** column name */
    RawInvitesSelectColumn["GlobalRoleId"] = "global_role_id";
    /** column name */
    RawInvitesSelectColumn["Id"] = "id";
    /** column name */
    RawInvitesSelectColumn["ReceiverEmail"] = "receiver_email";
    /** column name */
    RawInvitesSelectColumn["SenderId"] = "sender_id";
    /** column name */
    RawInvitesSelectColumn["StartDate"] = "start_date";
    /** column name */
    RawInvitesSelectColumn["UserGroupId"] = "user_group_id";
    /** column name */
    RawInvitesSelectColumn["UserGroupRoleId"] = "user_group_role_id";
})(RawInvitesSelectColumn || (RawInvitesSelectColumn = {}));
/** update columns of table "raw_invites" */
export var RawInvitesUpdateColumn;
(function (RawInvitesUpdateColumn) {
    /** column name */
    RawInvitesUpdateColumn["CreatedAt"] = "created_at";
    /** column name */
    RawInvitesUpdateColumn["EndDate"] = "end_date";
    /** column name */
    RawInvitesUpdateColumn["GlobalRoleId"] = "global_role_id";
    /** column name */
    RawInvitesUpdateColumn["Id"] = "id";
    /** column name */
    RawInvitesUpdateColumn["ReceiverEmail"] = "receiver_email";
    /** column name */
    RawInvitesUpdateColumn["SenderId"] = "sender_id";
    /** column name */
    RawInvitesUpdateColumn["StartDate"] = "start_date";
    /** column name */
    RawInvitesUpdateColumn["UserGroupId"] = "user_group_id";
    /** column name */
    RawInvitesUpdateColumn["UserGroupRoleId"] = "user_group_role_id";
})(RawInvitesUpdateColumn || (RawInvitesUpdateColumn = {}));
/** select columns of table "saturday_operating_hours" */
export var SaturdayOperatingHoursSelectColumn;
(function (SaturdayOperatingHoursSelectColumn) {
    /** column name */
    SaturdayOperatingHoursSelectColumn["DayOfWeek"] = "day_of_week";
    /** column name */
    SaturdayOperatingHoursSelectColumn["HourEnd"] = "hour_end";
    /** column name */
    SaturdayOperatingHoursSelectColumn["HourStart"] = "hour_start";
    /** column name */
    SaturdayOperatingHoursSelectColumn["ModelId"] = "model_id";
})(SaturdayOperatingHoursSelectColumn || (SaturdayOperatingHoursSelectColumn = {}));
/** unique or primary key constraints on table "spacecloud.asset_group_annex_images" */
export var ScAssetGroupAnnexImagesConstraint;
(function (ScAssetGroupAnnexImagesConstraint) {
    /** unique or primary key constraint on columns "id" */
    ScAssetGroupAnnexImagesConstraint["Pk_160cf5195e8aae81df3c81cd7a1"] = "PK_160cf5195e8aae81df3c81cd7a1";
})(ScAssetGroupAnnexImagesConstraint || (ScAssetGroupAnnexImagesConstraint = {}));
/** select columns of table "spacecloud.asset_group_annex_images" */
export var ScAssetGroupAnnexImagesSelectColumn;
(function (ScAssetGroupAnnexImagesSelectColumn) {
    /** column name */
    ScAssetGroupAnnexImagesSelectColumn["AssetGroupAnnexId"] = "asset_group_annex_id";
    /** column name */
    ScAssetGroupAnnexImagesSelectColumn["CreatedAt"] = "created_at";
    /** column name */
    ScAssetGroupAnnexImagesSelectColumn["Id"] = "id";
    /** column name */
    ScAssetGroupAnnexImagesSelectColumn["IsActive"] = "is_active";
    /** column name */
    ScAssetGroupAnnexImagesSelectColumn["ObjectKey"] = "object_key";
    /** column name */
    ScAssetGroupAnnexImagesSelectColumn["UpdatedAt"] = "updated_at";
})(ScAssetGroupAnnexImagesSelectColumn || (ScAssetGroupAnnexImagesSelectColumn = {}));
/** select "sc_asset_group_annex_images_aggregate_bool_exp_bool_and_arguments_columns" columns of table "spacecloud.asset_group_annex_images" */
export var ScAssetGroupAnnexImagesSelectColumnScAssetGroupAnnexImagesAggregateBoolExpBoolAndArgumentsColumns;
(function (ScAssetGroupAnnexImagesSelectColumnScAssetGroupAnnexImagesAggregateBoolExpBoolAndArgumentsColumns) {
    /** column name */
    ScAssetGroupAnnexImagesSelectColumnScAssetGroupAnnexImagesAggregateBoolExpBoolAndArgumentsColumns["IsActive"] = "is_active";
})(ScAssetGroupAnnexImagesSelectColumnScAssetGroupAnnexImagesAggregateBoolExpBoolAndArgumentsColumns || (ScAssetGroupAnnexImagesSelectColumnScAssetGroupAnnexImagesAggregateBoolExpBoolAndArgumentsColumns = {}));
/** select "sc_asset_group_annex_images_aggregate_bool_exp_bool_or_arguments_columns" columns of table "spacecloud.asset_group_annex_images" */
export var ScAssetGroupAnnexImagesSelectColumnScAssetGroupAnnexImagesAggregateBoolExpBoolOrArgumentsColumns;
(function (ScAssetGroupAnnexImagesSelectColumnScAssetGroupAnnexImagesAggregateBoolExpBoolOrArgumentsColumns) {
    /** column name */
    ScAssetGroupAnnexImagesSelectColumnScAssetGroupAnnexImagesAggregateBoolExpBoolOrArgumentsColumns["IsActive"] = "is_active";
})(ScAssetGroupAnnexImagesSelectColumnScAssetGroupAnnexImagesAggregateBoolExpBoolOrArgumentsColumns || (ScAssetGroupAnnexImagesSelectColumnScAssetGroupAnnexImagesAggregateBoolExpBoolOrArgumentsColumns = {}));
/** update columns of table "spacecloud.asset_group_annex_images" */
export var ScAssetGroupAnnexImagesUpdateColumn;
(function (ScAssetGroupAnnexImagesUpdateColumn) {
    /** column name */
    ScAssetGroupAnnexImagesUpdateColumn["AssetGroupAnnexId"] = "asset_group_annex_id";
    /** column name */
    ScAssetGroupAnnexImagesUpdateColumn["CreatedAt"] = "created_at";
    /** column name */
    ScAssetGroupAnnexImagesUpdateColumn["Id"] = "id";
    /** column name */
    ScAssetGroupAnnexImagesUpdateColumn["IsActive"] = "is_active";
    /** column name */
    ScAssetGroupAnnexImagesUpdateColumn["ObjectKey"] = "object_key";
    /** column name */
    ScAssetGroupAnnexImagesUpdateColumn["UpdatedAt"] = "updated_at";
})(ScAssetGroupAnnexImagesUpdateColumn || (ScAssetGroupAnnexImagesUpdateColumn = {}));
/** unique or primary key constraints on table "spacecloud.asset_group_premium_info" */
export var ScAssetGroupPremiumInfoConstraint;
(function (ScAssetGroupPremiumInfoConstraint) {
    /** unique or primary key constraint on columns "asset_group_annex_id" */
    ScAssetGroupPremiumInfoConstraint["AssetGroupPremiumInfoAssetGroupAnnexIdKey"] = "asset_group_premium_info_asset_group_annex_id_key";
    /** unique or primary key constraint on columns "id" */
    ScAssetGroupPremiumInfoConstraint["AssetGroupPremiumInfoPkey"] = "asset_group_premium_info_pkey";
})(ScAssetGroupPremiumInfoConstraint || (ScAssetGroupPremiumInfoConstraint = {}));
/** select columns of table "spacecloud.asset_group_premium_info" */
export var ScAssetGroupPremiumInfoSelectColumn;
(function (ScAssetGroupPremiumInfoSelectColumn) {
    /** column name */
    ScAssetGroupPremiumInfoSelectColumn["AssetGroupAnnexId"] = "asset_group_annex_id";
    /** column name */
    ScAssetGroupPremiumInfoSelectColumn["AverageBeveragePrice"] = "average_beverage_price";
    /** column name */
    ScAssetGroupPremiumInfoSelectColumn["AverageMainDishPrice"] = "average_main_dish_price";
    /** column name */
    ScAssetGroupPremiumInfoSelectColumn["AverageSnackPrice"] = "average_snack_price";
    /** column name */
    ScAssetGroupPremiumInfoSelectColumn["CctvFloorPlanImage"] = "cctv_floor_plan_image";
    /** column name */
    ScAssetGroupPremiumInfoSelectColumn["Id"] = "id";
    /** column name */
    ScAssetGroupPremiumInfoSelectColumn["NeighborhoodDetail"] = "neighborhood_detail";
    /** column name */
    ScAssetGroupPremiumInfoSelectColumn["NeighborhoodImage"] = "neighborhood_image";
    /** column name */
    ScAssetGroupPremiumInfoSelectColumn["NeighborhoodType"] = "neighborhood_type";
    /** column name */
    ScAssetGroupPremiumInfoSelectColumn["PurchasingPowerDetail"] = "purchasing_power_detail";
    /** column name */
    ScAssetGroupPremiumInfoSelectColumn["PurchasingPowerImage"] = "purchasing_power_image";
    /** column name */
    ScAssetGroupPremiumInfoSelectColumn["PurchasingPowerType"] = "purchasing_power_type";
})(ScAssetGroupPremiumInfoSelectColumn || (ScAssetGroupPremiumInfoSelectColumn = {}));
/** update columns of table "spacecloud.asset_group_premium_info" */
export var ScAssetGroupPremiumInfoUpdateColumn;
(function (ScAssetGroupPremiumInfoUpdateColumn) {
    /** column name */
    ScAssetGroupPremiumInfoUpdateColumn["AssetGroupAnnexId"] = "asset_group_annex_id";
    /** column name */
    ScAssetGroupPremiumInfoUpdateColumn["AverageBeveragePrice"] = "average_beverage_price";
    /** column name */
    ScAssetGroupPremiumInfoUpdateColumn["AverageMainDishPrice"] = "average_main_dish_price";
    /** column name */
    ScAssetGroupPremiumInfoUpdateColumn["AverageSnackPrice"] = "average_snack_price";
    /** column name */
    ScAssetGroupPremiumInfoUpdateColumn["CctvFloorPlanImage"] = "cctv_floor_plan_image";
    /** column name */
    ScAssetGroupPremiumInfoUpdateColumn["Id"] = "id";
    /** column name */
    ScAssetGroupPremiumInfoUpdateColumn["NeighborhoodDetail"] = "neighborhood_detail";
    /** column name */
    ScAssetGroupPremiumInfoUpdateColumn["NeighborhoodImage"] = "neighborhood_image";
    /** column name */
    ScAssetGroupPremiumInfoUpdateColumn["NeighborhoodType"] = "neighborhood_type";
    /** column name */
    ScAssetGroupPremiumInfoUpdateColumn["PurchasingPowerDetail"] = "purchasing_power_detail";
    /** column name */
    ScAssetGroupPremiumInfoUpdateColumn["PurchasingPowerImage"] = "purchasing_power_image";
    /** column name */
    ScAssetGroupPremiumInfoUpdateColumn["PurchasingPowerType"] = "purchasing_power_type";
})(ScAssetGroupPremiumInfoUpdateColumn || (ScAssetGroupPremiumInfoUpdateColumn = {}));
/** select columns of table "spacecloud.asset_group_rental_business_group_summary" */
export var ScAssetGroupRentalBusinessGroupSummarySelectColumn;
(function (ScAssetGroupRentalBusinessGroupSummarySelectColumn) {
    /** column name */
    ScAssetGroupRentalBusinessGroupSummarySelectColumn["AssetGroupAnnexUuid"] = "asset_group_annex_uuid";
    /** column name */
    ScAssetGroupRentalBusinessGroupSummarySelectColumn["RentalBusinessGroup"] = "rental_business_group";
    /** column name */
    ScAssetGroupRentalBusinessGroupSummarySelectColumn["ShopAmount"] = "shop_amount";
})(ScAssetGroupRentalBusinessGroupSummarySelectColumn || (ScAssetGroupRentalBusinessGroupSummarySelectColumn = {}));
/** unique or primary key constraints on table "spacecloud.asset_group_user_premium" */
export var ScAssetGroupUserPremiumConstraint;
(function (ScAssetGroupUserPremiumConstraint) {
    /** unique or primary key constraint on columns "asset_group_uuid", "user_id" */
    ScAssetGroupUserPremiumConstraint["AssetGroupUserPremiumPkey"] = "asset_group_user_premium_pkey";
})(ScAssetGroupUserPremiumConstraint || (ScAssetGroupUserPremiumConstraint = {}));
/** select columns of table "spacecloud.asset_group_user_premium" */
export var ScAssetGroupUserPremiumSelectColumn;
(function (ScAssetGroupUserPremiumSelectColumn) {
    /** column name */
    ScAssetGroupUserPremiumSelectColumn["AssetGroupUuid"] = "asset_group_uuid";
    /** column name */
    ScAssetGroupUserPremiumSelectColumn["CreatedAt"] = "created_at";
    /** column name */
    ScAssetGroupUserPremiumSelectColumn["UpdatedAt"] = "updated_at";
    /** column name */
    ScAssetGroupUserPremiumSelectColumn["UserId"] = "user_id";
})(ScAssetGroupUserPremiumSelectColumn || (ScAssetGroupUserPremiumSelectColumn = {}));
/** update columns of table "spacecloud.asset_group_user_premium" */
export var ScAssetGroupUserPremiumUpdateColumn;
(function (ScAssetGroupUserPremiumUpdateColumn) {
    /** column name */
    ScAssetGroupUserPremiumUpdateColumn["AssetGroupUuid"] = "asset_group_uuid";
    /** column name */
    ScAssetGroupUserPremiumUpdateColumn["CreatedAt"] = "created_at";
    /** column name */
    ScAssetGroupUserPremiumUpdateColumn["UpdatedAt"] = "updated_at";
    /** column name */
    ScAssetGroupUserPremiumUpdateColumn["UserId"] = "user_id";
})(ScAssetGroupUserPremiumUpdateColumn || (ScAssetGroupUserPremiumUpdateColumn = {}));
/** unique or primary key constraints on table "spacecloud.asset_groups_annex" */
export var ScAssetGroupsAnnexConstraint;
(function (ScAssetGroupsAnnexConstraint) {
    /** unique or primary key constraint on columns "id" */
    ScAssetGroupsAnnexConstraint["Pk_681f4a2d0c16f651b2de9b5d730"] = "PK_681f4a2d0c16f651b2de9b5d730";
    /** unique or primary key constraint on columns "uuid" */
    ScAssetGroupsAnnexConstraint["UqD3269e4bc35dcf334063594a970"] = "UQ_d3269e4bc35dcf334063594a970";
})(ScAssetGroupsAnnexConstraint || (ScAssetGroupsAnnexConstraint = {}));
/** select columns of table "spacecloud.asset_groups_annex" */
export var ScAssetGroupsAnnexSelectColumn;
(function (ScAssetGroupsAnnexSelectColumn) {
    /** column name */
    ScAssetGroupsAnnexSelectColumn["Address"] = "address";
    /** column name */
    ScAssetGroupsAnnexSelectColumn["AssetClassName"] = "asset_class_name";
    /** column name */
    ScAssetGroupsAnnexSelectColumn["AssetClassUuid"] = "asset_class_uuid";
    /** column name */
    ScAssetGroupsAnnexSelectColumn["CreatedAt"] = "created_at";
    /** column name */
    ScAssetGroupsAnnexSelectColumn["Description"] = "description";
    /** column name */
    ScAssetGroupsAnnexSelectColumn["DisplayName"] = "display_name";
    /** column name */
    ScAssetGroupsAnnexSelectColumn["District"] = "district";
    /** column name */
    ScAssetGroupsAnnexSelectColumn["DistrictCode"] = "district_code";
    /** column name */
    ScAssetGroupsAnnexSelectColumn["Id"] = "id";
    /** column name */
    ScAssetGroupsAnnexSelectColumn["IsActive"] = "is_active";
    /** column name */
    ScAssetGroupsAnnexSelectColumn["IsBookable"] = "is_bookable";
    /** column name */
    ScAssetGroupsAnnexSelectColumn["Key"] = "key";
    /** column name */
    ScAssetGroupsAnnexSelectColumn["LandlordEmail"] = "landlord_email";
    /** column name */
    ScAssetGroupsAnnexSelectColumn["LandlordFirstName"] = "landlord_first_name";
    /** column name */
    ScAssetGroupsAnnexSelectColumn["LandlordFullName"] = "landlord_full_name";
    /** column name */
    ScAssetGroupsAnnexSelectColumn["LandlordLastName"] = "landlord_last_name";
    /** column name */
    ScAssetGroupsAnnexSelectColumn["LandlordNote"] = "landlord_note";
    /** column name */
    ScAssetGroupsAnnexSelectColumn["LandlordTel"] = "landlord_tel";
    /** column name */
    ScAssetGroupsAnnexSelectColumn["Latitude"] = "latitude";
    /** column name */
    ScAssetGroupsAnnexSelectColumn["LineShoppingUrl"] = "line_shopping_url";
    /** column name */
    ScAssetGroupsAnnexSelectColumn["Longitude"] = "longitude";
    /** column name */
    ScAssetGroupsAnnexSelectColumn["NearPlaces"] = "near_places";
    /** column name */
    ScAssetGroupsAnnexSelectColumn["NumOfAvailableAssets"] = "num_of_available_assets";
    /** column name */
    ScAssetGroupsAnnexSelectColumn["OrganizationId"] = "organization_id";
    /** column name */
    ScAssetGroupsAnnexSelectColumn["ParkingAvailable"] = "parking_available";
    /** column name */
    ScAssetGroupsAnnexSelectColumn["Province"] = "province";
    /** column name */
    ScAssetGroupsAnnexSelectColumn["ProvinceCode"] = "province_code";
    /** column name */
    ScAssetGroupsAnnexSelectColumn["SubDistrict"] = "sub_district";
    /** column name */
    ScAssetGroupsAnnexSelectColumn["SubDistrictCode"] = "sub_district_code";
    /** column name */
    ScAssetGroupsAnnexSelectColumn["Type"] = "type";
    /** column name */
    ScAssetGroupsAnnexSelectColumn["UpdatedAt"] = "updated_at";
    /** column name */
    ScAssetGroupsAnnexSelectColumn["Uuid"] = "uuid";
    /** column name */
    ScAssetGroupsAnnexSelectColumn["VideoUrl"] = "video_url";
})(ScAssetGroupsAnnexSelectColumn || (ScAssetGroupsAnnexSelectColumn = {}));
/** update columns of table "spacecloud.asset_groups_annex" */
export var ScAssetGroupsAnnexUpdateColumn;
(function (ScAssetGroupsAnnexUpdateColumn) {
    /** column name */
    ScAssetGroupsAnnexUpdateColumn["Address"] = "address";
    /** column name */
    ScAssetGroupsAnnexUpdateColumn["AssetClassName"] = "asset_class_name";
    /** column name */
    ScAssetGroupsAnnexUpdateColumn["AssetClassUuid"] = "asset_class_uuid";
    /** column name */
    ScAssetGroupsAnnexUpdateColumn["CreatedAt"] = "created_at";
    /** column name */
    ScAssetGroupsAnnexUpdateColumn["Description"] = "description";
    /** column name */
    ScAssetGroupsAnnexUpdateColumn["DisplayName"] = "display_name";
    /** column name */
    ScAssetGroupsAnnexUpdateColumn["District"] = "district";
    /** column name */
    ScAssetGroupsAnnexUpdateColumn["DistrictCode"] = "district_code";
    /** column name */
    ScAssetGroupsAnnexUpdateColumn["Id"] = "id";
    /** column name */
    ScAssetGroupsAnnexUpdateColumn["IsActive"] = "is_active";
    /** column name */
    ScAssetGroupsAnnexUpdateColumn["IsBookable"] = "is_bookable";
    /** column name */
    ScAssetGroupsAnnexUpdateColumn["Key"] = "key";
    /** column name */
    ScAssetGroupsAnnexUpdateColumn["LandlordEmail"] = "landlord_email";
    /** column name */
    ScAssetGroupsAnnexUpdateColumn["LandlordFirstName"] = "landlord_first_name";
    /** column name */
    ScAssetGroupsAnnexUpdateColumn["LandlordFullName"] = "landlord_full_name";
    /** column name */
    ScAssetGroupsAnnexUpdateColumn["LandlordLastName"] = "landlord_last_name";
    /** column name */
    ScAssetGroupsAnnexUpdateColumn["LandlordNote"] = "landlord_note";
    /** column name */
    ScAssetGroupsAnnexUpdateColumn["LandlordTel"] = "landlord_tel";
    /** column name */
    ScAssetGroupsAnnexUpdateColumn["Latitude"] = "latitude";
    /** column name */
    ScAssetGroupsAnnexUpdateColumn["LineShoppingUrl"] = "line_shopping_url";
    /** column name */
    ScAssetGroupsAnnexUpdateColumn["Longitude"] = "longitude";
    /** column name */
    ScAssetGroupsAnnexUpdateColumn["NearPlaces"] = "near_places";
    /** column name */
    ScAssetGroupsAnnexUpdateColumn["NumOfAvailableAssets"] = "num_of_available_assets";
    /** column name */
    ScAssetGroupsAnnexUpdateColumn["OrganizationId"] = "organization_id";
    /** column name */
    ScAssetGroupsAnnexUpdateColumn["ParkingAvailable"] = "parking_available";
    /** column name */
    ScAssetGroupsAnnexUpdateColumn["Province"] = "province";
    /** column name */
    ScAssetGroupsAnnexUpdateColumn["ProvinceCode"] = "province_code";
    /** column name */
    ScAssetGroupsAnnexUpdateColumn["SubDistrict"] = "sub_district";
    /** column name */
    ScAssetGroupsAnnexUpdateColumn["SubDistrictCode"] = "sub_district_code";
    /** column name */
    ScAssetGroupsAnnexUpdateColumn["Type"] = "type";
    /** column name */
    ScAssetGroupsAnnexUpdateColumn["UpdatedAt"] = "updated_at";
    /** column name */
    ScAssetGroupsAnnexUpdateColumn["Uuid"] = "uuid";
    /** column name */
    ScAssetGroupsAnnexUpdateColumn["VideoUrl"] = "video_url";
})(ScAssetGroupsAnnexUpdateColumn || (ScAssetGroupsAnnexUpdateColumn = {}));
/** unique or primary key constraints on table "spacecloud.assets" */
export var ScAssetsConstraint;
(function (ScAssetsConstraint) {
    /** unique or primary key constraint on columns "id" */
    ScAssetsConstraint["PkDa96729a8b113377cfb6a62439c"] = "PK_da96729a8b113377cfb6a62439c";
    /** unique or primary key constraint on columns "uuid" */
    ScAssetsConstraint["Uq_6bd9c512d7bb9e6d63fc403a77b"] = "UQ_6bd9c512d7bb9e6d63fc403a77b";
})(ScAssetsConstraint || (ScAssetsConstraint = {}));
/** unique or primary key constraints on table "spacecloud.assets_images" */
export var ScAssetsImagesConstraint;
(function (ScAssetsImagesConstraint) {
    /** unique or primary key constraint on columns "id" */
    ScAssetsImagesConstraint["Pk_1981f892c0e2e9d31b097beabf2"] = "PK_1981f892c0e2e9d31b097beabf2";
})(ScAssetsImagesConstraint || (ScAssetsImagesConstraint = {}));
/** select columns of table "spacecloud.assets_images" */
export var ScAssetsImagesSelectColumn;
(function (ScAssetsImagesSelectColumn) {
    /** column name */
    ScAssetsImagesSelectColumn["AssetId"] = "asset_id";
    /** column name */
    ScAssetsImagesSelectColumn["CreatedAt"] = "created_at";
    /** column name */
    ScAssetsImagesSelectColumn["Id"] = "id";
    /** column name */
    ScAssetsImagesSelectColumn["IsActive"] = "is_active";
    /** column name */
    ScAssetsImagesSelectColumn["ObjectKey"] = "object_key";
    /** column name */
    ScAssetsImagesSelectColumn["UpdatedAt"] = "updated_at";
})(ScAssetsImagesSelectColumn || (ScAssetsImagesSelectColumn = {}));
/** select "sc_assets_images_aggregate_bool_exp_bool_and_arguments_columns" columns of table "spacecloud.assets_images" */
export var ScAssetsImagesSelectColumnScAssetsImagesAggregateBoolExpBoolAndArgumentsColumns;
(function (ScAssetsImagesSelectColumnScAssetsImagesAggregateBoolExpBoolAndArgumentsColumns) {
    /** column name */
    ScAssetsImagesSelectColumnScAssetsImagesAggregateBoolExpBoolAndArgumentsColumns["IsActive"] = "is_active";
})(ScAssetsImagesSelectColumnScAssetsImagesAggregateBoolExpBoolAndArgumentsColumns || (ScAssetsImagesSelectColumnScAssetsImagesAggregateBoolExpBoolAndArgumentsColumns = {}));
/** select "sc_assets_images_aggregate_bool_exp_bool_or_arguments_columns" columns of table "spacecloud.assets_images" */
export var ScAssetsImagesSelectColumnScAssetsImagesAggregateBoolExpBoolOrArgumentsColumns;
(function (ScAssetsImagesSelectColumnScAssetsImagesAggregateBoolExpBoolOrArgumentsColumns) {
    /** column name */
    ScAssetsImagesSelectColumnScAssetsImagesAggregateBoolExpBoolOrArgumentsColumns["IsActive"] = "is_active";
})(ScAssetsImagesSelectColumnScAssetsImagesAggregateBoolExpBoolOrArgumentsColumns || (ScAssetsImagesSelectColumnScAssetsImagesAggregateBoolExpBoolOrArgumentsColumns = {}));
/** update columns of table "spacecloud.assets_images" */
export var ScAssetsImagesUpdateColumn;
(function (ScAssetsImagesUpdateColumn) {
    /** column name */
    ScAssetsImagesUpdateColumn["AssetId"] = "asset_id";
    /** column name */
    ScAssetsImagesUpdateColumn["CreatedAt"] = "created_at";
    /** column name */
    ScAssetsImagesUpdateColumn["Id"] = "id";
    /** column name */
    ScAssetsImagesUpdateColumn["IsActive"] = "is_active";
    /** column name */
    ScAssetsImagesUpdateColumn["ObjectKey"] = "object_key";
    /** column name */
    ScAssetsImagesUpdateColumn["UpdatedAt"] = "updated_at";
})(ScAssetsImagesUpdateColumn || (ScAssetsImagesUpdateColumn = {}));
/** select columns of table "spacecloud.assets" */
export var ScAssetsSelectColumn;
(function (ScAssetsSelectColumn) {
    /** column name */
    ScAssetsSelectColumn["Approver_1"] = "approver_1";
    /** column name */
    ScAssetsSelectColumn["Approver_2"] = "approver_2";
    /** column name */
    ScAssetsSelectColumn["Approver_3"] = "approver_3";
    /** column name */
    ScAssetsSelectColumn["Approver_4"] = "approver_4";
    /** column name */
    ScAssetsSelectColumn["Approver_5"] = "approver_5";
    /** column name */
    ScAssetsSelectColumn["AssetAlias"] = "asset_alias";
    /** column name */
    ScAssetsSelectColumn["AssetGroupAnnexId"] = "asset_group_annex_id";
    /** column name */
    ScAssetsSelectColumn["AssetType"] = "asset_type";
    /** column name */
    ScAssetsSelectColumn["CommonFeeCharge"] = "common_fee_charge";
    /** column name */
    ScAssetsSelectColumn["CreatedAt"] = "created_at";
    /** column name */
    ScAssetsSelectColumn["DepositFee"] = "deposit_fee";
    /** column name */
    ScAssetsSelectColumn["DimensionsArea"] = "dimensions_area";
    /** column name */
    ScAssetsSelectColumn["DimensionsLength"] = "dimensions_length";
    /** column name */
    ScAssetsSelectColumn["DimensionsWidth"] = "dimensions_width";
    /** column name */
    ScAssetsSelectColumn["ElectricityCharge"] = "electricity_charge";
    /** column name */
    ScAssetsSelectColumn["FloorId"] = "floor_id";
    /** column name */
    ScAssetsSelectColumn["Id"] = "id";
    /** column name */
    ScAssetsSelectColumn["InsuranceRental"] = "insurance_rental";
    /** column name */
    ScAssetsSelectColumn["IsDraft"] = "is_draft";
    /** column name */
    ScAssetsSelectColumn["LayoutPositions"] = "layout_positions";
    /** column name */
    ScAssetsSelectColumn["OrganizationId"] = "organization_id";
    /** column name */
    ScAssetsSelectColumn["OtherFee"] = "other_fee";
    /** column name */
    ScAssetsSelectColumn["RentalFixedAmount"] = "rental_fixed_amount";
    /** column name */
    ScAssetsSelectColumn["RentalPercentAmount"] = "rental_percent_amount";
    /** column name */
    ScAssetsSelectColumn["RentalType"] = "rental_type";
    /** column name */
    ScAssetsSelectColumn["UpdatedAt"] = "updated_at";
    /** column name */
    ScAssetsSelectColumn["UtilityBillPeriodType"] = "utility_bill_period_type";
    /** column name */
    ScAssetsSelectColumn["Uuid"] = "uuid";
    /** column name */
    ScAssetsSelectColumn["WaterCharge"] = "water_charge";
})(ScAssetsSelectColumn || (ScAssetsSelectColumn = {}));
/** select "sc_assets_aggregate_bool_exp_avg_arguments_columns" columns of table "spacecloud.assets" */
export var ScAssetsSelectColumnScAssetsAggregateBoolExpAvgArgumentsColumns;
(function (ScAssetsSelectColumnScAssetsAggregateBoolExpAvgArgumentsColumns) {
    /** column name */
    ScAssetsSelectColumnScAssetsAggregateBoolExpAvgArgumentsColumns["CommonFeeCharge"] = "common_fee_charge";
    /** column name */
    ScAssetsSelectColumnScAssetsAggregateBoolExpAvgArgumentsColumns["DepositFee"] = "deposit_fee";
    /** column name */
    ScAssetsSelectColumnScAssetsAggregateBoolExpAvgArgumentsColumns["DimensionsArea"] = "dimensions_area";
    /** column name */
    ScAssetsSelectColumnScAssetsAggregateBoolExpAvgArgumentsColumns["DimensionsLength"] = "dimensions_length";
    /** column name */
    ScAssetsSelectColumnScAssetsAggregateBoolExpAvgArgumentsColumns["DimensionsWidth"] = "dimensions_width";
    /** column name */
    ScAssetsSelectColumnScAssetsAggregateBoolExpAvgArgumentsColumns["ElectricityCharge"] = "electricity_charge";
    /** column name */
    ScAssetsSelectColumnScAssetsAggregateBoolExpAvgArgumentsColumns["InsuranceRental"] = "insurance_rental";
    /** column name */
    ScAssetsSelectColumnScAssetsAggregateBoolExpAvgArgumentsColumns["RentalFixedAmount"] = "rental_fixed_amount";
    /** column name */
    ScAssetsSelectColumnScAssetsAggregateBoolExpAvgArgumentsColumns["RentalPercentAmount"] = "rental_percent_amount";
    /** column name */
    ScAssetsSelectColumnScAssetsAggregateBoolExpAvgArgumentsColumns["WaterCharge"] = "water_charge";
})(ScAssetsSelectColumnScAssetsAggregateBoolExpAvgArgumentsColumns || (ScAssetsSelectColumnScAssetsAggregateBoolExpAvgArgumentsColumns = {}));
/** select "sc_assets_aggregate_bool_exp_bool_and_arguments_columns" columns of table "spacecloud.assets" */
export var ScAssetsSelectColumnScAssetsAggregateBoolExpBoolAndArgumentsColumns;
(function (ScAssetsSelectColumnScAssetsAggregateBoolExpBoolAndArgumentsColumns) {
    /** column name */
    ScAssetsSelectColumnScAssetsAggregateBoolExpBoolAndArgumentsColumns["IsDraft"] = "is_draft";
})(ScAssetsSelectColumnScAssetsAggregateBoolExpBoolAndArgumentsColumns || (ScAssetsSelectColumnScAssetsAggregateBoolExpBoolAndArgumentsColumns = {}));
/** select "sc_assets_aggregate_bool_exp_bool_or_arguments_columns" columns of table "spacecloud.assets" */
export var ScAssetsSelectColumnScAssetsAggregateBoolExpBoolOrArgumentsColumns;
(function (ScAssetsSelectColumnScAssetsAggregateBoolExpBoolOrArgumentsColumns) {
    /** column name */
    ScAssetsSelectColumnScAssetsAggregateBoolExpBoolOrArgumentsColumns["IsDraft"] = "is_draft";
})(ScAssetsSelectColumnScAssetsAggregateBoolExpBoolOrArgumentsColumns || (ScAssetsSelectColumnScAssetsAggregateBoolExpBoolOrArgumentsColumns = {}));
/** select "sc_assets_aggregate_bool_exp_corr_arguments_columns" columns of table "spacecloud.assets" */
export var ScAssetsSelectColumnScAssetsAggregateBoolExpCorrArgumentsColumns;
(function (ScAssetsSelectColumnScAssetsAggregateBoolExpCorrArgumentsColumns) {
    /** column name */
    ScAssetsSelectColumnScAssetsAggregateBoolExpCorrArgumentsColumns["CommonFeeCharge"] = "common_fee_charge";
    /** column name */
    ScAssetsSelectColumnScAssetsAggregateBoolExpCorrArgumentsColumns["DepositFee"] = "deposit_fee";
    /** column name */
    ScAssetsSelectColumnScAssetsAggregateBoolExpCorrArgumentsColumns["DimensionsArea"] = "dimensions_area";
    /** column name */
    ScAssetsSelectColumnScAssetsAggregateBoolExpCorrArgumentsColumns["DimensionsLength"] = "dimensions_length";
    /** column name */
    ScAssetsSelectColumnScAssetsAggregateBoolExpCorrArgumentsColumns["DimensionsWidth"] = "dimensions_width";
    /** column name */
    ScAssetsSelectColumnScAssetsAggregateBoolExpCorrArgumentsColumns["ElectricityCharge"] = "electricity_charge";
    /** column name */
    ScAssetsSelectColumnScAssetsAggregateBoolExpCorrArgumentsColumns["InsuranceRental"] = "insurance_rental";
    /** column name */
    ScAssetsSelectColumnScAssetsAggregateBoolExpCorrArgumentsColumns["RentalFixedAmount"] = "rental_fixed_amount";
    /** column name */
    ScAssetsSelectColumnScAssetsAggregateBoolExpCorrArgumentsColumns["RentalPercentAmount"] = "rental_percent_amount";
    /** column name */
    ScAssetsSelectColumnScAssetsAggregateBoolExpCorrArgumentsColumns["WaterCharge"] = "water_charge";
})(ScAssetsSelectColumnScAssetsAggregateBoolExpCorrArgumentsColumns || (ScAssetsSelectColumnScAssetsAggregateBoolExpCorrArgumentsColumns = {}));
/** select "sc_assets_aggregate_bool_exp_covar_samp_arguments_columns" columns of table "spacecloud.assets" */
export var ScAssetsSelectColumnScAssetsAggregateBoolExpCovarSampArgumentsColumns;
(function (ScAssetsSelectColumnScAssetsAggregateBoolExpCovarSampArgumentsColumns) {
    /** column name */
    ScAssetsSelectColumnScAssetsAggregateBoolExpCovarSampArgumentsColumns["CommonFeeCharge"] = "common_fee_charge";
    /** column name */
    ScAssetsSelectColumnScAssetsAggregateBoolExpCovarSampArgumentsColumns["DepositFee"] = "deposit_fee";
    /** column name */
    ScAssetsSelectColumnScAssetsAggregateBoolExpCovarSampArgumentsColumns["DimensionsArea"] = "dimensions_area";
    /** column name */
    ScAssetsSelectColumnScAssetsAggregateBoolExpCovarSampArgumentsColumns["DimensionsLength"] = "dimensions_length";
    /** column name */
    ScAssetsSelectColumnScAssetsAggregateBoolExpCovarSampArgumentsColumns["DimensionsWidth"] = "dimensions_width";
    /** column name */
    ScAssetsSelectColumnScAssetsAggregateBoolExpCovarSampArgumentsColumns["ElectricityCharge"] = "electricity_charge";
    /** column name */
    ScAssetsSelectColumnScAssetsAggregateBoolExpCovarSampArgumentsColumns["InsuranceRental"] = "insurance_rental";
    /** column name */
    ScAssetsSelectColumnScAssetsAggregateBoolExpCovarSampArgumentsColumns["RentalFixedAmount"] = "rental_fixed_amount";
    /** column name */
    ScAssetsSelectColumnScAssetsAggregateBoolExpCovarSampArgumentsColumns["RentalPercentAmount"] = "rental_percent_amount";
    /** column name */
    ScAssetsSelectColumnScAssetsAggregateBoolExpCovarSampArgumentsColumns["WaterCharge"] = "water_charge";
})(ScAssetsSelectColumnScAssetsAggregateBoolExpCovarSampArgumentsColumns || (ScAssetsSelectColumnScAssetsAggregateBoolExpCovarSampArgumentsColumns = {}));
/** select "sc_assets_aggregate_bool_exp_max_arguments_columns" columns of table "spacecloud.assets" */
export var ScAssetsSelectColumnScAssetsAggregateBoolExpMaxArgumentsColumns;
(function (ScAssetsSelectColumnScAssetsAggregateBoolExpMaxArgumentsColumns) {
    /** column name */
    ScAssetsSelectColumnScAssetsAggregateBoolExpMaxArgumentsColumns["CommonFeeCharge"] = "common_fee_charge";
    /** column name */
    ScAssetsSelectColumnScAssetsAggregateBoolExpMaxArgumentsColumns["DepositFee"] = "deposit_fee";
    /** column name */
    ScAssetsSelectColumnScAssetsAggregateBoolExpMaxArgumentsColumns["DimensionsArea"] = "dimensions_area";
    /** column name */
    ScAssetsSelectColumnScAssetsAggregateBoolExpMaxArgumentsColumns["DimensionsLength"] = "dimensions_length";
    /** column name */
    ScAssetsSelectColumnScAssetsAggregateBoolExpMaxArgumentsColumns["DimensionsWidth"] = "dimensions_width";
    /** column name */
    ScAssetsSelectColumnScAssetsAggregateBoolExpMaxArgumentsColumns["ElectricityCharge"] = "electricity_charge";
    /** column name */
    ScAssetsSelectColumnScAssetsAggregateBoolExpMaxArgumentsColumns["InsuranceRental"] = "insurance_rental";
    /** column name */
    ScAssetsSelectColumnScAssetsAggregateBoolExpMaxArgumentsColumns["RentalFixedAmount"] = "rental_fixed_amount";
    /** column name */
    ScAssetsSelectColumnScAssetsAggregateBoolExpMaxArgumentsColumns["RentalPercentAmount"] = "rental_percent_amount";
    /** column name */
    ScAssetsSelectColumnScAssetsAggregateBoolExpMaxArgumentsColumns["WaterCharge"] = "water_charge";
})(ScAssetsSelectColumnScAssetsAggregateBoolExpMaxArgumentsColumns || (ScAssetsSelectColumnScAssetsAggregateBoolExpMaxArgumentsColumns = {}));
/** select "sc_assets_aggregate_bool_exp_min_arguments_columns" columns of table "spacecloud.assets" */
export var ScAssetsSelectColumnScAssetsAggregateBoolExpMinArgumentsColumns;
(function (ScAssetsSelectColumnScAssetsAggregateBoolExpMinArgumentsColumns) {
    /** column name */
    ScAssetsSelectColumnScAssetsAggregateBoolExpMinArgumentsColumns["CommonFeeCharge"] = "common_fee_charge";
    /** column name */
    ScAssetsSelectColumnScAssetsAggregateBoolExpMinArgumentsColumns["DepositFee"] = "deposit_fee";
    /** column name */
    ScAssetsSelectColumnScAssetsAggregateBoolExpMinArgumentsColumns["DimensionsArea"] = "dimensions_area";
    /** column name */
    ScAssetsSelectColumnScAssetsAggregateBoolExpMinArgumentsColumns["DimensionsLength"] = "dimensions_length";
    /** column name */
    ScAssetsSelectColumnScAssetsAggregateBoolExpMinArgumentsColumns["DimensionsWidth"] = "dimensions_width";
    /** column name */
    ScAssetsSelectColumnScAssetsAggregateBoolExpMinArgumentsColumns["ElectricityCharge"] = "electricity_charge";
    /** column name */
    ScAssetsSelectColumnScAssetsAggregateBoolExpMinArgumentsColumns["InsuranceRental"] = "insurance_rental";
    /** column name */
    ScAssetsSelectColumnScAssetsAggregateBoolExpMinArgumentsColumns["RentalFixedAmount"] = "rental_fixed_amount";
    /** column name */
    ScAssetsSelectColumnScAssetsAggregateBoolExpMinArgumentsColumns["RentalPercentAmount"] = "rental_percent_amount";
    /** column name */
    ScAssetsSelectColumnScAssetsAggregateBoolExpMinArgumentsColumns["WaterCharge"] = "water_charge";
})(ScAssetsSelectColumnScAssetsAggregateBoolExpMinArgumentsColumns || (ScAssetsSelectColumnScAssetsAggregateBoolExpMinArgumentsColumns = {}));
/** select "sc_assets_aggregate_bool_exp_stddev_samp_arguments_columns" columns of table "spacecloud.assets" */
export var ScAssetsSelectColumnScAssetsAggregateBoolExpStddevSampArgumentsColumns;
(function (ScAssetsSelectColumnScAssetsAggregateBoolExpStddevSampArgumentsColumns) {
    /** column name */
    ScAssetsSelectColumnScAssetsAggregateBoolExpStddevSampArgumentsColumns["CommonFeeCharge"] = "common_fee_charge";
    /** column name */
    ScAssetsSelectColumnScAssetsAggregateBoolExpStddevSampArgumentsColumns["DepositFee"] = "deposit_fee";
    /** column name */
    ScAssetsSelectColumnScAssetsAggregateBoolExpStddevSampArgumentsColumns["DimensionsArea"] = "dimensions_area";
    /** column name */
    ScAssetsSelectColumnScAssetsAggregateBoolExpStddevSampArgumentsColumns["DimensionsLength"] = "dimensions_length";
    /** column name */
    ScAssetsSelectColumnScAssetsAggregateBoolExpStddevSampArgumentsColumns["DimensionsWidth"] = "dimensions_width";
    /** column name */
    ScAssetsSelectColumnScAssetsAggregateBoolExpStddevSampArgumentsColumns["ElectricityCharge"] = "electricity_charge";
    /** column name */
    ScAssetsSelectColumnScAssetsAggregateBoolExpStddevSampArgumentsColumns["InsuranceRental"] = "insurance_rental";
    /** column name */
    ScAssetsSelectColumnScAssetsAggregateBoolExpStddevSampArgumentsColumns["RentalFixedAmount"] = "rental_fixed_amount";
    /** column name */
    ScAssetsSelectColumnScAssetsAggregateBoolExpStddevSampArgumentsColumns["RentalPercentAmount"] = "rental_percent_amount";
    /** column name */
    ScAssetsSelectColumnScAssetsAggregateBoolExpStddevSampArgumentsColumns["WaterCharge"] = "water_charge";
})(ScAssetsSelectColumnScAssetsAggregateBoolExpStddevSampArgumentsColumns || (ScAssetsSelectColumnScAssetsAggregateBoolExpStddevSampArgumentsColumns = {}));
/** select "sc_assets_aggregate_bool_exp_sum_arguments_columns" columns of table "spacecloud.assets" */
export var ScAssetsSelectColumnScAssetsAggregateBoolExpSumArgumentsColumns;
(function (ScAssetsSelectColumnScAssetsAggregateBoolExpSumArgumentsColumns) {
    /** column name */
    ScAssetsSelectColumnScAssetsAggregateBoolExpSumArgumentsColumns["CommonFeeCharge"] = "common_fee_charge";
    /** column name */
    ScAssetsSelectColumnScAssetsAggregateBoolExpSumArgumentsColumns["DepositFee"] = "deposit_fee";
    /** column name */
    ScAssetsSelectColumnScAssetsAggregateBoolExpSumArgumentsColumns["DimensionsArea"] = "dimensions_area";
    /** column name */
    ScAssetsSelectColumnScAssetsAggregateBoolExpSumArgumentsColumns["DimensionsLength"] = "dimensions_length";
    /** column name */
    ScAssetsSelectColumnScAssetsAggregateBoolExpSumArgumentsColumns["DimensionsWidth"] = "dimensions_width";
    /** column name */
    ScAssetsSelectColumnScAssetsAggregateBoolExpSumArgumentsColumns["ElectricityCharge"] = "electricity_charge";
    /** column name */
    ScAssetsSelectColumnScAssetsAggregateBoolExpSumArgumentsColumns["InsuranceRental"] = "insurance_rental";
    /** column name */
    ScAssetsSelectColumnScAssetsAggregateBoolExpSumArgumentsColumns["RentalFixedAmount"] = "rental_fixed_amount";
    /** column name */
    ScAssetsSelectColumnScAssetsAggregateBoolExpSumArgumentsColumns["RentalPercentAmount"] = "rental_percent_amount";
    /** column name */
    ScAssetsSelectColumnScAssetsAggregateBoolExpSumArgumentsColumns["WaterCharge"] = "water_charge";
})(ScAssetsSelectColumnScAssetsAggregateBoolExpSumArgumentsColumns || (ScAssetsSelectColumnScAssetsAggregateBoolExpSumArgumentsColumns = {}));
/** select "sc_assets_aggregate_bool_exp_var_samp_arguments_columns" columns of table "spacecloud.assets" */
export var ScAssetsSelectColumnScAssetsAggregateBoolExpVarSampArgumentsColumns;
(function (ScAssetsSelectColumnScAssetsAggregateBoolExpVarSampArgumentsColumns) {
    /** column name */
    ScAssetsSelectColumnScAssetsAggregateBoolExpVarSampArgumentsColumns["CommonFeeCharge"] = "common_fee_charge";
    /** column name */
    ScAssetsSelectColumnScAssetsAggregateBoolExpVarSampArgumentsColumns["DepositFee"] = "deposit_fee";
    /** column name */
    ScAssetsSelectColumnScAssetsAggregateBoolExpVarSampArgumentsColumns["DimensionsArea"] = "dimensions_area";
    /** column name */
    ScAssetsSelectColumnScAssetsAggregateBoolExpVarSampArgumentsColumns["DimensionsLength"] = "dimensions_length";
    /** column name */
    ScAssetsSelectColumnScAssetsAggregateBoolExpVarSampArgumentsColumns["DimensionsWidth"] = "dimensions_width";
    /** column name */
    ScAssetsSelectColumnScAssetsAggregateBoolExpVarSampArgumentsColumns["ElectricityCharge"] = "electricity_charge";
    /** column name */
    ScAssetsSelectColumnScAssetsAggregateBoolExpVarSampArgumentsColumns["InsuranceRental"] = "insurance_rental";
    /** column name */
    ScAssetsSelectColumnScAssetsAggregateBoolExpVarSampArgumentsColumns["RentalFixedAmount"] = "rental_fixed_amount";
    /** column name */
    ScAssetsSelectColumnScAssetsAggregateBoolExpVarSampArgumentsColumns["RentalPercentAmount"] = "rental_percent_amount";
    /** column name */
    ScAssetsSelectColumnScAssetsAggregateBoolExpVarSampArgumentsColumns["WaterCharge"] = "water_charge";
})(ScAssetsSelectColumnScAssetsAggregateBoolExpVarSampArgumentsColumns || (ScAssetsSelectColumnScAssetsAggregateBoolExpVarSampArgumentsColumns = {}));
/** update columns of table "spacecloud.assets" */
export var ScAssetsUpdateColumn;
(function (ScAssetsUpdateColumn) {
    /** column name */
    ScAssetsUpdateColumn["Approver_1"] = "approver_1";
    /** column name */
    ScAssetsUpdateColumn["Approver_2"] = "approver_2";
    /** column name */
    ScAssetsUpdateColumn["Approver_3"] = "approver_3";
    /** column name */
    ScAssetsUpdateColumn["Approver_4"] = "approver_4";
    /** column name */
    ScAssetsUpdateColumn["Approver_5"] = "approver_5";
    /** column name */
    ScAssetsUpdateColumn["AssetAlias"] = "asset_alias";
    /** column name */
    ScAssetsUpdateColumn["AssetGroupAnnexId"] = "asset_group_annex_id";
    /** column name */
    ScAssetsUpdateColumn["AssetType"] = "asset_type";
    /** column name */
    ScAssetsUpdateColumn["CommonFeeCharge"] = "common_fee_charge";
    /** column name */
    ScAssetsUpdateColumn["CreatedAt"] = "created_at";
    /** column name */
    ScAssetsUpdateColumn["DepositFee"] = "deposit_fee";
    /** column name */
    ScAssetsUpdateColumn["DimensionsArea"] = "dimensions_area";
    /** column name */
    ScAssetsUpdateColumn["DimensionsLength"] = "dimensions_length";
    /** column name */
    ScAssetsUpdateColumn["DimensionsWidth"] = "dimensions_width";
    /** column name */
    ScAssetsUpdateColumn["ElectricityCharge"] = "electricity_charge";
    /** column name */
    ScAssetsUpdateColumn["FloorId"] = "floor_id";
    /** column name */
    ScAssetsUpdateColumn["Id"] = "id";
    /** column name */
    ScAssetsUpdateColumn["InsuranceRental"] = "insurance_rental";
    /** column name */
    ScAssetsUpdateColumn["IsDraft"] = "is_draft";
    /** column name */
    ScAssetsUpdateColumn["LayoutPositions"] = "layout_positions";
    /** column name */
    ScAssetsUpdateColumn["OrganizationId"] = "organization_id";
    /** column name */
    ScAssetsUpdateColumn["OtherFee"] = "other_fee";
    /** column name */
    ScAssetsUpdateColumn["RentalFixedAmount"] = "rental_fixed_amount";
    /** column name */
    ScAssetsUpdateColumn["RentalPercentAmount"] = "rental_percent_amount";
    /** column name */
    ScAssetsUpdateColumn["RentalType"] = "rental_type";
    /** column name */
    ScAssetsUpdateColumn["UpdatedAt"] = "updated_at";
    /** column name */
    ScAssetsUpdateColumn["UtilityBillPeriodType"] = "utility_bill_period_type";
    /** column name */
    ScAssetsUpdateColumn["Uuid"] = "uuid";
    /** column name */
    ScAssetsUpdateColumn["WaterCharge"] = "water_charge";
})(ScAssetsUpdateColumn || (ScAssetsUpdateColumn = {}));
/** unique or primary key constraints on table "spacecloud.booking_images" */
export var ScBookingImagesConstraint;
(function (ScBookingImagesConstraint) {
    /** unique or primary key constraint on columns "id" */
    ScBookingImagesConstraint["Pk_0a23a7b72845a77057a4b78eeef"] = "PK_0a23a7b72845a77057a4b78eeef";
})(ScBookingImagesConstraint || (ScBookingImagesConstraint = {}));
/** select columns of table "spacecloud.booking_images" */
export var ScBookingImagesSelectColumn;
(function (ScBookingImagesSelectColumn) {
    /** column name */
    ScBookingImagesSelectColumn["BookingId"] = "booking_id";
    /** column name */
    ScBookingImagesSelectColumn["CreatedAt"] = "created_at";
    /** column name */
    ScBookingImagesSelectColumn["Id"] = "id";
    /** column name */
    ScBookingImagesSelectColumn["IsActive"] = "is_active";
    /** column name */
    ScBookingImagesSelectColumn["ObjectKey"] = "object_key";
    /** column name */
    ScBookingImagesSelectColumn["UpdatedAt"] = "updated_at";
})(ScBookingImagesSelectColumn || (ScBookingImagesSelectColumn = {}));
/** select "sc_booking_images_aggregate_bool_exp_bool_and_arguments_columns" columns of table "spacecloud.booking_images" */
export var ScBookingImagesSelectColumnScBookingImagesAggregateBoolExpBoolAndArgumentsColumns;
(function (ScBookingImagesSelectColumnScBookingImagesAggregateBoolExpBoolAndArgumentsColumns) {
    /** column name */
    ScBookingImagesSelectColumnScBookingImagesAggregateBoolExpBoolAndArgumentsColumns["IsActive"] = "is_active";
})(ScBookingImagesSelectColumnScBookingImagesAggregateBoolExpBoolAndArgumentsColumns || (ScBookingImagesSelectColumnScBookingImagesAggregateBoolExpBoolAndArgumentsColumns = {}));
/** select "sc_booking_images_aggregate_bool_exp_bool_or_arguments_columns" columns of table "spacecloud.booking_images" */
export var ScBookingImagesSelectColumnScBookingImagesAggregateBoolExpBoolOrArgumentsColumns;
(function (ScBookingImagesSelectColumnScBookingImagesAggregateBoolExpBoolOrArgumentsColumns) {
    /** column name */
    ScBookingImagesSelectColumnScBookingImagesAggregateBoolExpBoolOrArgumentsColumns["IsActive"] = "is_active";
})(ScBookingImagesSelectColumnScBookingImagesAggregateBoolExpBoolOrArgumentsColumns || (ScBookingImagesSelectColumnScBookingImagesAggregateBoolExpBoolOrArgumentsColumns = {}));
/** update columns of table "spacecloud.booking_images" */
export var ScBookingImagesUpdateColumn;
(function (ScBookingImagesUpdateColumn) {
    /** column name */
    ScBookingImagesUpdateColumn["BookingId"] = "booking_id";
    /** column name */
    ScBookingImagesUpdateColumn["CreatedAt"] = "created_at";
    /** column name */
    ScBookingImagesUpdateColumn["Id"] = "id";
    /** column name */
    ScBookingImagesUpdateColumn["IsActive"] = "is_active";
    /** column name */
    ScBookingImagesUpdateColumn["ObjectKey"] = "object_key";
    /** column name */
    ScBookingImagesUpdateColumn["UpdatedAt"] = "updated_at";
})(ScBookingImagesUpdateColumn || (ScBookingImagesUpdateColumn = {}));
/** unique or primary key constraints on table "spacecloud.bookings" */
export var ScBookingsConstraint;
(function (ScBookingsConstraint) {
    /** unique or primary key constraint on columns "id" */
    ScBookingsConstraint["PkBee6805982cc1e248e94ce94957"] = "PK_bee6805982cc1e248e94ce94957";
    /** unique or primary key constraint on columns "uuid" */
    ScBookingsConstraint["BookingsUuidKey"] = "bookings_uuid_key";
})(ScBookingsConstraint || (ScBookingsConstraint = {}));
/** select columns of table "spacecloud.bookings" */
export var ScBookingsSelectColumn;
(function (ScBookingsSelectColumn) {
    /** column name */
    ScBookingsSelectColumn["AssetId"] = "asset_id";
    /** column name */
    ScBookingsSelectColumn["CommonFeeCharge"] = "common_fee_charge";
    /** column name */
    ScBookingsSelectColumn["CreatedAt"] = "created_at";
    /** column name */
    ScBookingsSelectColumn["DepositFee"] = "deposit_fee";
    /** column name */
    ScBookingsSelectColumn["ElectricityCharge"] = "electricity_charge";
    /** column name */
    ScBookingsSelectColumn["ExampleItems"] = "example_items";
    /** column name */
    ScBookingsSelectColumn["FirstName"] = "first_name";
    /** column name */
    ScBookingsSelectColumn["Id"] = "id";
    /** column name */
    ScBookingsSelectColumn["InsuranceRental"] = "insurance_rental";
    /** column name */
    ScBookingsSelectColumn["IsActive"] = "is_active";
    /** column name */
    ScBookingsSelectColumn["LastName"] = "last_name";
    /** column name */
    ScBookingsSelectColumn["MessageToBooker"] = "message_to_booker";
    /** column name */
    ScBookingsSelectColumn["MoreInfo"] = "more_info";
    /** column name */
    ScBookingsSelectColumn["Note"] = "note";
    /** column name */
    ScBookingsSelectColumn["OrganizationId"] = "organization_id";
    /** column name */
    ScBookingsSelectColumn["OtherFee"] = "other_fee";
    /** column name */
    ScBookingsSelectColumn["PeriodType"] = "period_type";
    /** column name */
    ScBookingsSelectColumn["RejectReason"] = "reject_reason";
    /** column name */
    ScBookingsSelectColumn["RentalBusinessGroup"] = "rental_business_group";
    /** column name */
    ScBookingsSelectColumn["RentalCost"] = "rental_cost";
    /** column name */
    ScBookingsSelectColumn["RentalCostPercent"] = "rental_cost_percent";
    /** column name */
    ScBookingsSelectColumn["RentalType"] = "rental_type";
    /** column name */
    ScBookingsSelectColumn["ShopName"] = "shop_name";
    /** column name */
    ScBookingsSelectColumn["ShopType"] = "shop_type";
    /** column name */
    ScBookingsSelectColumn["Tel"] = "tel";
    /** column name */
    ScBookingsSelectColumn["UpdatedAt"] = "updated_at";
    /** column name */
    ScBookingsSelectColumn["UtilityBillPeriodType"] = "utility_bill_period_type";
    /** column name */
    ScBookingsSelectColumn["Uuid"] = "uuid";
    /** column name */
    ScBookingsSelectColumn["WaterCharge"] = "water_charge";
})(ScBookingsSelectColumn || (ScBookingsSelectColumn = {}));
/** select "sc_bookings_aggregate_bool_exp_avg_arguments_columns" columns of table "spacecloud.bookings" */
export var ScBookingsSelectColumnScBookingsAggregateBoolExpAvgArgumentsColumns;
(function (ScBookingsSelectColumnScBookingsAggregateBoolExpAvgArgumentsColumns) {
    /** column name */
    ScBookingsSelectColumnScBookingsAggregateBoolExpAvgArgumentsColumns["CommonFeeCharge"] = "common_fee_charge";
    /** column name */
    ScBookingsSelectColumnScBookingsAggregateBoolExpAvgArgumentsColumns["DepositFee"] = "deposit_fee";
    /** column name */
    ScBookingsSelectColumnScBookingsAggregateBoolExpAvgArgumentsColumns["ElectricityCharge"] = "electricity_charge";
    /** column name */
    ScBookingsSelectColumnScBookingsAggregateBoolExpAvgArgumentsColumns["InsuranceRental"] = "insurance_rental";
    /** column name */
    ScBookingsSelectColumnScBookingsAggregateBoolExpAvgArgumentsColumns["RentalCost"] = "rental_cost";
    /** column name */
    ScBookingsSelectColumnScBookingsAggregateBoolExpAvgArgumentsColumns["RentalCostPercent"] = "rental_cost_percent";
    /** column name */
    ScBookingsSelectColumnScBookingsAggregateBoolExpAvgArgumentsColumns["WaterCharge"] = "water_charge";
})(ScBookingsSelectColumnScBookingsAggregateBoolExpAvgArgumentsColumns || (ScBookingsSelectColumnScBookingsAggregateBoolExpAvgArgumentsColumns = {}));
/** select "sc_bookings_aggregate_bool_exp_bool_and_arguments_columns" columns of table "spacecloud.bookings" */
export var ScBookingsSelectColumnScBookingsAggregateBoolExpBoolAndArgumentsColumns;
(function (ScBookingsSelectColumnScBookingsAggregateBoolExpBoolAndArgumentsColumns) {
    /** column name */
    ScBookingsSelectColumnScBookingsAggregateBoolExpBoolAndArgumentsColumns["IsActive"] = "is_active";
})(ScBookingsSelectColumnScBookingsAggregateBoolExpBoolAndArgumentsColumns || (ScBookingsSelectColumnScBookingsAggregateBoolExpBoolAndArgumentsColumns = {}));
/** select "sc_bookings_aggregate_bool_exp_bool_or_arguments_columns" columns of table "spacecloud.bookings" */
export var ScBookingsSelectColumnScBookingsAggregateBoolExpBoolOrArgumentsColumns;
(function (ScBookingsSelectColumnScBookingsAggregateBoolExpBoolOrArgumentsColumns) {
    /** column name */
    ScBookingsSelectColumnScBookingsAggregateBoolExpBoolOrArgumentsColumns["IsActive"] = "is_active";
})(ScBookingsSelectColumnScBookingsAggregateBoolExpBoolOrArgumentsColumns || (ScBookingsSelectColumnScBookingsAggregateBoolExpBoolOrArgumentsColumns = {}));
/** select "sc_bookings_aggregate_bool_exp_corr_arguments_columns" columns of table "spacecloud.bookings" */
export var ScBookingsSelectColumnScBookingsAggregateBoolExpCorrArgumentsColumns;
(function (ScBookingsSelectColumnScBookingsAggregateBoolExpCorrArgumentsColumns) {
    /** column name */
    ScBookingsSelectColumnScBookingsAggregateBoolExpCorrArgumentsColumns["CommonFeeCharge"] = "common_fee_charge";
    /** column name */
    ScBookingsSelectColumnScBookingsAggregateBoolExpCorrArgumentsColumns["DepositFee"] = "deposit_fee";
    /** column name */
    ScBookingsSelectColumnScBookingsAggregateBoolExpCorrArgumentsColumns["ElectricityCharge"] = "electricity_charge";
    /** column name */
    ScBookingsSelectColumnScBookingsAggregateBoolExpCorrArgumentsColumns["InsuranceRental"] = "insurance_rental";
    /** column name */
    ScBookingsSelectColumnScBookingsAggregateBoolExpCorrArgumentsColumns["RentalCost"] = "rental_cost";
    /** column name */
    ScBookingsSelectColumnScBookingsAggregateBoolExpCorrArgumentsColumns["RentalCostPercent"] = "rental_cost_percent";
    /** column name */
    ScBookingsSelectColumnScBookingsAggregateBoolExpCorrArgumentsColumns["WaterCharge"] = "water_charge";
})(ScBookingsSelectColumnScBookingsAggregateBoolExpCorrArgumentsColumns || (ScBookingsSelectColumnScBookingsAggregateBoolExpCorrArgumentsColumns = {}));
/** select "sc_bookings_aggregate_bool_exp_covar_samp_arguments_columns" columns of table "spacecloud.bookings" */
export var ScBookingsSelectColumnScBookingsAggregateBoolExpCovarSampArgumentsColumns;
(function (ScBookingsSelectColumnScBookingsAggregateBoolExpCovarSampArgumentsColumns) {
    /** column name */
    ScBookingsSelectColumnScBookingsAggregateBoolExpCovarSampArgumentsColumns["CommonFeeCharge"] = "common_fee_charge";
    /** column name */
    ScBookingsSelectColumnScBookingsAggregateBoolExpCovarSampArgumentsColumns["DepositFee"] = "deposit_fee";
    /** column name */
    ScBookingsSelectColumnScBookingsAggregateBoolExpCovarSampArgumentsColumns["ElectricityCharge"] = "electricity_charge";
    /** column name */
    ScBookingsSelectColumnScBookingsAggregateBoolExpCovarSampArgumentsColumns["InsuranceRental"] = "insurance_rental";
    /** column name */
    ScBookingsSelectColumnScBookingsAggregateBoolExpCovarSampArgumentsColumns["RentalCost"] = "rental_cost";
    /** column name */
    ScBookingsSelectColumnScBookingsAggregateBoolExpCovarSampArgumentsColumns["RentalCostPercent"] = "rental_cost_percent";
    /** column name */
    ScBookingsSelectColumnScBookingsAggregateBoolExpCovarSampArgumentsColumns["WaterCharge"] = "water_charge";
})(ScBookingsSelectColumnScBookingsAggregateBoolExpCovarSampArgumentsColumns || (ScBookingsSelectColumnScBookingsAggregateBoolExpCovarSampArgumentsColumns = {}));
/** select "sc_bookings_aggregate_bool_exp_max_arguments_columns" columns of table "spacecloud.bookings" */
export var ScBookingsSelectColumnScBookingsAggregateBoolExpMaxArgumentsColumns;
(function (ScBookingsSelectColumnScBookingsAggregateBoolExpMaxArgumentsColumns) {
    /** column name */
    ScBookingsSelectColumnScBookingsAggregateBoolExpMaxArgumentsColumns["CommonFeeCharge"] = "common_fee_charge";
    /** column name */
    ScBookingsSelectColumnScBookingsAggregateBoolExpMaxArgumentsColumns["DepositFee"] = "deposit_fee";
    /** column name */
    ScBookingsSelectColumnScBookingsAggregateBoolExpMaxArgumentsColumns["ElectricityCharge"] = "electricity_charge";
    /** column name */
    ScBookingsSelectColumnScBookingsAggregateBoolExpMaxArgumentsColumns["InsuranceRental"] = "insurance_rental";
    /** column name */
    ScBookingsSelectColumnScBookingsAggregateBoolExpMaxArgumentsColumns["RentalCost"] = "rental_cost";
    /** column name */
    ScBookingsSelectColumnScBookingsAggregateBoolExpMaxArgumentsColumns["RentalCostPercent"] = "rental_cost_percent";
    /** column name */
    ScBookingsSelectColumnScBookingsAggregateBoolExpMaxArgumentsColumns["WaterCharge"] = "water_charge";
})(ScBookingsSelectColumnScBookingsAggregateBoolExpMaxArgumentsColumns || (ScBookingsSelectColumnScBookingsAggregateBoolExpMaxArgumentsColumns = {}));
/** select "sc_bookings_aggregate_bool_exp_min_arguments_columns" columns of table "spacecloud.bookings" */
export var ScBookingsSelectColumnScBookingsAggregateBoolExpMinArgumentsColumns;
(function (ScBookingsSelectColumnScBookingsAggregateBoolExpMinArgumentsColumns) {
    /** column name */
    ScBookingsSelectColumnScBookingsAggregateBoolExpMinArgumentsColumns["CommonFeeCharge"] = "common_fee_charge";
    /** column name */
    ScBookingsSelectColumnScBookingsAggregateBoolExpMinArgumentsColumns["DepositFee"] = "deposit_fee";
    /** column name */
    ScBookingsSelectColumnScBookingsAggregateBoolExpMinArgumentsColumns["ElectricityCharge"] = "electricity_charge";
    /** column name */
    ScBookingsSelectColumnScBookingsAggregateBoolExpMinArgumentsColumns["InsuranceRental"] = "insurance_rental";
    /** column name */
    ScBookingsSelectColumnScBookingsAggregateBoolExpMinArgumentsColumns["RentalCost"] = "rental_cost";
    /** column name */
    ScBookingsSelectColumnScBookingsAggregateBoolExpMinArgumentsColumns["RentalCostPercent"] = "rental_cost_percent";
    /** column name */
    ScBookingsSelectColumnScBookingsAggregateBoolExpMinArgumentsColumns["WaterCharge"] = "water_charge";
})(ScBookingsSelectColumnScBookingsAggregateBoolExpMinArgumentsColumns || (ScBookingsSelectColumnScBookingsAggregateBoolExpMinArgumentsColumns = {}));
/** select "sc_bookings_aggregate_bool_exp_stddev_samp_arguments_columns" columns of table "spacecloud.bookings" */
export var ScBookingsSelectColumnScBookingsAggregateBoolExpStddevSampArgumentsColumns;
(function (ScBookingsSelectColumnScBookingsAggregateBoolExpStddevSampArgumentsColumns) {
    /** column name */
    ScBookingsSelectColumnScBookingsAggregateBoolExpStddevSampArgumentsColumns["CommonFeeCharge"] = "common_fee_charge";
    /** column name */
    ScBookingsSelectColumnScBookingsAggregateBoolExpStddevSampArgumentsColumns["DepositFee"] = "deposit_fee";
    /** column name */
    ScBookingsSelectColumnScBookingsAggregateBoolExpStddevSampArgumentsColumns["ElectricityCharge"] = "electricity_charge";
    /** column name */
    ScBookingsSelectColumnScBookingsAggregateBoolExpStddevSampArgumentsColumns["InsuranceRental"] = "insurance_rental";
    /** column name */
    ScBookingsSelectColumnScBookingsAggregateBoolExpStddevSampArgumentsColumns["RentalCost"] = "rental_cost";
    /** column name */
    ScBookingsSelectColumnScBookingsAggregateBoolExpStddevSampArgumentsColumns["RentalCostPercent"] = "rental_cost_percent";
    /** column name */
    ScBookingsSelectColumnScBookingsAggregateBoolExpStddevSampArgumentsColumns["WaterCharge"] = "water_charge";
})(ScBookingsSelectColumnScBookingsAggregateBoolExpStddevSampArgumentsColumns || (ScBookingsSelectColumnScBookingsAggregateBoolExpStddevSampArgumentsColumns = {}));
/** select "sc_bookings_aggregate_bool_exp_sum_arguments_columns" columns of table "spacecloud.bookings" */
export var ScBookingsSelectColumnScBookingsAggregateBoolExpSumArgumentsColumns;
(function (ScBookingsSelectColumnScBookingsAggregateBoolExpSumArgumentsColumns) {
    /** column name */
    ScBookingsSelectColumnScBookingsAggregateBoolExpSumArgumentsColumns["CommonFeeCharge"] = "common_fee_charge";
    /** column name */
    ScBookingsSelectColumnScBookingsAggregateBoolExpSumArgumentsColumns["DepositFee"] = "deposit_fee";
    /** column name */
    ScBookingsSelectColumnScBookingsAggregateBoolExpSumArgumentsColumns["ElectricityCharge"] = "electricity_charge";
    /** column name */
    ScBookingsSelectColumnScBookingsAggregateBoolExpSumArgumentsColumns["InsuranceRental"] = "insurance_rental";
    /** column name */
    ScBookingsSelectColumnScBookingsAggregateBoolExpSumArgumentsColumns["RentalCost"] = "rental_cost";
    /** column name */
    ScBookingsSelectColumnScBookingsAggregateBoolExpSumArgumentsColumns["RentalCostPercent"] = "rental_cost_percent";
    /** column name */
    ScBookingsSelectColumnScBookingsAggregateBoolExpSumArgumentsColumns["WaterCharge"] = "water_charge";
})(ScBookingsSelectColumnScBookingsAggregateBoolExpSumArgumentsColumns || (ScBookingsSelectColumnScBookingsAggregateBoolExpSumArgumentsColumns = {}));
/** select "sc_bookings_aggregate_bool_exp_var_samp_arguments_columns" columns of table "spacecloud.bookings" */
export var ScBookingsSelectColumnScBookingsAggregateBoolExpVarSampArgumentsColumns;
(function (ScBookingsSelectColumnScBookingsAggregateBoolExpVarSampArgumentsColumns) {
    /** column name */
    ScBookingsSelectColumnScBookingsAggregateBoolExpVarSampArgumentsColumns["CommonFeeCharge"] = "common_fee_charge";
    /** column name */
    ScBookingsSelectColumnScBookingsAggregateBoolExpVarSampArgumentsColumns["DepositFee"] = "deposit_fee";
    /** column name */
    ScBookingsSelectColumnScBookingsAggregateBoolExpVarSampArgumentsColumns["ElectricityCharge"] = "electricity_charge";
    /** column name */
    ScBookingsSelectColumnScBookingsAggregateBoolExpVarSampArgumentsColumns["InsuranceRental"] = "insurance_rental";
    /** column name */
    ScBookingsSelectColumnScBookingsAggregateBoolExpVarSampArgumentsColumns["RentalCost"] = "rental_cost";
    /** column name */
    ScBookingsSelectColumnScBookingsAggregateBoolExpVarSampArgumentsColumns["RentalCostPercent"] = "rental_cost_percent";
    /** column name */
    ScBookingsSelectColumnScBookingsAggregateBoolExpVarSampArgumentsColumns["WaterCharge"] = "water_charge";
})(ScBookingsSelectColumnScBookingsAggregateBoolExpVarSampArgumentsColumns || (ScBookingsSelectColumnScBookingsAggregateBoolExpVarSampArgumentsColumns = {}));
/** update columns of table "spacecloud.bookings" */
export var ScBookingsUpdateColumn;
(function (ScBookingsUpdateColumn) {
    /** column name */
    ScBookingsUpdateColumn["AssetId"] = "asset_id";
    /** column name */
    ScBookingsUpdateColumn["CommonFeeCharge"] = "common_fee_charge";
    /** column name */
    ScBookingsUpdateColumn["CreatedAt"] = "created_at";
    /** column name */
    ScBookingsUpdateColumn["DepositFee"] = "deposit_fee";
    /** column name */
    ScBookingsUpdateColumn["ElectricityCharge"] = "electricity_charge";
    /** column name */
    ScBookingsUpdateColumn["ExampleItems"] = "example_items";
    /** column name */
    ScBookingsUpdateColumn["FirstName"] = "first_name";
    /** column name */
    ScBookingsUpdateColumn["Id"] = "id";
    /** column name */
    ScBookingsUpdateColumn["InsuranceRental"] = "insurance_rental";
    /** column name */
    ScBookingsUpdateColumn["IsActive"] = "is_active";
    /** column name */
    ScBookingsUpdateColumn["LastName"] = "last_name";
    /** column name */
    ScBookingsUpdateColumn["MessageToBooker"] = "message_to_booker";
    /** column name */
    ScBookingsUpdateColumn["MoreInfo"] = "more_info";
    /** column name */
    ScBookingsUpdateColumn["Note"] = "note";
    /** column name */
    ScBookingsUpdateColumn["OrganizationId"] = "organization_id";
    /** column name */
    ScBookingsUpdateColumn["OtherFee"] = "other_fee";
    /** column name */
    ScBookingsUpdateColumn["PeriodType"] = "period_type";
    /** column name */
    ScBookingsUpdateColumn["RejectReason"] = "reject_reason";
    /** column name */
    ScBookingsUpdateColumn["RentalBusinessGroup"] = "rental_business_group";
    /** column name */
    ScBookingsUpdateColumn["RentalCost"] = "rental_cost";
    /** column name */
    ScBookingsUpdateColumn["RentalCostPercent"] = "rental_cost_percent";
    /** column name */
    ScBookingsUpdateColumn["RentalType"] = "rental_type";
    /** column name */
    ScBookingsUpdateColumn["ShopName"] = "shop_name";
    /** column name */
    ScBookingsUpdateColumn["ShopType"] = "shop_type";
    /** column name */
    ScBookingsUpdateColumn["Tel"] = "tel";
    /** column name */
    ScBookingsUpdateColumn["UpdatedAt"] = "updated_at";
    /** column name */
    ScBookingsUpdateColumn["UtilityBillPeriodType"] = "utility_bill_period_type";
    /** column name */
    ScBookingsUpdateColumn["Uuid"] = "uuid";
    /** column name */
    ScBookingsUpdateColumn["WaterCharge"] = "water_charge";
})(ScBookingsUpdateColumn || (ScBookingsUpdateColumn = {}));
/** unique or primary key constraints on table "spacecloud.cctv_cameras" */
export var ScCctvCamerasConstraint;
(function (ScCctvCamerasConstraint) {
    /** unique or primary key constraint on columns "asset_group_annex_id", "alias_name" */
    ScCctvCamerasConstraint["CctvCamerasAliasAssetGroupAnnexUniqueKey"] = "cctv_cameras_alias_asset_group_annex_unique_key";
    /** unique or primary key constraint on columns "id" */
    ScCctvCamerasConstraint["CctvCamerasPkey"] = "cctv_cameras_pkey";
})(ScCctvCamerasConstraint || (ScCctvCamerasConstraint = {}));
/** select columns of table "spacecloud.cctv_cameras" */
export var ScCctvCamerasSelectColumn;
(function (ScCctvCamerasSelectColumn) {
    /** column name */
    ScCctvCamerasSelectColumn["AliasName"] = "alias_name";
    /** column name */
    ScCctvCamerasSelectColumn["AssetGroupAnnexId"] = "asset_group_annex_id";
    /** column name */
    ScCctvCamerasSelectColumn["CountType"] = "count_type";
    /** column name */
    ScCctvCamerasSelectColumn["CreatedAt"] = "created_at";
    /** column name */
    ScCctvCamerasSelectColumn["Description"] = "description";
    /** column name */
    ScCctvCamerasSelectColumn["Id"] = "id";
    /** column name */
    ScCctvCamerasSelectColumn["UpdatedAt"] = "updated_at";
})(ScCctvCamerasSelectColumn || (ScCctvCamerasSelectColumn = {}));
/** update columns of table "spacecloud.cctv_cameras" */
export var ScCctvCamerasUpdateColumn;
(function (ScCctvCamerasUpdateColumn) {
    /** column name */
    ScCctvCamerasUpdateColumn["AliasName"] = "alias_name";
    /** column name */
    ScCctvCamerasUpdateColumn["AssetGroupAnnexId"] = "asset_group_annex_id";
    /** column name */
    ScCctvCamerasUpdateColumn["CountType"] = "count_type";
    /** column name */
    ScCctvCamerasUpdateColumn["CreatedAt"] = "created_at";
    /** column name */
    ScCctvCamerasUpdateColumn["Description"] = "description";
    /** column name */
    ScCctvCamerasUpdateColumn["Id"] = "id";
    /** column name */
    ScCctvCamerasUpdateColumn["UpdatedAt"] = "updated_at";
})(ScCctvCamerasUpdateColumn || (ScCctvCamerasUpdateColumn = {}));
/** unique or primary key constraints on table "spacecloud.cctv_feet_stamptation" */
export var ScCctvFeetStamptationConstraint;
(function (ScCctvFeetStamptationConstraint) {
    /** unique or primary key constraint on columns "id" */
    ScCctvFeetStamptationConstraint["CctvFeetStamptationPkey"] = "cctv_feet_stamptation_pkey";
})(ScCctvFeetStamptationConstraint || (ScCctvFeetStamptationConstraint = {}));
/** select columns of table "spacecloud.cctv_feet_stamptation" */
export var ScCctvFeetStamptationSelectColumn;
(function (ScCctvFeetStamptationSelectColumn) {
    /** column name */
    ScCctvFeetStamptationSelectColumn["CctvCameraId"] = "cctv_camera_id";
    /** column name */
    ScCctvFeetStamptationSelectColumn["CreatedAt"] = "created_at";
    /** column name */
    ScCctvFeetStamptationSelectColumn["EventType"] = "event_type";
    /** column name */
    ScCctvFeetStamptationSelectColumn["Id"] = "id";
    /** column name */
    ScCctvFeetStamptationSelectColumn["StamptationAt"] = "stamptation_at";
    /** column name */
    ScCctvFeetStamptationSelectColumn["UpdatedAt"] = "updated_at";
})(ScCctvFeetStamptationSelectColumn || (ScCctvFeetStamptationSelectColumn = {}));
/** update columns of table "spacecloud.cctv_feet_stamptation" */
export var ScCctvFeetStamptationUpdateColumn;
(function (ScCctvFeetStamptationUpdateColumn) {
    /** column name */
    ScCctvFeetStamptationUpdateColumn["CctvCameraId"] = "cctv_camera_id";
    /** column name */
    ScCctvFeetStamptationUpdateColumn["CreatedAt"] = "created_at";
    /** column name */
    ScCctvFeetStamptationUpdateColumn["EventType"] = "event_type";
    /** column name */
    ScCctvFeetStamptationUpdateColumn["Id"] = "id";
    /** column name */
    ScCctvFeetStamptationUpdateColumn["StamptationAt"] = "stamptation_at";
    /** column name */
    ScCctvFeetStamptationUpdateColumn["UpdatedAt"] = "updated_at";
})(ScCctvFeetStamptationUpdateColumn || (ScCctvFeetStamptationUpdateColumn = {}));
/** unique or primary key constraints on table "spacecloud.contract_info" */
export var ScContractInfoConstraint;
(function (ScContractInfoConstraint) {
    /** unique or primary key constraint on columns "id" */
    ScContractInfoConstraint["PkDe5fc90e42a90a8a9d5233e3f2e"] = "PK_de5fc90e42a90a8a9d5233e3f2e";
})(ScContractInfoConstraint || (ScContractInfoConstraint = {}));
/** select columns of table "spacecloud.contract_info" */
export var ScContractInfoSelectColumn;
(function (ScContractInfoSelectColumn) {
    /** column name */
    ScContractInfoSelectColumn["AssetUuid"] = "asset_uuid";
    /** column name */
    ScContractInfoSelectColumn["CommonFee"] = "common_fee";
    /** column name */
    ScContractInfoSelectColumn["Id"] = "id";
    /** column name */
    ScContractInfoSelectColumn["Percent"] = "percent";
    /** column name */
    ScContractInfoSelectColumn["PeriodType"] = "period_type";
    /** column name */
    ScContractInfoSelectColumn["RentalPrice"] = "rental_price";
    /** column name */
    ScContractInfoSelectColumn["RentalType"] = "rental_type";
})(ScContractInfoSelectColumn || (ScContractInfoSelectColumn = {}));
/** select "sc_contract_info_aggregate_bool_exp_avg_arguments_columns" columns of table "spacecloud.contract_info" */
export var ScContractInfoSelectColumnScContractInfoAggregateBoolExpAvgArgumentsColumns;
(function (ScContractInfoSelectColumnScContractInfoAggregateBoolExpAvgArgumentsColumns) {
    /** column name */
    ScContractInfoSelectColumnScContractInfoAggregateBoolExpAvgArgumentsColumns["CommonFee"] = "common_fee";
    /** column name */
    ScContractInfoSelectColumnScContractInfoAggregateBoolExpAvgArgumentsColumns["Percent"] = "percent";
})(ScContractInfoSelectColumnScContractInfoAggregateBoolExpAvgArgumentsColumns || (ScContractInfoSelectColumnScContractInfoAggregateBoolExpAvgArgumentsColumns = {}));
/** select "sc_contract_info_aggregate_bool_exp_corr_arguments_columns" columns of table "spacecloud.contract_info" */
export var ScContractInfoSelectColumnScContractInfoAggregateBoolExpCorrArgumentsColumns;
(function (ScContractInfoSelectColumnScContractInfoAggregateBoolExpCorrArgumentsColumns) {
    /** column name */
    ScContractInfoSelectColumnScContractInfoAggregateBoolExpCorrArgumentsColumns["CommonFee"] = "common_fee";
    /** column name */
    ScContractInfoSelectColumnScContractInfoAggregateBoolExpCorrArgumentsColumns["Percent"] = "percent";
})(ScContractInfoSelectColumnScContractInfoAggregateBoolExpCorrArgumentsColumns || (ScContractInfoSelectColumnScContractInfoAggregateBoolExpCorrArgumentsColumns = {}));
/** select "sc_contract_info_aggregate_bool_exp_covar_samp_arguments_columns" columns of table "spacecloud.contract_info" */
export var ScContractInfoSelectColumnScContractInfoAggregateBoolExpCovarSampArgumentsColumns;
(function (ScContractInfoSelectColumnScContractInfoAggregateBoolExpCovarSampArgumentsColumns) {
    /** column name */
    ScContractInfoSelectColumnScContractInfoAggregateBoolExpCovarSampArgumentsColumns["CommonFee"] = "common_fee";
    /** column name */
    ScContractInfoSelectColumnScContractInfoAggregateBoolExpCovarSampArgumentsColumns["Percent"] = "percent";
})(ScContractInfoSelectColumnScContractInfoAggregateBoolExpCovarSampArgumentsColumns || (ScContractInfoSelectColumnScContractInfoAggregateBoolExpCovarSampArgumentsColumns = {}));
/** select "sc_contract_info_aggregate_bool_exp_max_arguments_columns" columns of table "spacecloud.contract_info" */
export var ScContractInfoSelectColumnScContractInfoAggregateBoolExpMaxArgumentsColumns;
(function (ScContractInfoSelectColumnScContractInfoAggregateBoolExpMaxArgumentsColumns) {
    /** column name */
    ScContractInfoSelectColumnScContractInfoAggregateBoolExpMaxArgumentsColumns["CommonFee"] = "common_fee";
    /** column name */
    ScContractInfoSelectColumnScContractInfoAggregateBoolExpMaxArgumentsColumns["Percent"] = "percent";
})(ScContractInfoSelectColumnScContractInfoAggregateBoolExpMaxArgumentsColumns || (ScContractInfoSelectColumnScContractInfoAggregateBoolExpMaxArgumentsColumns = {}));
/** select "sc_contract_info_aggregate_bool_exp_min_arguments_columns" columns of table "spacecloud.contract_info" */
export var ScContractInfoSelectColumnScContractInfoAggregateBoolExpMinArgumentsColumns;
(function (ScContractInfoSelectColumnScContractInfoAggregateBoolExpMinArgumentsColumns) {
    /** column name */
    ScContractInfoSelectColumnScContractInfoAggregateBoolExpMinArgumentsColumns["CommonFee"] = "common_fee";
    /** column name */
    ScContractInfoSelectColumnScContractInfoAggregateBoolExpMinArgumentsColumns["Percent"] = "percent";
})(ScContractInfoSelectColumnScContractInfoAggregateBoolExpMinArgumentsColumns || (ScContractInfoSelectColumnScContractInfoAggregateBoolExpMinArgumentsColumns = {}));
/** select "sc_contract_info_aggregate_bool_exp_stddev_samp_arguments_columns" columns of table "spacecloud.contract_info" */
export var ScContractInfoSelectColumnScContractInfoAggregateBoolExpStddevSampArgumentsColumns;
(function (ScContractInfoSelectColumnScContractInfoAggregateBoolExpStddevSampArgumentsColumns) {
    /** column name */
    ScContractInfoSelectColumnScContractInfoAggregateBoolExpStddevSampArgumentsColumns["CommonFee"] = "common_fee";
    /** column name */
    ScContractInfoSelectColumnScContractInfoAggregateBoolExpStddevSampArgumentsColumns["Percent"] = "percent";
})(ScContractInfoSelectColumnScContractInfoAggregateBoolExpStddevSampArgumentsColumns || (ScContractInfoSelectColumnScContractInfoAggregateBoolExpStddevSampArgumentsColumns = {}));
/** select "sc_contract_info_aggregate_bool_exp_sum_arguments_columns" columns of table "spacecloud.contract_info" */
export var ScContractInfoSelectColumnScContractInfoAggregateBoolExpSumArgumentsColumns;
(function (ScContractInfoSelectColumnScContractInfoAggregateBoolExpSumArgumentsColumns) {
    /** column name */
    ScContractInfoSelectColumnScContractInfoAggregateBoolExpSumArgumentsColumns["CommonFee"] = "common_fee";
    /** column name */
    ScContractInfoSelectColumnScContractInfoAggregateBoolExpSumArgumentsColumns["Percent"] = "percent";
})(ScContractInfoSelectColumnScContractInfoAggregateBoolExpSumArgumentsColumns || (ScContractInfoSelectColumnScContractInfoAggregateBoolExpSumArgumentsColumns = {}));
/** select "sc_contract_info_aggregate_bool_exp_var_samp_arguments_columns" columns of table "spacecloud.contract_info" */
export var ScContractInfoSelectColumnScContractInfoAggregateBoolExpVarSampArgumentsColumns;
(function (ScContractInfoSelectColumnScContractInfoAggregateBoolExpVarSampArgumentsColumns) {
    /** column name */
    ScContractInfoSelectColumnScContractInfoAggregateBoolExpVarSampArgumentsColumns["CommonFee"] = "common_fee";
    /** column name */
    ScContractInfoSelectColumnScContractInfoAggregateBoolExpVarSampArgumentsColumns["Percent"] = "percent";
})(ScContractInfoSelectColumnScContractInfoAggregateBoolExpVarSampArgumentsColumns || (ScContractInfoSelectColumnScContractInfoAggregateBoolExpVarSampArgumentsColumns = {}));
/** update columns of table "spacecloud.contract_info" */
export var ScContractInfoUpdateColumn;
(function (ScContractInfoUpdateColumn) {
    /** column name */
    ScContractInfoUpdateColumn["AssetUuid"] = "asset_uuid";
    /** column name */
    ScContractInfoUpdateColumn["CommonFee"] = "common_fee";
    /** column name */
    ScContractInfoUpdateColumn["Id"] = "id";
    /** column name */
    ScContractInfoUpdateColumn["Percent"] = "percent";
    /** column name */
    ScContractInfoUpdateColumn["PeriodType"] = "period_type";
    /** column name */
    ScContractInfoUpdateColumn["RentalPrice"] = "rental_price";
    /** column name */
    ScContractInfoUpdateColumn["RentalType"] = "rental_type";
})(ScContractInfoUpdateColumn || (ScContractInfoUpdateColumn = {}));
/** unique or primary key constraints on table "spacecloud.enum_cctv_cameras_count_type" */
export var ScEnumCctvCamerasCountTypeConstraint;
(function (ScEnumCctvCamerasCountTypeConstraint) {
    /** unique or primary key constraint on columns "value" */
    ScEnumCctvCamerasCountTypeConstraint["EnumCctvCamerasCountTypePkey"] = "enum_cctv_cameras_count_type_pkey";
})(ScEnumCctvCamerasCountTypeConstraint || (ScEnumCctvCamerasCountTypeConstraint = {}));
export var ScEnumCctvCamerasCountTypeEnum;
(function (ScEnumCctvCamerasCountTypeEnum) {
    ScEnumCctvCamerasCountTypeEnum["Enter"] = "enter";
    ScEnumCctvCamerasCountTypeEnum["EnterAndExit"] = "enter_and_exit";
    ScEnumCctvCamerasCountTypeEnum["Exit"] = "exit";
})(ScEnumCctvCamerasCountTypeEnum || (ScEnumCctvCamerasCountTypeEnum = {}));
/** select columns of table "spacecloud.enum_cctv_cameras_count_type" */
export var ScEnumCctvCamerasCountTypeSelectColumn;
(function (ScEnumCctvCamerasCountTypeSelectColumn) {
    /** column name */
    ScEnumCctvCamerasCountTypeSelectColumn["Value"] = "value";
})(ScEnumCctvCamerasCountTypeSelectColumn || (ScEnumCctvCamerasCountTypeSelectColumn = {}));
/** update columns of table "spacecloud.enum_cctv_cameras_count_type" */
export var ScEnumCctvCamerasCountTypeUpdateColumn;
(function (ScEnumCctvCamerasCountTypeUpdateColumn) {
    /** column name */
    ScEnumCctvCamerasCountTypeUpdateColumn["Value"] = "value";
})(ScEnumCctvCamerasCountTypeUpdateColumn || (ScEnumCctvCamerasCountTypeUpdateColumn = {}));
/** unique or primary key constraints on table "spacecloud.enum_cctv_feet_stamptation_event_type" */
export var ScEnumCctvFeetStamptationEventTypeConstraint;
(function (ScEnumCctvFeetStamptationEventTypeConstraint) {
    /** unique or primary key constraint on columns "value" */
    ScEnumCctvFeetStamptationEventTypeConstraint["EnumCctvFeetStamptationEventTypePkey"] = "enum_cctv_feet_stamptation_event_type_pkey";
})(ScEnumCctvFeetStamptationEventTypeConstraint || (ScEnumCctvFeetStamptationEventTypeConstraint = {}));
export var ScEnumCctvFeetStamptationEventTypeEnum;
(function (ScEnumCctvFeetStamptationEventTypeEnum) {
    ScEnumCctvFeetStamptationEventTypeEnum["Enter"] = "enter";
    ScEnumCctvFeetStamptationEventTypeEnum["Exit"] = "exit";
})(ScEnumCctvFeetStamptationEventTypeEnum || (ScEnumCctvFeetStamptationEventTypeEnum = {}));
/** select columns of table "spacecloud.enum_cctv_feet_stamptation_event_type" */
export var ScEnumCctvFeetStamptationEventTypeSelectColumn;
(function (ScEnumCctvFeetStamptationEventTypeSelectColumn) {
    /** column name */
    ScEnumCctvFeetStamptationEventTypeSelectColumn["Value"] = "value";
})(ScEnumCctvFeetStamptationEventTypeSelectColumn || (ScEnumCctvFeetStamptationEventTypeSelectColumn = {}));
/** update columns of table "spacecloud.enum_cctv_feet_stamptation_event_type" */
export var ScEnumCctvFeetStamptationEventTypeUpdateColumn;
(function (ScEnumCctvFeetStamptationEventTypeUpdateColumn) {
    /** column name */
    ScEnumCctvFeetStamptationEventTypeUpdateColumn["Value"] = "value";
})(ScEnumCctvFeetStamptationEventTypeUpdateColumn || (ScEnumCctvFeetStamptationEventTypeUpdateColumn = {}));
/** unique or primary key constraints on table "spacecloud.enum_near_place_type" */
export var ScEnumNearPlaceTypeConstraint;
(function (ScEnumNearPlaceTypeConstraint) {
    /** unique or primary key constraint on columns "value" */
    ScEnumNearPlaceTypeConstraint["EnumNearPlaceTypePkey"] = "enum_near_place_type_pkey";
})(ScEnumNearPlaceTypeConstraint || (ScEnumNearPlaceTypeConstraint = {}));
export var ScEnumNearPlaceTypeEnum;
(function (ScEnumNearPlaceTypeEnum) {
    /** department store */
    ScEnumNearPlaceTypeEnum["DepartmentStore"] = "department_store";
    /** famous brand */
    ScEnumNearPlaceTypeEnum["FamousBrand"] = "famous_brand";
    /** institute */
    ScEnumNearPlaceTypeEnum["Institute"] = "institute";
    /** office building */
    ScEnumNearPlaceTypeEnum["OfficeBuilding"] = "office_building";
    /** residence */
    ScEnumNearPlaceTypeEnum["Residence"] = "residence";
    /** train station */
    ScEnumNearPlaceTypeEnum["TrainStation"] = "train_station";
})(ScEnumNearPlaceTypeEnum || (ScEnumNearPlaceTypeEnum = {}));
/** select columns of table "spacecloud.enum_near_place_type" */
export var ScEnumNearPlaceTypeSelectColumn;
(function (ScEnumNearPlaceTypeSelectColumn) {
    /** column name */
    ScEnumNearPlaceTypeSelectColumn["Description"] = "description";
    /** column name */
    ScEnumNearPlaceTypeSelectColumn["Value"] = "value";
})(ScEnumNearPlaceTypeSelectColumn || (ScEnumNearPlaceTypeSelectColumn = {}));
/** update columns of table "spacecloud.enum_near_place_type" */
export var ScEnumNearPlaceTypeUpdateColumn;
(function (ScEnumNearPlaceTypeUpdateColumn) {
    /** column name */
    ScEnumNearPlaceTypeUpdateColumn["Description"] = "description";
    /** column name */
    ScEnumNearPlaceTypeUpdateColumn["Value"] = "value";
})(ScEnumNearPlaceTypeUpdateColumn || (ScEnumNearPlaceTypeUpdateColumn = {}));
/** unique or primary key constraints on table "spacecloud.enum_neighborhood_type" */
export var ScEnumNeighborhoodTypeConstraint;
(function (ScEnumNeighborhoodTypeConstraint) {
    /** unique or primary key constraint on columns "value" */
    ScEnumNeighborhoodTypeConstraint["EnumNeighborhoodTypePkey"] = "enum_neighborhood_type_pkey";
})(ScEnumNeighborhoodTypeConstraint || (ScEnumNeighborhoodTypeConstraint = {}));
export var ScEnumNeighborhoodTypeEnum;
(function (ScEnumNeighborhoodTypeEnum) {
    /** CBD */
    ScEnumNeighborhoodTypeEnum["Cbd"] = "cbd";
    /** Outer CBD */
    ScEnumNeighborhoodTypeEnum["OuterCbd"] = "outer_cbd";
    /** Residential */
    ScEnumNeighborhoodTypeEnum["Residential"] = "residential";
    /** Sub Urban */
    ScEnumNeighborhoodTypeEnum["SubUrban"] = "sub_urban";
})(ScEnumNeighborhoodTypeEnum || (ScEnumNeighborhoodTypeEnum = {}));
/** select columns of table "spacecloud.enum_neighborhood_type" */
export var ScEnumNeighborhoodTypeSelectColumn;
(function (ScEnumNeighborhoodTypeSelectColumn) {
    /** column name */
    ScEnumNeighborhoodTypeSelectColumn["Description"] = "description";
    /** column name */
    ScEnumNeighborhoodTypeSelectColumn["Value"] = "value";
})(ScEnumNeighborhoodTypeSelectColumn || (ScEnumNeighborhoodTypeSelectColumn = {}));
/** update columns of table "spacecloud.enum_neighborhood_type" */
export var ScEnumNeighborhoodTypeUpdateColumn;
(function (ScEnumNeighborhoodTypeUpdateColumn) {
    /** column name */
    ScEnumNeighborhoodTypeUpdateColumn["Description"] = "description";
    /** column name */
    ScEnumNeighborhoodTypeUpdateColumn["Value"] = "value";
})(ScEnumNeighborhoodTypeUpdateColumn || (ScEnumNeighborhoodTypeUpdateColumn = {}));
/** unique or primary key constraints on table "spacecloud.enum_period_types" */
export var ScEnumPeriodTypesConstraint;
(function (ScEnumPeriodTypesConstraint) {
    /** unique or primary key constraint on columns "value" */
    ScEnumPeriodTypesConstraint["EnumPeriodTypesPkey"] = "enum_period_types_pkey";
})(ScEnumPeriodTypesConstraint || (ScEnumPeriodTypesConstraint = {}));
export var ScEnumPeriodTypesEnum;
(function (ScEnumPeriodTypesEnum) {
    ScEnumPeriodTypesEnum["Daily"] = "daily";
    ScEnumPeriodTypesEnum["Monthly"] = "monthly";
    ScEnumPeriodTypesEnum["Weekly"] = "weekly";
})(ScEnumPeriodTypesEnum || (ScEnumPeriodTypesEnum = {}));
/** select columns of table "spacecloud.enum_period_types" */
export var ScEnumPeriodTypesSelectColumn;
(function (ScEnumPeriodTypesSelectColumn) {
    /** column name */
    ScEnumPeriodTypesSelectColumn["Value"] = "value";
})(ScEnumPeriodTypesSelectColumn || (ScEnumPeriodTypesSelectColumn = {}));
/** update columns of table "spacecloud.enum_period_types" */
export var ScEnumPeriodTypesUpdateColumn;
(function (ScEnumPeriodTypesUpdateColumn) {
    /** column name */
    ScEnumPeriodTypesUpdateColumn["Value"] = "value";
})(ScEnumPeriodTypesUpdateColumn || (ScEnumPeriodTypesUpdateColumn = {}));
/** unique or primary key constraints on table "spacecloud.enum_purchasing_power_type" */
export var ScEnumPurchasingPowerTypeConstraint;
(function (ScEnumPurchasingPowerTypeConstraint) {
    /** unique or primary key constraint on columns "value" */
    ScEnumPurchasingPowerTypeConstraint["EnumPurchasingPowerTypePkey"] = "enum_purchasing_power_type_pkey";
})(ScEnumPurchasingPowerTypeConstraint || (ScEnumPurchasingPowerTypeConstraint = {}));
export var ScEnumPurchasingPowerTypeEnum;
(function (ScEnumPurchasingPowerTypeEnum) {
    /** HNW */
    ScEnumPurchasingPowerTypeEnum["Hnw"] = "hnw";
    /** Lower Mid */
    ScEnumPurchasingPowerTypeEnum["LowerMid"] = "lower_mid";
    /** Mass */
    ScEnumPurchasingPowerTypeEnum["Mass"] = "mass";
    /** Upper Mid */
    ScEnumPurchasingPowerTypeEnum["UpperMid"] = "upper_mid";
})(ScEnumPurchasingPowerTypeEnum || (ScEnumPurchasingPowerTypeEnum = {}));
/** select columns of table "spacecloud.enum_purchasing_power_type" */
export var ScEnumPurchasingPowerTypeSelectColumn;
(function (ScEnumPurchasingPowerTypeSelectColumn) {
    /** column name */
    ScEnumPurchasingPowerTypeSelectColumn["Description"] = "description";
    /** column name */
    ScEnumPurchasingPowerTypeSelectColumn["Value"] = "value";
})(ScEnumPurchasingPowerTypeSelectColumn || (ScEnumPurchasingPowerTypeSelectColumn = {}));
/** update columns of table "spacecloud.enum_purchasing_power_type" */
export var ScEnumPurchasingPowerTypeUpdateColumn;
(function (ScEnumPurchasingPowerTypeUpdateColumn) {
    /** column name */
    ScEnumPurchasingPowerTypeUpdateColumn["Description"] = "description";
    /** column name */
    ScEnumPurchasingPowerTypeUpdateColumn["Value"] = "value";
})(ScEnumPurchasingPowerTypeUpdateColumn || (ScEnumPurchasingPowerTypeUpdateColumn = {}));
/** unique or primary key constraints on table "spacecloud.enum_rental_business_groups" */
export var ScEnumRentalBusinessGroupsConstraint;
(function (ScEnumRentalBusinessGroupsConstraint) {
    /** unique or primary key constraint on columns "value" */
    ScEnumRentalBusinessGroupsConstraint["EnumRentalBusinessGroupsPkey"] = "enum_rental_business_groups_pkey";
})(ScEnumRentalBusinessGroupsConstraint || (ScEnumRentalBusinessGroupsConstraint = {}));
export var ScEnumRentalBusinessGroupsEnum;
(function (ScEnumRentalBusinessGroupsEnum) {
    ScEnumRentalBusinessGroupsEnum["Appetizers"] = "appetizers";
    ScEnumRentalBusinessGroupsEnum["Clinic"] = "clinic";
    ScEnumRentalBusinessGroupsEnum["CommonStuff"] = "common_stuff";
    ScEnumRentalBusinessGroupsEnum["DrinkShop"] = "drink_shop";
    ScEnumRentalBusinessGroupsEnum["Fashion"] = "fashion";
    ScEnumRentalBusinessGroupsEnum["Lifestyle"] = "lifestyle";
    ScEnumRentalBusinessGroupsEnum["MainDishes"] = "main_dishes";
    ScEnumRentalBusinessGroupsEnum["Others"] = "others";
    ScEnumRentalBusinessGroupsEnum["Specialty"] = "specialty";
})(ScEnumRentalBusinessGroupsEnum || (ScEnumRentalBusinessGroupsEnum = {}));
/** select columns of table "spacecloud.enum_rental_business_groups" */
export var ScEnumRentalBusinessGroupsSelectColumn;
(function (ScEnumRentalBusinessGroupsSelectColumn) {
    /** column name */
    ScEnumRentalBusinessGroupsSelectColumn["Value"] = "value";
})(ScEnumRentalBusinessGroupsSelectColumn || (ScEnumRentalBusinessGroupsSelectColumn = {}));
/** update columns of table "spacecloud.enum_rental_business_groups" */
export var ScEnumRentalBusinessGroupsUpdateColumn;
(function (ScEnumRentalBusinessGroupsUpdateColumn) {
    /** column name */
    ScEnumRentalBusinessGroupsUpdateColumn["Value"] = "value";
})(ScEnumRentalBusinessGroupsUpdateColumn || (ScEnumRentalBusinessGroupsUpdateColumn = {}));
/** unique or primary key constraints on table "spacecloud.enum_rental_types" */
export var ScEnumRentalTypesConstraint;
(function (ScEnumRentalTypesConstraint) {
    /** unique or primary key constraint on columns "value" */
    ScEnumRentalTypesConstraint["EnumRentalTypesPkey"] = "enum_rental_types_pkey";
})(ScEnumRentalTypesConstraint || (ScEnumRentalTypesConstraint = {}));
export var ScEnumRentalTypesEnum;
(function (ScEnumRentalTypesEnum) {
    ScEnumRentalTypesEnum["Fixed"] = "fixed";
    ScEnumRentalTypesEnum["Float"] = "float";
    ScEnumRentalTypesEnum["Negotiable"] = "negotiable";
})(ScEnumRentalTypesEnum || (ScEnumRentalTypesEnum = {}));
/** select columns of table "spacecloud.enum_rental_types" */
export var ScEnumRentalTypesSelectColumn;
(function (ScEnumRentalTypesSelectColumn) {
    /** column name */
    ScEnumRentalTypesSelectColumn["Value"] = "value";
})(ScEnumRentalTypesSelectColumn || (ScEnumRentalTypesSelectColumn = {}));
/** update columns of table "spacecloud.enum_rental_types" */
export var ScEnumRentalTypesUpdateColumn;
(function (ScEnumRentalTypesUpdateColumn) {
    /** column name */
    ScEnumRentalTypesUpdateColumn["Value"] = "value";
})(ScEnumRentalTypesUpdateColumn || (ScEnumRentalTypesUpdateColumn = {}));
/** unique or primary key constraints on table "spacecloud.enum_user_preference_asset_types" */
export var ScEnumUserPreferenceAssetTypesConstraint;
(function (ScEnumUserPreferenceAssetTypesConstraint) {
    /** unique or primary key constraint on columns "value" */
    ScEnumUserPreferenceAssetTypesConstraint["EnumUserPreferenceAssetTypesPkey"] = "enum_user_preference_asset_types_pkey";
})(ScEnumUserPreferenceAssetTypesConstraint || (ScEnumUserPreferenceAssetTypesConstraint = {}));
export var ScEnumUserPreferenceAssetTypesEnum;
(function (ScEnumUserPreferenceAssetTypesEnum) {
    /** Commercial Building */
    ScEnumUserPreferenceAssetTypesEnum["CommercialBuilding"] = "commercial_building";
    /** Community Mall */
    ScEnumUserPreferenceAssetTypesEnum["CommunityMall"] = "community_mall";
    /** Gas Station */
    ScEnumUserPreferenceAssetTypesEnum["GasStation"] = "gas_station";
    /** Market */
    ScEnumUserPreferenceAssetTypesEnum["Market"] = "market";
    /** Office Building */
    ScEnumUserPreferenceAssetTypesEnum["OfficeBuilding"] = "office_building";
    /** Others */
    ScEnumUserPreferenceAssetTypesEnum["Others"] = "others";
    /** Shop House */
    ScEnumUserPreferenceAssetTypesEnum["ShopHouse"] = "shop_house";
    /** Shopping Mall */
    ScEnumUserPreferenceAssetTypesEnum["ShoppingMall"] = "shopping_mall";
    /** Specialty Store */
    ScEnumUserPreferenceAssetTypesEnum["SpecialtyStore"] = "specialty_store";
})(ScEnumUserPreferenceAssetTypesEnum || (ScEnumUserPreferenceAssetTypesEnum = {}));
/** select columns of table "spacecloud.enum_user_preference_asset_types" */
export var ScEnumUserPreferenceAssetTypesSelectColumn;
(function (ScEnumUserPreferenceAssetTypesSelectColumn) {
    /** column name */
    ScEnumUserPreferenceAssetTypesSelectColumn["Description"] = "description";
    /** column name */
    ScEnumUserPreferenceAssetTypesSelectColumn["Value"] = "value";
})(ScEnumUserPreferenceAssetTypesSelectColumn || (ScEnumUserPreferenceAssetTypesSelectColumn = {}));
/** update columns of table "spacecloud.enum_user_preference_asset_types" */
export var ScEnumUserPreferenceAssetTypesUpdateColumn;
(function (ScEnumUserPreferenceAssetTypesUpdateColumn) {
    /** column name */
    ScEnumUserPreferenceAssetTypesUpdateColumn["Description"] = "description";
    /** column name */
    ScEnumUserPreferenceAssetTypesUpdateColumn["Value"] = "value";
})(ScEnumUserPreferenceAssetTypesUpdateColumn || (ScEnumUserPreferenceAssetTypesUpdateColumn = {}));
/** unique or primary key constraints on table "spacecloud.enum_utility_bill_period_types" */
export var ScEnumUtilityBillPeriodTypesConstraint;
(function (ScEnumUtilityBillPeriodTypesConstraint) {
    /** unique or primary key constraint on columns "value" */
    ScEnumUtilityBillPeriodTypesConstraint["EnumUtilityBillPeriodTypesPkey"] = "enum_utility_bill_period_types_pkey";
})(ScEnumUtilityBillPeriodTypesConstraint || (ScEnumUtilityBillPeriodTypesConstraint = {}));
export var ScEnumUtilityBillPeriodTypesEnum;
(function (ScEnumUtilityBillPeriodTypesEnum) {
    ScEnumUtilityBillPeriodTypesEnum["FixedDaily"] = "fixed_daily";
    ScEnumUtilityBillPeriodTypesEnum["FixedMonthly"] = "fixed_monthly";
    ScEnumUtilityBillPeriodTypesEnum["FixedWeekly"] = "fixed_weekly";
    ScEnumUtilityBillPeriodTypesEnum["PerUnitDaily"] = "per_unit_daily";
    ScEnumUtilityBillPeriodTypesEnum["PerUnitMonthly"] = "per_unit_monthly";
    ScEnumUtilityBillPeriodTypesEnum["PerUnitWeekly"] = "per_unit_weekly";
})(ScEnumUtilityBillPeriodTypesEnum || (ScEnumUtilityBillPeriodTypesEnum = {}));
/** select columns of table "spacecloud.enum_utility_bill_period_types" */
export var ScEnumUtilityBillPeriodTypesSelectColumn;
(function (ScEnumUtilityBillPeriodTypesSelectColumn) {
    /** column name */
    ScEnumUtilityBillPeriodTypesSelectColumn["Value"] = "value";
})(ScEnumUtilityBillPeriodTypesSelectColumn || (ScEnumUtilityBillPeriodTypesSelectColumn = {}));
/** update columns of table "spacecloud.enum_utility_bill_period_types" */
export var ScEnumUtilityBillPeriodTypesUpdateColumn;
(function (ScEnumUtilityBillPeriodTypesUpdateColumn) {
    /** column name */
    ScEnumUtilityBillPeriodTypesUpdateColumn["Value"] = "value";
})(ScEnumUtilityBillPeriodTypesUpdateColumn || (ScEnumUtilityBillPeriodTypesUpdateColumn = {}));
/** unique or primary key constraints on table "spacecloud.existing_brand_asset_group_premium_info" */
export var ScExistingBrandAssetGroupPremiumInfoConstraint;
(function (ScExistingBrandAssetGroupPremiumInfoConstraint) {
    /** unique or primary key constraint on columns "id" */
    ScExistingBrandAssetGroupPremiumInfoConstraint["ExistingBrandAssetGroupPremiumInfoPkey"] = "existing_brand_asset_group_premium_info_pkey";
})(ScExistingBrandAssetGroupPremiumInfoConstraint || (ScExistingBrandAssetGroupPremiumInfoConstraint = {}));
/** select columns of table "spacecloud.existing_brand_asset_group_premium_info" */
export var ScExistingBrandAssetGroupPremiumInfoSelectColumn;
(function (ScExistingBrandAssetGroupPremiumInfoSelectColumn) {
    /** column name */
    ScExistingBrandAssetGroupPremiumInfoSelectColumn["AssetGroupPremiumInfoId"] = "asset_group_premium_info_id";
    /** column name */
    ScExistingBrandAssetGroupPremiumInfoSelectColumn["ExistingBrandId"] = "existing_brand_id";
    /** column name */
    ScExistingBrandAssetGroupPremiumInfoSelectColumn["Id"] = "id";
})(ScExistingBrandAssetGroupPremiumInfoSelectColumn || (ScExistingBrandAssetGroupPremiumInfoSelectColumn = {}));
/** update columns of table "spacecloud.existing_brand_asset_group_premium_info" */
export var ScExistingBrandAssetGroupPremiumInfoUpdateColumn;
(function (ScExistingBrandAssetGroupPremiumInfoUpdateColumn) {
    /** column name */
    ScExistingBrandAssetGroupPremiumInfoUpdateColumn["AssetGroupPremiumInfoId"] = "asset_group_premium_info_id";
    /** column name */
    ScExistingBrandAssetGroupPremiumInfoUpdateColumn["ExistingBrandId"] = "existing_brand_id";
    /** column name */
    ScExistingBrandAssetGroupPremiumInfoUpdateColumn["Id"] = "id";
})(ScExistingBrandAssetGroupPremiumInfoUpdateColumn || (ScExistingBrandAssetGroupPremiumInfoUpdateColumn = {}));
/** unique or primary key constraints on table "spacecloud.existing_brands" */
export var ScExistingBrandsConstraint;
(function (ScExistingBrandsConstraint) {
    /** unique or primary key constraint on columns "id" */
    ScExistingBrandsConstraint["ExistingBrandsPkey"] = "existing_brands_pkey";
})(ScExistingBrandsConstraint || (ScExistingBrandsConstraint = {}));
/** select columns of table "spacecloud.existing_brands" */
export var ScExistingBrandsSelectColumn;
(function (ScExistingBrandsSelectColumn) {
    /** column name */
    ScExistingBrandsSelectColumn["Id"] = "id";
    /** column name */
    ScExistingBrandsSelectColumn["ImageUrl"] = "image_url";
    /** column name */
    ScExistingBrandsSelectColumn["Name"] = "name";
})(ScExistingBrandsSelectColumn || (ScExistingBrandsSelectColumn = {}));
/** update columns of table "spacecloud.existing_brands" */
export var ScExistingBrandsUpdateColumn;
(function (ScExistingBrandsUpdateColumn) {
    /** column name */
    ScExistingBrandsUpdateColumn["Id"] = "id";
    /** column name */
    ScExistingBrandsUpdateColumn["ImageUrl"] = "image_url";
    /** column name */
    ScExistingBrandsUpdateColumn["Name"] = "name";
})(ScExistingBrandsUpdateColumn || (ScExistingBrandsUpdateColumn = {}));
/** unique or primary key constraints on table "spacecloud.favorites" */
export var ScFavoritesConstraint;
(function (ScFavoritesConstraint) {
    /** unique or primary key constraint on columns "id" */
    ScFavoritesConstraint["Pk_890818d27523748dd36a4d1bdc8"] = "PK_890818d27523748dd36a4d1bdc8";
    /** unique or primary key constraint on columns "interested_target_uuid", "user_uuid" */
    ScFavoritesConstraint["FavoritesUserUuidInterestedTargetUuidKey"] = "favorites_user_uuid_interested_target_uuid_key";
})(ScFavoritesConstraint || (ScFavoritesConstraint = {}));
/** select columns of table "spacecloud.favorites" */
export var ScFavoritesSelectColumn;
(function (ScFavoritesSelectColumn) {
    /** column name */
    ScFavoritesSelectColumn["CreatedAt"] = "created_at";
    /** column name */
    ScFavoritesSelectColumn["Id"] = "id";
    /** column name */
    ScFavoritesSelectColumn["InterestedTargetUuid"] = "interested_target_uuid";
    /** column name */
    ScFavoritesSelectColumn["OrganizationId"] = "organization_id";
    /** column name */
    ScFavoritesSelectColumn["Type"] = "type";
    /** column name */
    ScFavoritesSelectColumn["UpdatedAt"] = "updated_at";
    /** column name */
    ScFavoritesSelectColumn["UserUuid"] = "user_uuid";
})(ScFavoritesSelectColumn || (ScFavoritesSelectColumn = {}));
/** update columns of table "spacecloud.favorites" */
export var ScFavoritesUpdateColumn;
(function (ScFavoritesUpdateColumn) {
    /** column name */
    ScFavoritesUpdateColumn["CreatedAt"] = "created_at";
    /** column name */
    ScFavoritesUpdateColumn["Id"] = "id";
    /** column name */
    ScFavoritesUpdateColumn["InterestedTargetUuid"] = "interested_target_uuid";
    /** column name */
    ScFavoritesUpdateColumn["OrganizationId"] = "organization_id";
    /** column name */
    ScFavoritesUpdateColumn["Type"] = "type";
    /** column name */
    ScFavoritesUpdateColumn["UpdatedAt"] = "updated_at";
    /** column name */
    ScFavoritesUpdateColumn["UserUuid"] = "user_uuid";
})(ScFavoritesUpdateColumn || (ScFavoritesUpdateColumn = {}));
/** select columns of table "spacecloud.feet_stamptation_heatmap_sumup" */
export var ScFeetStamptationHeatmapSumupSelectColumn;
(function (ScFeetStamptationHeatmapSumupSelectColumn) {
    /** column name */
    ScFeetStamptationHeatmapSumupSelectColumn["CctvCameraId"] = "cctv_camera_id";
    /** column name */
    ScFeetStamptationHeatmapSumupSelectColumn["DateEnd"] = "date_end";
    /** column name */
    ScFeetStamptationHeatmapSumupSelectColumn["DateStart"] = "date_start";
    /** column name */
    ScFeetStamptationHeatmapSumupSelectColumn["TrafficAmount"] = "traffic_amount";
    /** column name */
    ScFeetStamptationHeatmapSumupSelectColumn["VideoUrl"] = "video_url";
})(ScFeetStamptationHeatmapSumupSelectColumn || (ScFeetStamptationHeatmapSumupSelectColumn = {}));
/** unique or primary key constraints on table "spacecloud.floor_plans" */
export var ScFloorPlansConstraint;
(function (ScFloorPlansConstraint) {
    /** unique or primary key constraint on columns "id" */
    ScFloorPlansConstraint["Pk_4243d68fe3bfa6a38a2cccd5e9f"] = "PK_4243d68fe3bfa6a38a2cccd5e9f";
})(ScFloorPlansConstraint || (ScFloorPlansConstraint = {}));
/** select columns of table "spacecloud.floor_plans" */
export var ScFloorPlansSelectColumn;
(function (ScFloorPlansSelectColumn) {
    /** column name */
    ScFloorPlansSelectColumn["Alias"] = "alias";
    /** column name */
    ScFloorPlansSelectColumn["AssetGroupUuid"] = "asset_group_uuid";
    /** column name */
    ScFloorPlansSelectColumn["CreatedAt"] = "created_at";
    /** column name */
    ScFloorPlansSelectColumn["Id"] = "id";
    /** column name */
    ScFloorPlansSelectColumn["ImageKey"] = "image_key";
    /** column name */
    ScFloorPlansSelectColumn["IsActive"] = "is_active";
    /** column name */
    ScFloorPlansSelectColumn["Name"] = "name";
    /** column name */
    ScFloorPlansSelectColumn["OrderIndex"] = "order_index";
    /** column name */
    ScFloorPlansSelectColumn["UpdatedAt"] = "updated_at";
})(ScFloorPlansSelectColumn || (ScFloorPlansSelectColumn = {}));
/** select "sc_floor_plans_aggregate_bool_exp_bool_and_arguments_columns" columns of table "spacecloud.floor_plans" */
export var ScFloorPlansSelectColumnScFloorPlansAggregateBoolExpBoolAndArgumentsColumns;
(function (ScFloorPlansSelectColumnScFloorPlansAggregateBoolExpBoolAndArgumentsColumns) {
    /** column name */
    ScFloorPlansSelectColumnScFloorPlansAggregateBoolExpBoolAndArgumentsColumns["IsActive"] = "is_active";
})(ScFloorPlansSelectColumnScFloorPlansAggregateBoolExpBoolAndArgumentsColumns || (ScFloorPlansSelectColumnScFloorPlansAggregateBoolExpBoolAndArgumentsColumns = {}));
/** select "sc_floor_plans_aggregate_bool_exp_bool_or_arguments_columns" columns of table "spacecloud.floor_plans" */
export var ScFloorPlansSelectColumnScFloorPlansAggregateBoolExpBoolOrArgumentsColumns;
(function (ScFloorPlansSelectColumnScFloorPlansAggregateBoolExpBoolOrArgumentsColumns) {
    /** column name */
    ScFloorPlansSelectColumnScFloorPlansAggregateBoolExpBoolOrArgumentsColumns["IsActive"] = "is_active";
})(ScFloorPlansSelectColumnScFloorPlansAggregateBoolExpBoolOrArgumentsColumns || (ScFloorPlansSelectColumnScFloorPlansAggregateBoolExpBoolOrArgumentsColumns = {}));
/** update columns of table "spacecloud.floor_plans" */
export var ScFloorPlansUpdateColumn;
(function (ScFloorPlansUpdateColumn) {
    /** column name */
    ScFloorPlansUpdateColumn["Alias"] = "alias";
    /** column name */
    ScFloorPlansUpdateColumn["AssetGroupUuid"] = "asset_group_uuid";
    /** column name */
    ScFloorPlansUpdateColumn["CreatedAt"] = "created_at";
    /** column name */
    ScFloorPlansUpdateColumn["Id"] = "id";
    /** column name */
    ScFloorPlansUpdateColumn["ImageKey"] = "image_key";
    /** column name */
    ScFloorPlansUpdateColumn["IsActive"] = "is_active";
    /** column name */
    ScFloorPlansUpdateColumn["Name"] = "name";
    /** column name */
    ScFloorPlansUpdateColumn["OrderIndex"] = "order_index";
    /** column name */
    ScFloorPlansUpdateColumn["UpdatedAt"] = "updated_at";
})(ScFloorPlansUpdateColumn || (ScFloorPlansUpdateColumn = {}));
/** unique or primary key constraints on table "spacecloud.franchise_asset_group_annex" */
export var ScFranchiseAssetGroupAnnexConstraint;
(function (ScFranchiseAssetGroupAnnexConstraint) {
    /** unique or primary key constraint on columns "asset_group_annex_id", "franchise_id" */
    ScFranchiseAssetGroupAnnexConstraint["FranchiseAssetGroupAnnexFranchiseIdAssetGroupAnnexKey"] = "franchise_asset_group_annex_franchise_id_asset_group_annex__key";
    /** unique or primary key constraint on columns "id" */
    ScFranchiseAssetGroupAnnexConstraint["FranchiseAssetGroupAnnexPkey"] = "franchise_asset_group_annex_pkey";
})(ScFranchiseAssetGroupAnnexConstraint || (ScFranchiseAssetGroupAnnexConstraint = {}));
/** select columns of table "spacecloud.franchise_asset_group_annex" */
export var ScFranchiseAssetGroupAnnexSelectColumn;
(function (ScFranchiseAssetGroupAnnexSelectColumn) {
    /** column name */
    ScFranchiseAssetGroupAnnexSelectColumn["AssetGroupAnnexId"] = "asset_group_annex_id";
    /** column name */
    ScFranchiseAssetGroupAnnexSelectColumn["CreatedAt"] = "created_at";
    /** column name */
    ScFranchiseAssetGroupAnnexSelectColumn["FranchiseId"] = "franchise_id";
    /** column name */
    ScFranchiseAssetGroupAnnexSelectColumn["Id"] = "id";
    /** column name */
    ScFranchiseAssetGroupAnnexSelectColumn["UpdatedAt"] = "updated_at";
})(ScFranchiseAssetGroupAnnexSelectColumn || (ScFranchiseAssetGroupAnnexSelectColumn = {}));
/** update columns of table "spacecloud.franchise_asset_group_annex" */
export var ScFranchiseAssetGroupAnnexUpdateColumn;
(function (ScFranchiseAssetGroupAnnexUpdateColumn) {
    /** column name */
    ScFranchiseAssetGroupAnnexUpdateColumn["AssetGroupAnnexId"] = "asset_group_annex_id";
    /** column name */
    ScFranchiseAssetGroupAnnexUpdateColumn["CreatedAt"] = "created_at";
    /** column name */
    ScFranchiseAssetGroupAnnexUpdateColumn["FranchiseId"] = "franchise_id";
    /** column name */
    ScFranchiseAssetGroupAnnexUpdateColumn["Id"] = "id";
    /** column name */
    ScFranchiseAssetGroupAnnexUpdateColumn["UpdatedAt"] = "updated_at";
})(ScFranchiseAssetGroupAnnexUpdateColumn || (ScFranchiseAssetGroupAnnexUpdateColumn = {}));
/** unique or primary key constraints on table "spacecloud.franchises" */
export var ScFranchisesConstraint;
(function (ScFranchisesConstraint) {
    /** unique or primary key constraint on columns "id" */
    ScFranchisesConstraint["FranchisesPkey"] = "franchises_pkey";
})(ScFranchisesConstraint || (ScFranchisesConstraint = {}));
/** select columns of table "spacecloud.franchises" */
export var ScFranchisesSelectColumn;
(function (ScFranchisesSelectColumn) {
    /** column name */
    ScFranchisesSelectColumn["BrandUrl"] = "brand_url";
    /** column name */
    ScFranchisesSelectColumn["CreatedAt"] = "created_at";
    /** column name */
    ScFranchisesSelectColumn["Description"] = "description";
    /** column name */
    ScFranchisesSelectColumn["Id"] = "id";
    /** column name */
    ScFranchisesSelectColumn["LogoImageUrl"] = "logo_image_url";
    /** column name */
    ScFranchisesSelectColumn["Pdf"] = "pdf";
    /** column name */
    ScFranchisesSelectColumn["Title"] = "title";
    /** column name */
    ScFranchisesSelectColumn["UpdatedAt"] = "updated_at";
})(ScFranchisesSelectColumn || (ScFranchisesSelectColumn = {}));
/** update columns of table "spacecloud.franchises" */
export var ScFranchisesUpdateColumn;
(function (ScFranchisesUpdateColumn) {
    /** column name */
    ScFranchisesUpdateColumn["BrandUrl"] = "brand_url";
    /** column name */
    ScFranchisesUpdateColumn["CreatedAt"] = "created_at";
    /** column name */
    ScFranchisesUpdateColumn["Description"] = "description";
    /** column name */
    ScFranchisesUpdateColumn["Id"] = "id";
    /** column name */
    ScFranchisesUpdateColumn["LogoImageUrl"] = "logo_image_url";
    /** column name */
    ScFranchisesUpdateColumn["Pdf"] = "pdf";
    /** column name */
    ScFranchisesUpdateColumn["Title"] = "title";
    /** column name */
    ScFranchisesUpdateColumn["UpdatedAt"] = "updated_at";
})(ScFranchisesUpdateColumn || (ScFranchisesUpdateColumn = {}));
/** unique or primary key constraints on table "spacecloud.near_place_asset_group_premium_info" */
export var ScNearPlaceAssetGroupPremiumInfoConstraint;
(function (ScNearPlaceAssetGroupPremiumInfoConstraint) {
    /** unique or primary key constraint on columns "id" */
    ScNearPlaceAssetGroupPremiumInfoConstraint["NearPlaceAssetGroupPremiumInfoPkey"] = "near_place_asset_group_premium_info_pkey";
})(ScNearPlaceAssetGroupPremiumInfoConstraint || (ScNearPlaceAssetGroupPremiumInfoConstraint = {}));
/** select columns of table "spacecloud.near_place_asset_group_premium_info" */
export var ScNearPlaceAssetGroupPremiumInfoSelectColumn;
(function (ScNearPlaceAssetGroupPremiumInfoSelectColumn) {
    /** column name */
    ScNearPlaceAssetGroupPremiumInfoSelectColumn["AssetGroupPremiumInfoId"] = "asset_group_premium_info_id";
    /** column name */
    ScNearPlaceAssetGroupPremiumInfoSelectColumn["Id"] = "id";
    /** column name */
    ScNearPlaceAssetGroupPremiumInfoSelectColumn["IsSelected"] = "is_selected";
    /** column name */
    ScNearPlaceAssetGroupPremiumInfoSelectColumn["NearPlaceId"] = "near_place_id";
})(ScNearPlaceAssetGroupPremiumInfoSelectColumn || (ScNearPlaceAssetGroupPremiumInfoSelectColumn = {}));
/** select "sc_near_place_asset_group_premium_info_aggregate_bool_exp_bool_and_arguments_columns" columns of table "spacecloud.near_place_asset_group_premium_info" */
export var ScNearPlaceAssetGroupPremiumInfoSelectColumnScNearPlaceAssetGroupPremiumInfoAggregateBoolExpBoolAndArgumentsColumns;
(function (ScNearPlaceAssetGroupPremiumInfoSelectColumnScNearPlaceAssetGroupPremiumInfoAggregateBoolExpBoolAndArgumentsColumns) {
    /** column name */
    ScNearPlaceAssetGroupPremiumInfoSelectColumnScNearPlaceAssetGroupPremiumInfoAggregateBoolExpBoolAndArgumentsColumns["IsSelected"] = "is_selected";
})(ScNearPlaceAssetGroupPremiumInfoSelectColumnScNearPlaceAssetGroupPremiumInfoAggregateBoolExpBoolAndArgumentsColumns || (ScNearPlaceAssetGroupPremiumInfoSelectColumnScNearPlaceAssetGroupPremiumInfoAggregateBoolExpBoolAndArgumentsColumns = {}));
/** select "sc_near_place_asset_group_premium_info_aggregate_bool_exp_bool_or_arguments_columns" columns of table "spacecloud.near_place_asset_group_premium_info" */
export var ScNearPlaceAssetGroupPremiumInfoSelectColumnScNearPlaceAssetGroupPremiumInfoAggregateBoolExpBoolOrArgumentsColumns;
(function (ScNearPlaceAssetGroupPremiumInfoSelectColumnScNearPlaceAssetGroupPremiumInfoAggregateBoolExpBoolOrArgumentsColumns) {
    /** column name */
    ScNearPlaceAssetGroupPremiumInfoSelectColumnScNearPlaceAssetGroupPremiumInfoAggregateBoolExpBoolOrArgumentsColumns["IsSelected"] = "is_selected";
})(ScNearPlaceAssetGroupPremiumInfoSelectColumnScNearPlaceAssetGroupPremiumInfoAggregateBoolExpBoolOrArgumentsColumns || (ScNearPlaceAssetGroupPremiumInfoSelectColumnScNearPlaceAssetGroupPremiumInfoAggregateBoolExpBoolOrArgumentsColumns = {}));
/** update columns of table "spacecloud.near_place_asset_group_premium_info" */
export var ScNearPlaceAssetGroupPremiumInfoUpdateColumn;
(function (ScNearPlaceAssetGroupPremiumInfoUpdateColumn) {
    /** column name */
    ScNearPlaceAssetGroupPremiumInfoUpdateColumn["AssetGroupPremiumInfoId"] = "asset_group_premium_info_id";
    /** column name */
    ScNearPlaceAssetGroupPremiumInfoUpdateColumn["Id"] = "id";
    /** column name */
    ScNearPlaceAssetGroupPremiumInfoUpdateColumn["IsSelected"] = "is_selected";
    /** column name */
    ScNearPlaceAssetGroupPremiumInfoUpdateColumn["NearPlaceId"] = "near_place_id";
})(ScNearPlaceAssetGroupPremiumInfoUpdateColumn || (ScNearPlaceAssetGroupPremiumInfoUpdateColumn = {}));
/** unique or primary key constraints on table "spacecloud.near_places" */
export var ScNearPlacesConstraint;
(function (ScNearPlacesConstraint) {
    /** unique or primary key constraint on columns "id" */
    ScNearPlacesConstraint["NearPlacesPkey"] = "near_places_pkey";
})(ScNearPlacesConstraint || (ScNearPlacesConstraint = {}));
/** select columns of table "spacecloud.near_places" */
export var ScNearPlacesSelectColumn;
(function (ScNearPlacesSelectColumn) {
    /** column name */
    ScNearPlacesSelectColumn["AddressInfo"] = "address_info";
    /** column name */
    ScNearPlacesSelectColumn["GoogleMapUrl"] = "google_map_url";
    /** column name */
    ScNearPlacesSelectColumn["Id"] = "id";
    /** column name */
    ScNearPlacesSelectColumn["ImageUrl"] = "image_url";
    /** column name */
    ScNearPlacesSelectColumn["Latitude"] = "latitude";
    /** column name */
    ScNearPlacesSelectColumn["Longitude"] = "longitude";
    /** column name */
    ScNearPlacesSelectColumn["Name"] = "name";
    /** column name */
    ScNearPlacesSelectColumn["PriceInfo"] = "price_info";
    /** column name */
    ScNearPlacesSelectColumn["Type"] = "type";
    /** column name */
    ScNearPlacesSelectColumn["UnitInfo"] = "unit_info";
})(ScNearPlacesSelectColumn || (ScNearPlacesSelectColumn = {}));
/** update columns of table "spacecloud.near_places" */
export var ScNearPlacesUpdateColumn;
(function (ScNearPlacesUpdateColumn) {
    /** column name */
    ScNearPlacesUpdateColumn["AddressInfo"] = "address_info";
    /** column name */
    ScNearPlacesUpdateColumn["GoogleMapUrl"] = "google_map_url";
    /** column name */
    ScNearPlacesUpdateColumn["Id"] = "id";
    /** column name */
    ScNearPlacesUpdateColumn["ImageUrl"] = "image_url";
    /** column name */
    ScNearPlacesUpdateColumn["Latitude"] = "latitude";
    /** column name */
    ScNearPlacesUpdateColumn["Longitude"] = "longitude";
    /** column name */
    ScNearPlacesUpdateColumn["Name"] = "name";
    /** column name */
    ScNearPlacesUpdateColumn["PriceInfo"] = "price_info";
    /** column name */
    ScNearPlacesUpdateColumn["Type"] = "type";
    /** column name */
    ScNearPlacesUpdateColumn["UnitInfo"] = "unit_info";
})(ScNearPlacesUpdateColumn || (ScNearPlacesUpdateColumn = {}));
/** unique or primary key constraints on table "spacecloud.traffic_footages" */
export var ScTrafficFootagesConstraint;
(function (ScTrafficFootagesConstraint) {
    /** unique or primary key constraint on columns "id" */
    ScTrafficFootagesConstraint["TrafficFootagesPkey"] = "traffic_footages_pkey";
})(ScTrafficFootagesConstraint || (ScTrafficFootagesConstraint = {}));
/** select columns of table "spacecloud.traffic_footages" */
export var ScTrafficFootagesSelectColumn;
(function (ScTrafficFootagesSelectColumn) {
    /** column name */
    ScTrafficFootagesSelectColumn["CctvCameraId"] = "cctv_camera_id";
    /** column name */
    ScTrafficFootagesSelectColumn["CreatedAt"] = "created_at";
    /** column name */
    ScTrafficFootagesSelectColumn["Id"] = "id";
    /** column name */
    ScTrafficFootagesSelectColumn["TrafficStartAt"] = "traffic_start_at";
    /** column name */
    ScTrafficFootagesSelectColumn["UpdatedAt"] = "updated_at";
    /** column name */
    ScTrafficFootagesSelectColumn["VideoUrl"] = "video_url";
})(ScTrafficFootagesSelectColumn || (ScTrafficFootagesSelectColumn = {}));
/** update columns of table "spacecloud.traffic_footages" */
export var ScTrafficFootagesUpdateColumn;
(function (ScTrafficFootagesUpdateColumn) {
    /** column name */
    ScTrafficFootagesUpdateColumn["CctvCameraId"] = "cctv_camera_id";
    /** column name */
    ScTrafficFootagesUpdateColumn["CreatedAt"] = "created_at";
    /** column name */
    ScTrafficFootagesUpdateColumn["Id"] = "id";
    /** column name */
    ScTrafficFootagesUpdateColumn["TrafficStartAt"] = "traffic_start_at";
    /** column name */
    ScTrafficFootagesUpdateColumn["UpdatedAt"] = "updated_at";
    /** column name */
    ScTrafficFootagesUpdateColumn["VideoUrl"] = "video_url";
})(ScTrafficFootagesUpdateColumn || (ScTrafficFootagesUpdateColumn = {}));
/** unique or primary key constraints on table "spacecloud.user_preferences" */
export var ScUserPreferencesConstraint;
(function (ScUserPreferencesConstraint) {
    /** unique or primary key constraint on columns "id" */
    ScUserPreferencesConstraint["UserPreferencesPkey"] = "user_preferences_pkey";
    /** unique or primary key constraint on columns "user_id" */
    ScUserPreferencesConstraint["UserPreferencesUserIdKey"] = "user_preferences_user_id_key";
})(ScUserPreferencesConstraint || (ScUserPreferencesConstraint = {}));
/** select columns of table "spacecloud.user_preferences" */
export var ScUserPreferencesSelectColumn;
(function (ScUserPreferencesSelectColumn) {
    /** column name */
    ScUserPreferencesSelectColumn["AssetGroupDescription"] = "asset_group_description";
    /** column name */
    ScUserPreferencesSelectColumn["AssetType"] = "asset_type";
    /** column name */
    ScUserPreferencesSelectColumn["CreatedAt"] = "created_at";
    /** column name */
    ScUserPreferencesSelectColumn["Id"] = "id";
    /** column name */
    ScUserPreferencesSelectColumn["MaxArea"] = "max_area";
    /** column name */
    ScUserPreferencesSelectColumn["MaxBudget"] = "max_budget";
    /** column name */
    ScUserPreferencesSelectColumn["MinArea"] = "min_area";
    /** column name */
    ScUserPreferencesSelectColumn["MinBudget"] = "min_budget";
    /** column name */
    ScUserPreferencesSelectColumn["MoreDetails"] = "more_details";
    /** column name */
    ScUserPreferencesSelectColumn["UpdatedAt"] = "updated_at";
    /** column name */
    ScUserPreferencesSelectColumn["UserId"] = "user_id";
})(ScUserPreferencesSelectColumn || (ScUserPreferencesSelectColumn = {}));
/** update columns of table "spacecloud.user_preferences" */
export var ScUserPreferencesUpdateColumn;
(function (ScUserPreferencesUpdateColumn) {
    /** column name */
    ScUserPreferencesUpdateColumn["AssetGroupDescription"] = "asset_group_description";
    /** column name */
    ScUserPreferencesUpdateColumn["AssetType"] = "asset_type";
    /** column name */
    ScUserPreferencesUpdateColumn["CreatedAt"] = "created_at";
    /** column name */
    ScUserPreferencesUpdateColumn["Id"] = "id";
    /** column name */
    ScUserPreferencesUpdateColumn["MaxArea"] = "max_area";
    /** column name */
    ScUserPreferencesUpdateColumn["MaxBudget"] = "max_budget";
    /** column name */
    ScUserPreferencesUpdateColumn["MinArea"] = "min_area";
    /** column name */
    ScUserPreferencesUpdateColumn["MinBudget"] = "min_budget";
    /** column name */
    ScUserPreferencesUpdateColumn["MoreDetails"] = "more_details";
    /** column name */
    ScUserPreferencesUpdateColumn["UpdatedAt"] = "updated_at";
    /** column name */
    ScUserPreferencesUpdateColumn["UserId"] = "user_id";
})(ScUserPreferencesUpdateColumn || (ScUserPreferencesUpdateColumn = {}));
/** unique or primary key constraints on table "spacecloud.visits" */
export var ScVisitsConstraint;
(function (ScVisitsConstraint) {
    /** unique or primary key constraint on columns "id" */
    ScVisitsConstraint["Pk_0b0b322289a41015c6ea4e8bf30"] = "PK_0b0b322289a41015c6ea4e8bf30";
})(ScVisitsConstraint || (ScVisitsConstraint = {}));
/** select columns of table "spacecloud.visits" */
export var ScVisitsSelectColumn;
(function (ScVisitsSelectColumn) {
    /** column name */
    ScVisitsSelectColumn["AttachedJsonData"] = "attached_json_data";
    /** column name */
    ScVisitsSelectColumn["CreatedAt"] = "created_at";
    /** column name */
    ScVisitsSelectColumn["Id"] = "id";
    /** column name */
    ScVisitsSelectColumn["Path"] = "path";
    /** column name */
    ScVisitsSelectColumn["UpdatedAt"] = "updated_at";
})(ScVisitsSelectColumn || (ScVisitsSelectColumn = {}));
/** update columns of table "spacecloud.visits" */
export var ScVisitsUpdateColumn;
(function (ScVisitsUpdateColumn) {
    /** column name */
    ScVisitsUpdateColumn["AttachedJsonData"] = "attached_json_data";
    /** column name */
    ScVisitsUpdateColumn["CreatedAt"] = "created_at";
    /** column name */
    ScVisitsUpdateColumn["Id"] = "id";
    /** column name */
    ScVisitsUpdateColumn["Path"] = "path";
    /** column name */
    ScVisitsUpdateColumn["UpdatedAt"] = "updated_at";
})(ScVisitsUpdateColumn || (ScVisitsUpdateColumn = {}));
/** select columns of table "sunday_operating_hours" */
export var SundayOperatingHoursSelectColumn;
(function (SundayOperatingHoursSelectColumn) {
    /** column name */
    SundayOperatingHoursSelectColumn["DayOfWeek"] = "day_of_week";
    /** column name */
    SundayOperatingHoursSelectColumn["HourEnd"] = "hour_end";
    /** column name */
    SundayOperatingHoursSelectColumn["HourStart"] = "hour_start";
    /** column name */
    SundayOperatingHoursSelectColumn["ModelId"] = "model_id";
})(SundayOperatingHoursSelectColumn || (SundayOperatingHoursSelectColumn = {}));
/** select columns of table "thursday_operating_hours" */
export var ThursdayOperatingHoursSelectColumn;
(function (ThursdayOperatingHoursSelectColumn) {
    /** column name */
    ThursdayOperatingHoursSelectColumn["DayOfWeek"] = "day_of_week";
    /** column name */
    ThursdayOperatingHoursSelectColumn["HourEnd"] = "hour_end";
    /** column name */
    ThursdayOperatingHoursSelectColumn["HourStart"] = "hour_start";
    /** column name */
    ThursdayOperatingHoursSelectColumn["ModelId"] = "model_id";
})(ThursdayOperatingHoursSelectColumn || (ThursdayOperatingHoursSelectColumn = {}));
/** select columns of table "tuesday_operating_hours" */
export var TuesdayOperatingHoursSelectColumn;
(function (TuesdayOperatingHoursSelectColumn) {
    /** column name */
    TuesdayOperatingHoursSelectColumn["DayOfWeek"] = "day_of_week";
    /** column name */
    TuesdayOperatingHoursSelectColumn["HourEnd"] = "hour_end";
    /** column name */
    TuesdayOperatingHoursSelectColumn["HourStart"] = "hour_start";
    /** column name */
    TuesdayOperatingHoursSelectColumn["ModelId"] = "model_id";
})(TuesdayOperatingHoursSelectColumn || (TuesdayOperatingHoursSelectColumn = {}));
/** unique or primary key constraints on table "user_avatar_media" */
export var UserAvatarMediaConstraint;
(function (UserAvatarMediaConstraint) {
    /** unique or primary key constraint on columns "user_id", "media_id" */
    UserAvatarMediaConstraint["UserAvatarMediaPkey"] = "user_avatar_media_pkey";
})(UserAvatarMediaConstraint || (UserAvatarMediaConstraint = {}));
/** select columns of table "user_avatar_media" */
export var UserAvatarMediaSelectColumn;
(function (UserAvatarMediaSelectColumn) {
    /** column name */
    UserAvatarMediaSelectColumn["CreatedAt"] = "created_at";
    /** column name */
    UserAvatarMediaSelectColumn["MediaId"] = "media_id";
    /** column name */
    UserAvatarMediaSelectColumn["UpdatedAt"] = "updated_at";
    /** column name */
    UserAvatarMediaSelectColumn["UserId"] = "user_id";
})(UserAvatarMediaSelectColumn || (UserAvatarMediaSelectColumn = {}));
/** update columns of table "user_avatar_media" */
export var UserAvatarMediaUpdateColumn;
(function (UserAvatarMediaUpdateColumn) {
    /** column name */
    UserAvatarMediaUpdateColumn["CreatedAt"] = "created_at";
    /** column name */
    UserAvatarMediaUpdateColumn["MediaId"] = "media_id";
    /** column name */
    UserAvatarMediaUpdateColumn["UpdatedAt"] = "updated_at";
    /** column name */
    UserAvatarMediaUpdateColumn["UserId"] = "user_id";
})(UserAvatarMediaUpdateColumn || (UserAvatarMediaUpdateColumn = {}));
/** unique or primary key constraints on table "user_consents" */
export var UserConsentsConstraint;
(function (UserConsentsConstraint) {
    /** unique or primary key constraint on columns "consent_id", "user_id" */
    UserConsentsConstraint["UserConsentsConsentIdUserIdKey"] = "user_consents_consent_id_user_id_key";
    /** unique or primary key constraint on columns "id" */
    UserConsentsConstraint["UserConsentsPkey"] = "user_consents_pkey";
})(UserConsentsConstraint || (UserConsentsConstraint = {}));
/** select columns of table "user_consents" */
export var UserConsentsSelectColumn;
(function (UserConsentsSelectColumn) {
    /** column name */
    UserConsentsSelectColumn["Consent"] = "consent";
    /** column name */
    UserConsentsSelectColumn["ConsentId"] = "consent_id";
    /** column name */
    UserConsentsSelectColumn["CreatedAt"] = "created_at";
    /** column name */
    UserConsentsSelectColumn["Id"] = "id";
    /** column name */
    UserConsentsSelectColumn["UpdatedAt"] = "updated_at";
    /** column name */
    UserConsentsSelectColumn["UserId"] = "user_id";
})(UserConsentsSelectColumn || (UserConsentsSelectColumn = {}));
/** select "user_consents_aggregate_bool_exp_bool_and_arguments_columns" columns of table "user_consents" */
export var UserConsentsSelectColumnUserConsentsAggregateBoolExpBoolAndArgumentsColumns;
(function (UserConsentsSelectColumnUserConsentsAggregateBoolExpBoolAndArgumentsColumns) {
    /** column name */
    UserConsentsSelectColumnUserConsentsAggregateBoolExpBoolAndArgumentsColumns["Consent"] = "consent";
})(UserConsentsSelectColumnUserConsentsAggregateBoolExpBoolAndArgumentsColumns || (UserConsentsSelectColumnUserConsentsAggregateBoolExpBoolAndArgumentsColumns = {}));
/** select "user_consents_aggregate_bool_exp_bool_or_arguments_columns" columns of table "user_consents" */
export var UserConsentsSelectColumnUserConsentsAggregateBoolExpBoolOrArgumentsColumns;
(function (UserConsentsSelectColumnUserConsentsAggregateBoolExpBoolOrArgumentsColumns) {
    /** column name */
    UserConsentsSelectColumnUserConsentsAggregateBoolExpBoolOrArgumentsColumns["Consent"] = "consent";
})(UserConsentsSelectColumnUserConsentsAggregateBoolExpBoolOrArgumentsColumns || (UserConsentsSelectColumnUserConsentsAggregateBoolExpBoolOrArgumentsColumns = {}));
/** update columns of table "user_consents" */
export var UserConsentsUpdateColumn;
(function (UserConsentsUpdateColumn) {
    /** column name */
    UserConsentsUpdateColumn["Consent"] = "consent";
    /** column name */
    UserConsentsUpdateColumn["ConsentId"] = "consent_id";
    /** column name */
    UserConsentsUpdateColumn["CreatedAt"] = "created_at";
    /** column name */
    UserConsentsUpdateColumn["Id"] = "id";
    /** column name */
    UserConsentsUpdateColumn["UpdatedAt"] = "updated_at";
    /** column name */
    UserConsentsUpdateColumn["UserId"] = "user_id";
})(UserConsentsUpdateColumn || (UserConsentsUpdateColumn = {}));
/** unique or primary key constraints on table "user_group_logo_media" */
export var UserGroupLogoMediaConstraint;
(function (UserGroupLogoMediaConstraint) {
    /** unique or primary key constraint on columns "user_group_id", "media_id" */
    UserGroupLogoMediaConstraint["UserGroupLogoMediaPkey"] = "user_group_logo_media_pkey";
})(UserGroupLogoMediaConstraint || (UserGroupLogoMediaConstraint = {}));
/** select columns of table "user_group_logo_media" */
export var UserGroupLogoMediaSelectColumn;
(function (UserGroupLogoMediaSelectColumn) {
    /** column name */
    UserGroupLogoMediaSelectColumn["CreatedAt"] = "created_at";
    /** column name */
    UserGroupLogoMediaSelectColumn["MediaId"] = "media_id";
    /** column name */
    UserGroupLogoMediaSelectColumn["UpdatedAt"] = "updated_at";
    /** column name */
    UserGroupLogoMediaSelectColumn["UserGroupId"] = "user_group_id";
})(UserGroupLogoMediaSelectColumn || (UserGroupLogoMediaSelectColumn = {}));
/** update columns of table "user_group_logo_media" */
export var UserGroupLogoMediaUpdateColumn;
(function (UserGroupLogoMediaUpdateColumn) {
    /** column name */
    UserGroupLogoMediaUpdateColumn["CreatedAt"] = "created_at";
    /** column name */
    UserGroupLogoMediaUpdateColumn["MediaId"] = "media_id";
    /** column name */
    UserGroupLogoMediaUpdateColumn["UpdatedAt"] = "updated_at";
    /** column name */
    UserGroupLogoMediaUpdateColumn["UserGroupId"] = "user_group_id";
})(UserGroupLogoMediaUpdateColumn || (UserGroupLogoMediaUpdateColumn = {}));
/** unique or primary key constraints on table "user_group_process_values" */
export var UserGroupProcessValuesConstraint;
(function (UserGroupProcessValuesConstraint) {
    /** unique or primary key constraint on columns "id" */
    UserGroupProcessValuesConstraint["UserGroupProcessValuesPkey"] = "user_group_process_values_pkey";
    /** unique or primary key constraint on columns "user_id", "process_id" */
    UserGroupProcessValuesConstraint["UserGroupProcessValuesProcessIdUserIdKey"] = "user_group_process_values_process_id_user_id_key";
})(UserGroupProcessValuesConstraint || (UserGroupProcessValuesConstraint = {}));
/** select columns of table "user_group_process_values" */
export var UserGroupProcessValuesSelectColumn;
(function (UserGroupProcessValuesSelectColumn) {
    /** column name */
    UserGroupProcessValuesSelectColumn["CreatedAt"] = "created_at";
    /** column name */
    UserGroupProcessValuesSelectColumn["Id"] = "id";
    /** column name */
    UserGroupProcessValuesSelectColumn["ProcessId"] = "process_id";
    /** column name */
    UserGroupProcessValuesSelectColumn["ProcessValues"] = "process_values";
    /** column name */
    UserGroupProcessValuesSelectColumn["UpdatedAt"] = "updated_at";
    /** column name */
    UserGroupProcessValuesSelectColumn["UserId"] = "user_id";
})(UserGroupProcessValuesSelectColumn || (UserGroupProcessValuesSelectColumn = {}));
/** update columns of table "user_group_process_values" */
export var UserGroupProcessValuesUpdateColumn;
(function (UserGroupProcessValuesUpdateColumn) {
    /** column name */
    UserGroupProcessValuesUpdateColumn["CreatedAt"] = "created_at";
    /** column name */
    UserGroupProcessValuesUpdateColumn["Id"] = "id";
    /** column name */
    UserGroupProcessValuesUpdateColumn["ProcessId"] = "process_id";
    /** column name */
    UserGroupProcessValuesUpdateColumn["ProcessValues"] = "process_values";
    /** column name */
    UserGroupProcessValuesUpdateColumn["UpdatedAt"] = "updated_at";
    /** column name */
    UserGroupProcessValuesUpdateColumn["UserId"] = "user_id";
})(UserGroupProcessValuesUpdateColumn || (UserGroupProcessValuesUpdateColumn = {}));
/** unique or primary key constraints on table "user_group_role_permissions" */
export var UserGroupRolePermissionsConstraint;
(function (UserGroupRolePermissionsConstraint) {
    /** unique or primary key constraint on columns "user_group_role_id", "permission_id" */
    UserGroupRolePermissionsConstraint["GroupRolePermissionsPkey"] = "group_role_permissions_pkey";
    /** unique or primary key constraint on columns "user_group_role_id", "permission_id" */
    UserGroupRolePermissionsConstraint["UserGroupRolePermissionsUserGroupRoleIdPermissionIdKe"] = "user_group_role_permissions_user_group_role_id_permission_id_ke";
})(UserGroupRolePermissionsConstraint || (UserGroupRolePermissionsConstraint = {}));
/** select columns of table "user_group_role_permissions" */
export var UserGroupRolePermissionsSelectColumn;
(function (UserGroupRolePermissionsSelectColumn) {
    /** column name */
    UserGroupRolePermissionsSelectColumn["CreatedAt"] = "created_at";
    /** column name */
    UserGroupRolePermissionsSelectColumn["PermissionId"] = "permission_id";
    /** column name */
    UserGroupRolePermissionsSelectColumn["UpdatedAt"] = "updated_at";
    /** column name */
    UserGroupRolePermissionsSelectColumn["UserGroupRoleId"] = "user_group_role_id";
})(UserGroupRolePermissionsSelectColumn || (UserGroupRolePermissionsSelectColumn = {}));
/** update columns of table "user_group_role_permissions" */
export var UserGroupRolePermissionsUpdateColumn;
(function (UserGroupRolePermissionsUpdateColumn) {
    /** column name */
    UserGroupRolePermissionsUpdateColumn["CreatedAt"] = "created_at";
    /** column name */
    UserGroupRolePermissionsUpdateColumn["PermissionId"] = "permission_id";
    /** column name */
    UserGroupRolePermissionsUpdateColumn["UpdatedAt"] = "updated_at";
    /** column name */
    UserGroupRolePermissionsUpdateColumn["UserGroupRoleId"] = "user_group_role_id";
})(UserGroupRolePermissionsUpdateColumn || (UserGroupRolePermissionsUpdateColumn = {}));
/** unique or primary key constraints on table "user_group_roles" */
export var UserGroupRolesConstraint;
(function (UserGroupRolesConstraint) {
    /** unique or primary key constraint on columns "id" */
    UserGroupRolesConstraint["GroupRolesPkey"] = "group_roles_pkey";
    /** unique or primary key constraint on columns "name", "user_group_id" */
    UserGroupRolesConstraint["UserGroupRolesNameUserGroupIdKey"] = "user_group_roles_name_user_group_id_key";
})(UserGroupRolesConstraint || (UserGroupRolesConstraint = {}));
/** select columns of table "user_group_roles" */
export var UserGroupRolesSelectColumn;
(function (UserGroupRolesSelectColumn) {
    /** column name */
    UserGroupRolesSelectColumn["CreatedAt"] = "created_at";
    /** column name */
    UserGroupRolesSelectColumn["Description"] = "description";
    /** column name */
    UserGroupRolesSelectColumn["Id"] = "id";
    /** column name */
    UserGroupRolesSelectColumn["Name"] = "name";
    /** column name */
    UserGroupRolesSelectColumn["UpdatedAt"] = "updated_at";
    /** column name */
    UserGroupRolesSelectColumn["UserGroupId"] = "user_group_id";
})(UserGroupRolesSelectColumn || (UserGroupRolesSelectColumn = {}));
/** update columns of table "user_group_roles" */
export var UserGroupRolesUpdateColumn;
(function (UserGroupRolesUpdateColumn) {
    /** column name */
    UserGroupRolesUpdateColumn["CreatedAt"] = "created_at";
    /** column name */
    UserGroupRolesUpdateColumn["Description"] = "description";
    /** column name */
    UserGroupRolesUpdateColumn["Id"] = "id";
    /** column name */
    UserGroupRolesUpdateColumn["Name"] = "name";
    /** column name */
    UserGroupRolesUpdateColumn["UpdatedAt"] = "updated_at";
    /** column name */
    UserGroupRolesUpdateColumn["UserGroupId"] = "user_group_id";
})(UserGroupRolesUpdateColumn || (UserGroupRolesUpdateColumn = {}));
/** unique or primary key constraints on table "user_group_user_roles" */
export var UserGroupUserRolesConstraint;
(function (UserGroupUserRolesConstraint) {
    /** unique or primary key constraint on columns "user_group_role_id", "user_id" */
    UserGroupUserRolesConstraint["GroupUserRolesPkey"] = "group_user_roles_pkey";
})(UserGroupUserRolesConstraint || (UserGroupUserRolesConstraint = {}));
/** select columns of table "user_group_user_roles" */
export var UserGroupUserRolesSelectColumn;
(function (UserGroupUserRolesSelectColumn) {
    /** column name */
    UserGroupUserRolesSelectColumn["CreatedAt"] = "created_at";
    /** column name */
    UserGroupUserRolesSelectColumn["EndDate"] = "end_date";
    /** column name */
    UserGroupUserRolesSelectColumn["IsActive"] = "is_active";
    /** column name */
    UserGroupUserRolesSelectColumn["StartDate"] = "start_date";
    /** column name */
    UserGroupUserRolesSelectColumn["UpdatedAt"] = "updated_at";
    /** column name */
    UserGroupUserRolesSelectColumn["UserGroupRoleId"] = "user_group_role_id";
    /** column name */
    UserGroupUserRolesSelectColumn["UserId"] = "user_id";
})(UserGroupUserRolesSelectColumn || (UserGroupUserRolesSelectColumn = {}));
/** select "user_group_user_roles_aggregate_bool_exp_bool_and_arguments_columns" columns of table "user_group_user_roles" */
export var UserGroupUserRolesSelectColumnUserGroupUserRolesAggregateBoolExpBoolAndArgumentsColumns;
(function (UserGroupUserRolesSelectColumnUserGroupUserRolesAggregateBoolExpBoolAndArgumentsColumns) {
    /** column name */
    UserGroupUserRolesSelectColumnUserGroupUserRolesAggregateBoolExpBoolAndArgumentsColumns["IsActive"] = "is_active";
})(UserGroupUserRolesSelectColumnUserGroupUserRolesAggregateBoolExpBoolAndArgumentsColumns || (UserGroupUserRolesSelectColumnUserGroupUserRolesAggregateBoolExpBoolAndArgumentsColumns = {}));
/** select "user_group_user_roles_aggregate_bool_exp_bool_or_arguments_columns" columns of table "user_group_user_roles" */
export var UserGroupUserRolesSelectColumnUserGroupUserRolesAggregateBoolExpBoolOrArgumentsColumns;
(function (UserGroupUserRolesSelectColumnUserGroupUserRolesAggregateBoolExpBoolOrArgumentsColumns) {
    /** column name */
    UserGroupUserRolesSelectColumnUserGroupUserRolesAggregateBoolExpBoolOrArgumentsColumns["IsActive"] = "is_active";
})(UserGroupUserRolesSelectColumnUserGroupUserRolesAggregateBoolExpBoolOrArgumentsColumns || (UserGroupUserRolesSelectColumnUserGroupUserRolesAggregateBoolExpBoolOrArgumentsColumns = {}));
/** update columns of table "user_group_user_roles" */
export var UserGroupUserRolesUpdateColumn;
(function (UserGroupUserRolesUpdateColumn) {
    /** column name */
    UserGroupUserRolesUpdateColumn["CreatedAt"] = "created_at";
    /** column name */
    UserGroupUserRolesUpdateColumn["EndDate"] = "end_date";
    /** column name */
    UserGroupUserRolesUpdateColumn["IsActive"] = "is_active";
    /** column name */
    UserGroupUserRolesUpdateColumn["StartDate"] = "start_date";
    /** column name */
    UserGroupUserRolesUpdateColumn["UpdatedAt"] = "updated_at";
    /** column name */
    UserGroupUserRolesUpdateColumn["UserGroupRoleId"] = "user_group_role_id";
    /** column name */
    UserGroupUserRolesUpdateColumn["UserId"] = "user_id";
})(UserGroupUserRolesUpdateColumn || (UserGroupUserRolesUpdateColumn = {}));
/** unique or primary key constraints on table "user_groups" */
export var UserGroupsConstraint;
(function (UserGroupsConstraint) {
    /** unique or primary key constraint on columns "name" */
    UserGroupsConstraint["UserGroupsNameKey"] = "user_groups_name_key";
    /** unique or primary key constraint on columns "id" */
    UserGroupsConstraint["UserGroupsPkey"] = "user_groups_pkey";
    /** unique or primary key constraint on columns "slug" */
    UserGroupsConstraint["UserGroupsSlugKey"] = "user_groups_slug_key";
})(UserGroupsConstraint || (UserGroupsConstraint = {}));
/** select columns of table "user_groups" */
export var UserGroupsSelectColumn;
(function (UserGroupsSelectColumn) {
    /** column name */
    UserGroupsSelectColumn["Active"] = "active";
    /** column name */
    UserGroupsSelectColumn["Configuration"] = "configuration";
    /** column name */
    UserGroupsSelectColumn["CreatedAt"] = "created_at";
    /** column name */
    UserGroupsSelectColumn["CreatedById"] = "created_by_id";
    /** column name */
    UserGroupsSelectColumn["DeactivatedAt"] = "deactivated_at";
    /** column name */
    UserGroupsSelectColumn["DisplayName"] = "display_name";
    /** column name */
    UserGroupsSelectColumn["Id"] = "id";
    /** column name */
    UserGroupsSelectColumn["LogoUrl"] = "logo_url";
    /** column name */
    UserGroupsSelectColumn["Name"] = "name";
    /** column name */
    UserGroupsSelectColumn["ParentId"] = "parent_id";
    /** column name */
    UserGroupsSelectColumn["ProcessValues"] = "process_values";
    /** column name */
    UserGroupsSelectColumn["Schema"] = "schema";
    /** column name */
    UserGroupsSelectColumn["Slug"] = "slug";
    /** column name */
    UserGroupsSelectColumn["Tier"] = "tier";
    /** column name */
    UserGroupsSelectColumn["Uischema"] = "uischema";
    /** column name */
    UserGroupsSelectColumn["UpdatedAt"] = "updated_at";
})(UserGroupsSelectColumn || (UserGroupsSelectColumn = {}));
/** select "user_groups_aggregate_bool_exp_bool_and_arguments_columns" columns of table "user_groups" */
export var UserGroupsSelectColumnUserGroupsAggregateBoolExpBoolAndArgumentsColumns;
(function (UserGroupsSelectColumnUserGroupsAggregateBoolExpBoolAndArgumentsColumns) {
    /** column name */
    UserGroupsSelectColumnUserGroupsAggregateBoolExpBoolAndArgumentsColumns["Active"] = "active";
})(UserGroupsSelectColumnUserGroupsAggregateBoolExpBoolAndArgumentsColumns || (UserGroupsSelectColumnUserGroupsAggregateBoolExpBoolAndArgumentsColumns = {}));
/** select "user_groups_aggregate_bool_exp_bool_or_arguments_columns" columns of table "user_groups" */
export var UserGroupsSelectColumnUserGroupsAggregateBoolExpBoolOrArgumentsColumns;
(function (UserGroupsSelectColumnUserGroupsAggregateBoolExpBoolOrArgumentsColumns) {
    /** column name */
    UserGroupsSelectColumnUserGroupsAggregateBoolExpBoolOrArgumentsColumns["Active"] = "active";
})(UserGroupsSelectColumnUserGroupsAggregateBoolExpBoolOrArgumentsColumns || (UserGroupsSelectColumnUserGroupsAggregateBoolExpBoolOrArgumentsColumns = {}));
/** update columns of table "user_groups" */
export var UserGroupsUpdateColumn;
(function (UserGroupsUpdateColumn) {
    /** column name */
    UserGroupsUpdateColumn["Active"] = "active";
    /** column name */
    UserGroupsUpdateColumn["Configuration"] = "configuration";
    /** column name */
    UserGroupsUpdateColumn["CreatedAt"] = "created_at";
    /** column name */
    UserGroupsUpdateColumn["CreatedById"] = "created_by_id";
    /** column name */
    UserGroupsUpdateColumn["DeactivatedAt"] = "deactivated_at";
    /** column name */
    UserGroupsUpdateColumn["DisplayName"] = "display_name";
    /** column name */
    UserGroupsUpdateColumn["Id"] = "id";
    /** column name */
    UserGroupsUpdateColumn["LogoUrl"] = "logo_url";
    /** column name */
    UserGroupsUpdateColumn["Name"] = "name";
    /** column name */
    UserGroupsUpdateColumn["ParentId"] = "parent_id";
    /** column name */
    UserGroupsUpdateColumn["ProcessValues"] = "process_values";
    /** column name */
    UserGroupsUpdateColumn["Schema"] = "schema";
    /** column name */
    UserGroupsUpdateColumn["Slug"] = "slug";
    /** column name */
    UserGroupsUpdateColumn["Tier"] = "tier";
    /** column name */
    UserGroupsUpdateColumn["Uischema"] = "uischema";
    /** column name */
    UserGroupsUpdateColumn["UpdatedAt"] = "updated_at";
})(UserGroupsUpdateColumn || (UserGroupsUpdateColumn = {}));
/** unique or primary key constraints on table "user_process_values" */
export var UserProcessValuesConstraint;
(function (UserProcessValuesConstraint) {
    /** unique or primary key constraint on columns "id" */
    UserProcessValuesConstraint["UserProcessValuesPkey"] = "user_process_values_pkey";
    /** unique or primary key constraint on columns "user_id", "process_id" */
    UserProcessValuesConstraint["UserProcessValuesProcessIdUserIdKey"] = "user_process_values_process_id_user_id_key";
})(UserProcessValuesConstraint || (UserProcessValuesConstraint = {}));
/** select columns of table "user_process_values" */
export var UserProcessValuesSelectColumn;
(function (UserProcessValuesSelectColumn) {
    /** column name */
    UserProcessValuesSelectColumn["CreatedAt"] = "created_at";
    /** column name */
    UserProcessValuesSelectColumn["Id"] = "id";
    /** column name */
    UserProcessValuesSelectColumn["ProcessId"] = "process_id";
    /** column name */
    UserProcessValuesSelectColumn["ProcessValues"] = "process_values";
    /** column name */
    UserProcessValuesSelectColumn["UpdatedAt"] = "updated_at";
    /** column name */
    UserProcessValuesSelectColumn["UserId"] = "user_id";
})(UserProcessValuesSelectColumn || (UserProcessValuesSelectColumn = {}));
/** update columns of table "user_process_values" */
export var UserProcessValuesUpdateColumn;
(function (UserProcessValuesUpdateColumn) {
    /** column name */
    UserProcessValuesUpdateColumn["CreatedAt"] = "created_at";
    /** column name */
    UserProcessValuesUpdateColumn["Id"] = "id";
    /** column name */
    UserProcessValuesUpdateColumn["ProcessId"] = "process_id";
    /** column name */
    UserProcessValuesUpdateColumn["ProcessValues"] = "process_values";
    /** column name */
    UserProcessValuesUpdateColumn["UpdatedAt"] = "updated_at";
    /** column name */
    UserProcessValuesUpdateColumn["UserId"] = "user_id";
})(UserProcessValuesUpdateColumn || (UserProcessValuesUpdateColumn = {}));
/** unique or primary key constraints on table "users" */
export var UsersConstraint;
(function (UsersConstraint) {
    /** unique or primary key constraint on columns "email", "auth0_tenant_name" */
    UsersConstraint["UsersEmailAuth0TenantNameKey"] = "users_email_auth0_tenant_name_key";
    /** unique or primary key constraint on columns "auth0_tenant_name", "phone_number" */
    UsersConstraint["UsersPhoneNumberAuth0TenantNameKey"] = "users_phone_number_auth0_tenant_name_key";
    /** unique or primary key constraint on columns "id" */
    UsersConstraint["UsersPkey"] = "users_pkey";
})(UsersConstraint || (UsersConstraint = {}));
/** select columns of table "users" */
export var UsersSelectColumn;
(function (UsersSelectColumn) {
    /** column name */
    UsersSelectColumn["Active"] = "active";
    /** column name */
    UsersSelectColumn["AppMetadata"] = "app_metadata";
    /** column name */
    UsersSelectColumn["Auth0TenantName"] = "auth0_tenant_name";
    /** column name */
    UsersSelectColumn["AvatarUrl"] = "avatar_url";
    /** column name */
    UsersSelectColumn["ConsentUpdated"] = "consent_updated";
    /** column name */
    UsersSelectColumn["CreatedAt"] = "created_at";
    /** column name */
    UsersSelectColumn["DeactivatedAt"] = "deactivated_at";
    /** column name */
    UsersSelectColumn["Email"] = "email";
    /** column name */
    UsersSelectColumn["EndDate"] = "end_date";
    /** column name */
    UsersSelectColumn["FacialBuildingConsent"] = "facial_building_consent";
    /** column name */
    UsersSelectColumn["FirstName"] = "first_name";
    /** column name */
    UsersSelectColumn["Id"] = "id";
    /** column name */
    UsersSelectColumn["LastLoggedIn"] = "last_logged_in";
    /** column name */
    UsersSelectColumn["LastName"] = "last_name";
    /** column name */
    UsersSelectColumn["NewsletterConsent"] = "newsletter_consent";
    /** column name */
    UsersSelectColumn["PhoneNumber"] = "phone_number";
    /** column name */
    UsersSelectColumn["Salutation"] = "salutation";
    /** column name */
    UsersSelectColumn["StartDate"] = "start_date";
    /** column name */
    UsersSelectColumn["UpdatedAt"] = "updated_at";
})(UsersSelectColumn || (UsersSelectColumn = {}));
/** update columns of table "users" */
export var UsersUpdateColumn;
(function (UsersUpdateColumn) {
    /** column name */
    UsersUpdateColumn["Active"] = "active";
    /** column name */
    UsersUpdateColumn["AppMetadata"] = "app_metadata";
    /** column name */
    UsersUpdateColumn["Auth0TenantName"] = "auth0_tenant_name";
    /** column name */
    UsersUpdateColumn["AvatarUrl"] = "avatar_url";
    /** column name */
    UsersUpdateColumn["ConsentUpdated"] = "consent_updated";
    /** column name */
    UsersUpdateColumn["CreatedAt"] = "created_at";
    /** column name */
    UsersUpdateColumn["DeactivatedAt"] = "deactivated_at";
    /** column name */
    UsersUpdateColumn["Email"] = "email";
    /** column name */
    UsersUpdateColumn["EndDate"] = "end_date";
    /** column name */
    UsersUpdateColumn["FacialBuildingConsent"] = "facial_building_consent";
    /** column name */
    UsersUpdateColumn["FirstName"] = "first_name";
    /** column name */
    UsersUpdateColumn["Id"] = "id";
    /** column name */
    UsersUpdateColumn["LastLoggedIn"] = "last_logged_in";
    /** column name */
    UsersUpdateColumn["LastName"] = "last_name";
    /** column name */
    UsersUpdateColumn["NewsletterConsent"] = "newsletter_consent";
    /** column name */
    UsersUpdateColumn["PhoneNumber"] = "phone_number";
    /** column name */
    UsersUpdateColumn["Salutation"] = "salutation";
    /** column name */
    UsersUpdateColumn["StartDate"] = "start_date";
    /** column name */
    UsersUpdateColumn["UpdatedAt"] = "updated_at";
})(UsersUpdateColumn || (UsersUpdateColumn = {}));
/** select columns of table "wednesday_operating_hours" */
export var WednesdayOperatingHoursSelectColumn;
(function (WednesdayOperatingHoursSelectColumn) {
    /** column name */
    WednesdayOperatingHoursSelectColumn["DayOfWeek"] = "day_of_week";
    /** column name */
    WednesdayOperatingHoursSelectColumn["HourEnd"] = "hour_end";
    /** column name */
    WednesdayOperatingHoursSelectColumn["HourStart"] = "hour_start";
    /** column name */
    WednesdayOperatingHoursSelectColumn["ModelId"] = "model_id";
})(WednesdayOperatingHoursSelectColumn || (WednesdayOperatingHoursSelectColumn = {}));
export const MediaSignedUrlFieldsFragmentDoc = gql `
    fragment MediaSignedUrlFields on SignedMediaUrlsOutput {
  filename
  resource_key
  mime_type
  get_url
  put_url
}
    `;
export const GetMediaSignedUrlsDocument = gql `
    mutation GetMediaSignedUrls($files: [SignedMediaUrlsInput!]!) {
  get_media_signed_urls(files: $files) {
    ...MediaSignedUrlFields
  }
}
    ${MediaSignedUrlFieldsFragmentDoc}`;
/**
 * __useGetMediaSignedUrlsMutation__
 *
 * To run a mutation, you first call `useGetMediaSignedUrlsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGetMediaSignedUrlsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [getMediaSignedUrlsMutation, { data, loading, error }] = useGetMediaSignedUrlsMutation({
 *   variables: {
 *      files: // value for 'files'
 *   },
 * });
 */
export function useGetMediaSignedUrlsMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(GetMediaSignedUrlsDocument, options);
}
export const ProtectedGetMediaSignedUrlsDocument = gql `
    mutation ProtectedGetMediaSignedUrls($files: [SignedMediaUrlsInput!]!) {
  protected_get_media_signed_urls(files: $files) {
    ...MediaSignedUrlFields
  }
}
    ${MediaSignedUrlFieldsFragmentDoc}`;
/**
 * __useProtectedGetMediaSignedUrlsMutation__
 *
 * To run a mutation, you first call `useProtectedGetMediaSignedUrlsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProtectedGetMediaSignedUrlsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [protectedGetMediaSignedUrlsMutation, { data, loading, error }] = useProtectedGetMediaSignedUrlsMutation({
 *   variables: {
 *      files: // value for 'files'
 *   },
 * });
 */
export function useProtectedGetMediaSignedUrlsMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(ProtectedGetMediaSignedUrlsDocument, options);
}
export const UserGroupConfigurationDocument = gql `
    query UserGroupConfiguration($id: uuid!) {
  user_groups_by_pk(id: $id) {
    user_group_configuration
  }
}
    `;
/**
 * __useUserGroupConfigurationQuery__
 *
 * To run a query within a React component, call `useUserGroupConfigurationQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserGroupConfigurationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserGroupConfigurationQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUserGroupConfigurationQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(UserGroupConfigurationDocument, options);
}
export function useUserGroupConfigurationLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(UserGroupConfigurationDocument, options);
}
export const OrganizationByGroupIdDocument = gql `
    query OrganizationByGroupId($groupId: uuid!) {
  flattened_user_group_users(where: {user_group_id: {_eq: $groupId}}) {
    user_group_id
    organization_id
  }
}
    `;
/**
 * __useOrganizationByGroupIdQuery__
 *
 * To run a query within a React component, call `useOrganizationByGroupIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganizationByGroupIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganizationByGroupIdQuery({
 *   variables: {
 *      groupId: // value for 'groupId'
 *   },
 * });
 */
export function useOrganizationByGroupIdQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(OrganizationByGroupIdDocument, options);
}
export function useOrganizationByGroupIdLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(OrganizationByGroupIdDocument, options);
}
export const OrganizationWithSubGroupDocument = gql `
    query OrganizationWithSubGroup($userId: uuid!, $groupId: uuid!) {
  flattened_user_group_users(
    where: {_and: [{user_id: {_eq: $userId}}, {organization_id: {_eq: $groupId}}]}
  ) {
    user_group_id
    organization_id
  }
}
    `;
/**
 * __useOrganizationWithSubGroupQuery__
 *
 * To run a query within a React component, call `useOrganizationWithSubGroupQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganizationWithSubGroupQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganizationWithSubGroupQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *      groupId: // value for 'groupId'
 *   },
 * });
 */
export function useOrganizationWithSubGroupQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(OrganizationWithSubGroupDocument, options);
}
export function useOrganizationWithSubGroupLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(OrganizationWithSubGroupDocument, options);
}
export const UserByIdForPermissionsDocument = gql `
    query UserByIdForPermissions($userId: uuid!) {
  users_by_pk(id: $userId) {
    id
    email
    flattened_user_group_user_permissions {
      user_group_id
      permission_id
    }
    flattened_user_group_users {
      user_group {
        user_group_configuration
      }
    }
  }
}
    `;
/**
 * __useUserByIdForPermissionsQuery__
 *
 * To run a query within a React component, call `useUserByIdForPermissionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserByIdForPermissionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserByIdForPermissionsQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useUserByIdForPermissionsQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(UserByIdForPermissionsDocument, options);
}
export function useUserByIdForPermissionsLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(UserByIdForPermissionsDocument, options);
}
export const UserGroupChildIdsByGroupIdDocument = gql `
    query UserGroupChildIdsByGroupId($groupIds: [uuid!]) {
  flattened_user_groups(where: {parent_id: {_in: $groupIds}}) {
    parent_id
    child_id
  }
}
    `;
/**
 * __useUserGroupChildIdsByGroupIdQuery__
 *
 * To run a query within a React component, call `useUserGroupChildIdsByGroupIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserGroupChildIdsByGroupIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserGroupChildIdsByGroupIdQuery({
 *   variables: {
 *      groupIds: // value for 'groupIds'
 *   },
 * });
 */
export function useUserGroupChildIdsByGroupIdQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(UserGroupChildIdsByGroupIdDocument, options);
}
export function useUserGroupChildIdsByGroupIdLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(UserGroupChildIdsByGroupIdDocument, options);
}
export const UserGroupParentIdsByGroupIdDocument = gql `
    query UserGroupParentIdsByGroupId($groupIds: [uuid!]) {
  flattened_user_groups(where: {child_id: {_in: $groupIds}}) {
    parent_id
    child_id
  }
}
    `;
/**
 * __useUserGroupParentIdsByGroupIdQuery__
 *
 * To run a query within a React component, call `useUserGroupParentIdsByGroupIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserGroupParentIdsByGroupIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserGroupParentIdsByGroupIdQuery({
 *   variables: {
 *      groupIds: // value for 'groupIds'
 *   },
 * });
 */
export function useUserGroupParentIdsByGroupIdQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(UserGroupParentIdsByGroupIdDocument, options);
}
export function useUserGroupParentIdsByGroupIdLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(UserGroupParentIdsByGroupIdDocument, options);
}
export const UserGroupSchemaDocument = gql `
    query UserGroupSchema($id: uuid!) {
  user_groups_by_pk(id: $id) {
    schema
    uischema
  }
}
    `;
/**
 * __useUserGroupSchemaQuery__
 *
 * To run a query within a React component, call `useUserGroupSchemaQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserGroupSchemaQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserGroupSchemaQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUserGroupSchemaQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(UserGroupSchemaDocument, options);
}
export function useUserGroupSchemaLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(UserGroupSchemaDocument, options);
}
export const UserGroupByIdBasicDocument = gql `
    query UserGroupByIdBasic($id: uuid!) {
  user_groups_by_pk(id: $id) {
    id
    name
    display_name
  }
}
    `;
/**
 * __useUserGroupByIdBasicQuery__
 *
 * To run a query within a React component, call `useUserGroupByIdBasicQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserGroupByIdBasicQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserGroupByIdBasicQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUserGroupByIdBasicQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(UserGroupByIdBasicDocument, options);
}
export function useUserGroupByIdBasicLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(UserGroupByIdBasicDocument, options);
}
//# sourceMappingURL=index.js.map